// import React, { useState, useEffect } from "react";
// import { Box, Typography, Paper, useTheme, useMediaQuery, Button, Snackbar, Alert, CircularProgress, TextField, Grid, Chip, Tabs, Tab, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, FormControlLabel, MenuItem, Select, FormControl, InputLabel, Accordion, AccordionSummary, AccordionDetails, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import CustomNoDataOverlay from "../components/CustomNoDataOverlay";
// import NoDataComponent from "../components/NoDataComponent";
// import SearchIcon from '@mui/icons-material/Search';
// import ClearAllIcon from '@mui/icons-material/ClearAll';
// import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import TrendingDownIcon from '@mui/icons-material/TrendingDown';
// import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
// import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
// import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import TuneIcon from '@mui/icons-material/Tune';
// import CloseIcon from '@mui/icons-material/Close';
// import ClearIcon from '@mui/icons-material/Clear';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { FB, FB_DARK, FB_LIGHT, FB_MID, SURFACE, BG, BORDER, T1, T2, RED_BG, RED_FG, GRN_BG, GRN_FG, G200, G300, G500, G700, G900, WHITE, CARD_SHADOW, CARD_HOVER, REPORT_TYPES, BOOK_NAMES, cardSx, btnOutlineSx, btnGhostSx, btnPrimarySx, inputSx, selectSx, dgSx, } from "./ReportDetailsConstants";
// import { StatCard, TabPanel, getBalanceColor, getBalanceBgColor, getFinancialYearDates, fmt, fmtDate, getAmountColumnLabels, } from "./LedgerDetailsHelpers";
// import SmartFilterDialog from "./SmartFilterLedgerDetails";

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function LedgerDetails({ connectionString, pdfString }) {
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down(500));
//     const { user, selectedCompany } = useAuth();

//     // ── View Mode State ──────────────────────────────────────────────────────
//     const [viewMode, setViewMode] = useState("filter"); // 'filter', 'detail'

//     // ── Filter Dialog State ──────────────────────────────────────────────────
//     const [filterOpen, setFilterOpen] = useState(false);
//     const [allClients, setAllClients] = useState([]);
//     const [tempClientSearchText, setTempClientSearchText] = useState("");
//     const [filteredTempClients, setFilteredTempClients] = useState([]);
//     const [tempSelectedClients, setTempSelectedClients] = useState([]);
//     const [appliedFilters, setAppliedFilters] = useState(null);

//     // ── NEW: Report Type State ───────────────────────────────────────────────
//     const [tempReportType, setTempReportType] = useState("general_ledger");
//     const [appliedReportType, setAppliedReportType] = useState("general_ledger");

//     // ── Bank Book States ──────────────────────────────────────────────────────
//     const [selectedBookNames, setSelectedBookNames] = useState([]);
//     const [selectedBankAccount, setSelectedBankAccount] = useState('');
//     const [bankAccounts, setBankAccounts] = useState([]);
//     const [bankAccountsLoading, setBankAccountsLoading] = useState(false);
//     const [bankBookData, setBankBookData] = useState(null);
//     const [isDaywise, setIsDaywise] = useState(false);

//     // ── Cash Book State ───────────────────────────────────────────────────────
//     const [cashBookData, setCashBookData] = useState(null);

//     // ── Day Book State ────────────────────────────────────────────────────────
//     const [dayBookData, setDayBookData] = useState(null);
//     const [dayBookView, setDayBookView] = useState("month"); // 'month' | 'day' | 'all'

//     // ── Groupwise Summary State ───────────────────────────────────────────────
//     const [groupwiseSummaryData, setGroupwiseSummaryData] = useState(null);
//     const [expandedSubGroups, setExpandedSubGroups] = useState({});
//     const [expandedClients, setExpandedClients] = useState({});
//     const [groupwisePage, setGroupwisePage] = useState("groups"); // "groups" | "clients" | "monthly" | "ledger"
//     const [selectedSubGroup, setSelectedSubGroup] = useState(null);
//     const [selectedClientForMonthly, setSelectedClientForMonthly] = useState(null);
//     const [selectedMonthForLedger, setSelectedMonthForLedger] = useState(null);
//     const [monthLedgerData, setMonthLedgerData] = useState(null);
//     const [monthLedgerLoading, setMonthLedgerLoading] = useState(false);

//     // ── Detail View State ────────────────────────────────────────────────────
//     const [selectedClients, setSelectedClients] = useState([]);
//     const [ledgerDataMap, setLedgerDataMap] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success", });
//     const [activeTab, setActiveTab] = useState(0);
//     const [dateFilters, setDateFilters] = useState({});

//     // ── Temp Filter Dialog State ─────────────────────────────────────────────
//     const getTodayDate = () => new Date().toISOString().split("T")[0];
//     const [tempFromDate, setTempFromDate] = useState(getTodayDate());
//     const [tempToDate, setTempToDate] = useState(getTodayDate());

//     const [pdfLoading, setPdfLoading] = useState(false);

//     const companyId = selectedCompany?.CompId;

//     // ── API: Fetch All Clients ───────────────────────────────────────────────
//     const fetchAllClients = async () => {
//         try {
//             const { fromDate: fyFromDate, toDate: fyToDate } = getFinancialYearDates();
//             const params = { compId: companyId, fromDate: fyFromDate, toDate: fyToDate, reportType: "with_parties", };
//             const res = await axios.get(`${connectionString}/api/getLedgerData`, { params });
//             console.log(res);
//             if (res.data && res.data.parties) {
//                 const sortedClients = res.data.parties.sort((a, b) =>
//                     a.FirmName.localeCompare(b.FirmName)
//                 );
//                 setAllClients(sortedClients);
//                 setFilteredTempClients(sortedClients);
//             }
//         } catch (err) {
//             console.error("Clients fetch error:", err);
//             setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch clients", severity: "error", });
//         }
//     };

//     // ── Fetch Bank Accounts ──────────────────────────────────────────────────
//     const fetchBankAccounts = async () => {
//         try {
//             setBankAccountsLoading(true);
//             const res = await axios.get(`${connectionString}/api/getBankAccounts`, {
//                 params: { companyId }
//             });
//             const accountsData = res.data?.data || res.data?.accounts || res.data || [];
//             const formattedAccounts = Array.isArray(accountsData)
//                 ? accountsData.map(account => ({
//                     id: account.id || account.AccountId || account.accountId,
//                     AccountName: account.accountName || account.AccountName || account.name || '',
//                     AccountNumber: account.AccountNumber || account.accountNumber || account.number || ''
//                 }))
//                 : [];
//             setBankAccounts(formattedAccounts);
//         } catch (err) {
//             console.error("Bank accounts fetch error:", err);
//             setBankAccounts([]);
//             setSnackbar({ open: true, message: "Failed to fetch bank accounts", severity: "error" });
//         } finally {
//             setBankAccountsLoading(false);
//         }
//     };

//     // ── Fetch Bank Book Statement ────────────────────────────────────────────
//     const fetchBankBookStatement = async (bankAccountName, fromDateVal, toDateVal) => {
//         const res = await axios.get(`${connectionString}/api/bankbook-statement`, {
//             params: { bankAc: bankAccountName, fromDate: fromDateVal, toDate: toDateVal, compId: companyId, bookNames: selectedBookNames.join(","), },
//         });
//         return res.data;
//     };

//     // ── Fetch Cash Book Statement (NEW) ──────────────────────────────────────
//     const fetchCashBookStatement = async (fromDateVal, toDateVal) => {
//         const res = await axios.get(`${connectionString}/api/cashbook-statement`, {
//             params: { compId: companyId, fromDate: fromDateVal, toDate: toDateVal, bookNames: selectedBookNames.join(","), },
//         });
//         return res.data;
//     };

//     // ── Fetch Groupwise Summary ───────────────────────────────────────────────
//     const fetchGroupwiseSummary = async (fromDateVal, toDateVal) => {
//         const res = await axios.get(`${connectionString}/api/LedgerGroupwisesummary`, {
//             params: { companyId: companyId, fromDate: fromDateVal, toDate: toDateVal, },
//         });
//         console.log(res);
//         return res.data;
//     };

//     // ── Fetch Client Monthly Closing ──────────────────────────────────────────
//     const fetchClientMonthlyClosing = async (clientId) => {
//         setExpandedClients((prev) => ({
//             ...prev,
//             [clientId]: { loading: true, months: prev[clientId]?.months || [] },
//         }));
//         try {
//             const res = await axios.get(`${connectionString}/api/LedgerClientMonthlyClosing`, {
//                 params: {
//                     clientId,
//                     companyId,
//                     fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
//                     toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
//                 },
//             });
//             console.log(res);
//             setExpandedClients((prev) => ({
//                 ...prev,
//                 [clientId]: { loading: false, months: res.data?.data || [] },
//             }));
//         } catch (err) {
//             console.error("Monthly closing fetch error:", err);
//             setExpandedClients((prev) => ({
//                 ...prev,
//                 [clientId]: { loading: false, months: [] },
//             }));
//         }
//     };

//     // ── Fetch Month Ledger (Groupwise drill-down) ─────────────────────────────
//     const fetchMonthLedger = async (clientId, fromDate, toDate) => {
//         setMonthLedgerLoading(true);
//         setMonthLedgerData(null);
//         try {
//             const params = { compId: companyId, partyId: clientId, fromDate, toDate };
//             const res = await axios.get(`${connectionString}/api/getLedgerData`, { params });
//             if (res.data) {
//                 const detailsData = (res.data.details || []).map((item) => ({
//                     id: item.gLId,
//                     docDate: item.docDate,
//                     docNo: item.docNo,
//                     bookName: item.bookName,
//                     salePurchaseAC: item.salePurchaseAC || "—",
//                     debit: item.debit,
//                     credit: item.credit,
//                     remark: item.remark,
//                     balance: item.runningBalance,
//                     balanceType: item.balanceType,
//                 }));
//                 setMonthLedgerData({
//                     openingBalance: res.data.openingBalance || {},
//                     closingBalance: res.data.closingBalance || {},
//                     details: detailsData,
//                     summary: res.data.summary || {},
//                 });
//             }
//         } catch (err) {
//             console.error("Month ledger fetch error:", err);
//             setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
//             setMonthLedgerData(null);
//         } finally {
//             setMonthLedgerLoading(false);
//         }
//     };

//     // ── Fetch Day Book Statement ──────────────────────────────────────────────
//     const fetchDayBookStatement = async (fromDateVal, toDateVal) => {
//         const res = await axios.get(`${connectionString}/api/daybook-statement`, {
//             params: {
//                 compId: companyId,
//                 fromDate: fromDateVal,
//                 toDate: toDateVal,
//                 bookNames: selectedBookNames.join(","),
//             },
//         });
//         console.log(res)
//         return res.data;
//     };

//     // ─── Direct PDF Export Handler ────────────────────────────────────────────
//     const handleExportPDF = async () => {
//         // When called from Groupwise Summary ledger stage, delegate to the dedicated handler
//         if (groupwisePage === "ledger" && monthLedgerData && selectedClientForMonthly) {
//             return handleExportMonthLedgerPDF();
//         }
//         try {
//             setPdfLoading(true);
//             let allEntries = [];
//             let totalClientDebit = 0;
//             let totalClientCredit = 0;
//             let clientSummaries = [];

//             const printDate = new Date().toISOString().split("T")[0];

//             selectedClients.forEach((client) => {
//                 const clientData = ledgerDataMap[client.id];

//                 if (clientData && clientData.details) {
//                     const clientDebit = clientData.details.reduce(
//                         (sum, item) => sum + Number(item.debit || 0),
//                         0
//                     );

//                     const clientCredit = clientData.details.reduce(
//                         (sum, item) => sum + Number(item.credit || 0),
//                         0
//                     );

//                     const opValue = Number(clientData.openingBalance?.absValue || 0);
//                     const opType = clientData.openingBalance?.type || "Dr";
//                     const opbalEntry = {
//                         clientName: client.FirmName,
//                         clientCode: client.ClientCode,
//                         date: dateFilters[client.id]?.fromDate || "—",
//                         particulars: "OPBAL",
//                         remark: "",
//                         BookName: "OPBAL",
//                         salePurchaseAC: "—",
//                         DocNo: "—",
//                         debit: opType === "Dr" ? opValue : 0,
//                         credit: opType === "Cr" ? opValue : 0,
//                         balance: opValue,
//                         balanceType: opType,
//                         clientTotalDebit: clientDebit,
//                         clientTotalCredit: clientCredit,
//                         srNo: 0,
//                         isOpeningRow: true,
//                     };

//                     const clientEntries = [opbalEntry, ...clientData.details.map((r, idx) => ({
//                         clientName: client.FirmName,
//                         clientCode: client.ClientCode,
//                         date: r.docDate,
//                         particulars: r.bookName || "",
//                         remark: r.remark || "",
//                         BookName: r.bookName || "",
//                         salePurchaseAC: r.salePurchaseAC || "—",
//                         DocNo: r.docNo || "",
//                         debit: Number(r.debit || 0),
//                         credit: Number(r.credit || 0),
//                         balance: r.balance,
//                         balanceType: r.balanceType,
//                         clientTotalDebit: clientDebit,
//                         clientTotalCredit: clientCredit,
//                         srNo: idx + 1,
//                     }))];

//                     allEntries = [...allEntries, ...clientEntries];
//                     totalClientDebit += clientDebit;
//                     totalClientCredit += clientCredit;

//                     clientSummaries.push({
//                         firmName: client.FirmName,
//                         clientCode: client.ClientCode,
//                         openingBalance: clientData.openingBalance.opBal || 0,
//                         openingType: clientData.openingBalance.type || "Dr",
//                         closingBalance: clientData.closingBalance.closingBal || 0,
//                         closingType: clientData.closingBalance.type || "Dr",
//                         totalDebit: clientDebit,
//                         totalCredit: clientCredit,
//                         entries: clientData.details.length,
//                     });
//                 }
//             });

//             const pdfResp = await axios.post(
//                 `${pdfString}/api/ledger-pdf/general-ledger`,
//                 {
//                     docId: "general-ledger",
//                     userId: user?.UserId || "usr1",
//                     data: {
//                         reportType: "General Ledger",
//                         accountName: `General Ledger - ${selectedClients.length} Clients`,
//                         fromDate: dateFilters[selectedClients[0].id]?.fromDate || getFinancialYearDates().fromDate,
//                         toDate: dateFilters[selectedClients[0].id]?.toDate || getFinancialYearDates().toDate,
//                         printDate,
//                         entries: allEntries,
//                         clientSummaries: clientSummaries,
//                         totalDebit: totalClientDebit,
//                         totalCredit: totalClientCredit,
//                         totalClients: selectedClients.length,
//                     },
//                     company: selectedCompany
//                         ? {
//                             CompId: selectedCompany.CompId,
//                             CompanyName: selectedCompany.CompanyName || "",
//                             Address: selectedCompany.Address || "",
//                             MobileNo: selectedCompany.MobileNo || "",
//                             GSTIN: selectedCompany.GSTNo || "",
//                         }
//                         : {},
//                 },
//                 { responseType: "blob" }
//             );

//             const w = window.open(
//                 URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" })),
//                 "_blank"
//             );
//             if (w) w.focus();
//         } catch (err) {
//             console.error("PDF Error:", err);
//             setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     // ✅ NEW FUNCTION - BankBook PDF Export Handler
//     const handleExportBankBookPDF = async () => {
//         try {
//             setPdfLoading(true);

//             const account = bankAccounts.find((a) => a.id === selectedBankAccount);

//             if (!account) {
//                 setSnackbar({
//                     open: true,
//                     message: "Bank account not found",
//                     severity: "error"
//                 });
//                 return;
//             }

//             const printDate = new Date().toISOString().split("T")[0];

//             // ── Map details to a clean, consistent format for PDF ──────────────
//             const mappedEntries = (bankBookData?.details || []).map((row) => ({
//                 clientName: account.AccountName,
//                 date: row.docDate || row.DocDate || "—",
//                 salePurchaseAC: row.salePurchaseAC || row.AccName || "—",
//                 DocNo: row.docNo || "",
//                 BookName: row.bookName || row.BookName || "—",
//                 debit: Number(row.debit || row.Debit || 0),
//                 credit: Number(row.credit || row.Credit || 0),
//                 remark: row.remark || row.Remark || "",
//                 balance: Number(row.balance || row.RunningBalance || 0),
//                 balanceType: row.balanceType || row.BalanceType || "Dr",
//             }));

//             const pdfResp = await axios.post(
//                 `${pdfString}/api/ledger-pdf/bank-book`,
//                 {
//                     docId: "bank-book",
//                     userId: user?.UserId || "usr1",
//                     data: {
//                         reportType: "Bank Book",
//                         bankAccountName: account.AccountName,
//                         bankAccountNo: account.AccountNumber || "",
//                         fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
//                         toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
//                         printDate,
//                         openingBalance: bankBookData?.openingBalance?.opBal || 0,
//                         openingType: bankBookData?.openingBalance?.type || "Dr",
//                         closingBalance: bankBookData?.closingBalance?.closingBal || 0,
//                         closingType: bankBookData?.closingBalance?.type || "Dr",
//                         totalDebit: bankBookData?.summary?.totalDebit || 0,
//                         totalCredit: bankBookData?.summary?.totalCredit || 0,
//                         totalRecords: bankBookData?.summary?.totalRecords || mappedEntries.length,
//                         entries: mappedEntries,
//                         isDaywise: isDaywise,
//                         summary: bankBookData?.summary || {},
//                     },
//                     company: selectedCompany
//                         ? {
//                             CompId: selectedCompany.CompId,
//                             CompanyName: selectedCompany.CompanyName || "",
//                             Address: selectedCompany.Address || "",
//                             MobileNo: selectedCompany.MobileNo || "",
//                             GSTIN: selectedCompany.GSTNo || "",
//                         }
//                         : {},
//                 },
//                 { responseType: "blob" }
//             );

//             const url = URL.createObjectURL(
//                 new Blob([pdfResp.data], { type: "application/pdf" })
//             );
//             const w = window.open(url, "_blank");
//             if (w) w.focus();

//         } catch (err) {
//             console.error("BankBook PDF Error:", err);
//             setSnackbar({
//                 open: true,
//                 message: "Failed to generate bank book PDF",
//                 severity: "error"
//             });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     const handleExportCashBookPDF = async () => {
//         try {
//             setPdfLoading(true);

//             const printDate = new Date().toISOString().split("T")[0];

//             const activeClient = cashBookData?.clients?.[activeTab];
//             const activeClientName = activeClient?.clientInfo?.FirmName || "Cash Book";

//             const mappedEntries = (cashBookData?.details || []).map((row) => ({
//                 clientName: activeClientName,  // ← CHANGED: use actual client name
//                 date: row.docDate || "—",
//                 salePurchaseAC: row.salePurchaseAC || "—",
//                 DocNo: row.docNo || "",
//                 BookName: row.bookName || "—",
//                 debit: Number(row.debit || 0),
//                 credit: Number(row.credit || 0),
//                 remark: row.remark || "",
//                 balance: Number(row.balance || 0),
//                 balanceType: row.balanceType || "Dr",
//             }));

//             const pdfResp = await axios.post(
//                 `${pdfString}/api/ledger-pdf/bank-book`,
//                 {
//                     docId: "bank-book",
//                     userId: user?.UserId || "usr1",
//                     data: {
//                         reportType: "Cash Book",
//                         bankAccountName: "Cash Book",
//                         bankAccountNo: "",
//                         fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
//                         toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
//                         printDate,
//                         openingBalance: cashBookData?.clients?.[activeTab]?.openingBalance?.opBal || 0,
//                         openingType: cashBookData?.clients?.[activeTab]?.openingBalance?.type || "Dr",
//                         closingBalance: cashBookData?.clients?.[activeTab]?.closingBalance?.closingBal || 0,
//                         closingType: cashBookData?.clients?.[activeTab]?.closingBalance?.type || "Dr",
//                         totalDebit: cashBookData?.clients?.[activeTab]?.summary?.totalDebit || 0,
//                         totalCredit: cashBookData?.clients?.[activeTab]?.summary?.totalCredit || 0,
//                         totalRecords: mappedEntries.length,
//                         entries: mappedEntries,
//                         isDaywise: isDaywise,
//                         summary: cashBookData?.clients?.[activeTab]?.summary || {},
//                     },
//                     company: selectedCompany
//                         ? {
//                             CompId: selectedCompany.CompId,
//                             CompanyName: selectedCompany.CompanyName || "",
//                             Address: selectedCompany.Address || "",
//                             MobileNo: selectedCompany.MobileNo || "",
//                             GSTIN: selectedCompany.GSTNo || "",
//                         }
//                         : {},
//                 },
//                 { responseType: "blob" }
//             );

//             const url = URL.createObjectURL(
//                 new Blob([pdfResp.data], { type: "application/pdf" })
//             );
//             const w = window.open(url, "_blank");
//             if (w) w.focus();

//         } catch (err) {
//             console.error("CashBook PDF Error:", err);
//             setSnackbar({
//                 open: true,
//                 message: "Failed to generate cash book PDF",
//                 severity: "error"
//             });
//         } finally {
//             setPdfLoading(false);
//         }
//     };



//     const handleExportDayBookPDF = async () => {

//         try {
//             setPdfLoading(true);

//             const printDate =
//                 new Date().toISOString().split("T")[0];

//             // ✅ DATE NORMALIZER

//             const normalizeDate = (inputDate) => {
//                 if (!inputDate) { return "—"; }

//                 const raw = String(inputDate).trim();

//                 if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
//                     const [y, m, d] = raw.split("-");
//                     return `${d}-${m}-${y}`;
//                 }

//                 if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) {
//                     return raw;
//                 }

//                 if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {

//                     return raw.replace(/\//g, "-");
//                 }

//                 const dt = new Date(raw);

//                 if (!isNaN(dt.getTime())) {

//                     const d = String(dt.getDate()).padStart(2, "0");
//                     const m = String(dt.getMonth() + 1).padStart(2, "0");
//                     const y = dt.getFullYear();

//                     return `${d}-${m}-${y}`;
//                 }

//                 return raw;
//             };

//             // ✅ NORMALIZE ROWS

//             const mapRows = (rows, type) =>

//                 (rows || []).map((row) => ({
//                     partyName: row.partyName || row.PartyName || "—",
//                     date: normalizeDate(row.docDate || row.DocDate || row.date || ""),
//                     salePurchaseAC: row.salePurchaseAC || row.AccName || "—",
//                     DocNo: row.docNo || row.DocNo || "",
//                     BookName: row.bookName || row.BookName || "—",
//                     debit: Number(row.debit || row.Debit || 0),
//                     credit: Number(row.credit || row.Credit || 0),
//                     remark: row.remark || row.Remark || "",
//                     type,
//                 }));

//             // ✅ RAW ROWS

//             const incomeRows = mapRows(dayBookData?.incomeRows, "income");
//             const expenseRows = mapRows(dayBookData?.expenseRows, "expense");

//             // ✅ UNIQUE DATES

//             const allDates = [
//                 ...new Set([
//                     ...incomeRows.map(r => r.date),
//                     ...expenseRows.map(r => r.date),
//                 ])
//             ].sort((a, b) => {

//                 const [da, ma, ya] = a.split(/[-\/]/).map(Number);
//                 const [db, mb, yb] = b.split(/[-\/]/).map(Number);

//                 return (new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db));
//             });

//             // ✅ GROUP DATE WISE

//             // ✅ GROUP DATE WISE
//             const groupedEntries = allDates.map((date) => {

//                 const incomeEntries = incomeRows.filter(r => r.date === date);
//                 const expenseEntries = expenseRows.filter(r => r.date === date);

//                 // Calculate income total: check both debit and credit, take whichever has value
//                 const incomeTotal = incomeEntries.reduce((s, r) => {
//                     const val = Number(r.debit || 0) > 0 ? Number(r.debit || 0) : Number(r.credit || 0);
//                     return s + val;
//                 }, 0);

//                 // Calculate expense total: check both credit and debit, take whichever has value
//                 const expenseTotal = expenseEntries.reduce((s, r) => {
//                     const val = Number(r.credit || 0) > 0 ? Number(r.credit || 0) : Number(r.debit || 0);
//                     return s + val;
//                 }, 0);

//                 return { date, incomeEntries, expenseEntries, incomeTotal, expenseTotal, };
//             });

//             const payload = {
//                 docId: "day-book",
//                 userId: user?.UserId || "usr1",
//                 data: {
//                     reportType: "Day Book",
//                     fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
//                     toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
//                     printDate,
//                     groupedEntries,
//                     totalIncome: groupedEntries.reduce((s, g) => s + g.incomeTotal, 0),
//                     totalExpense: groupedEntries.reduce((s, g) => s + g.expenseTotal, 0),
//                     totalExpenseRecords: dayBookData?.expenseSummary?.totalRecords || 0,
//                     totalIncomeRecords: dayBookData?.incomeSummary?.totalRecords || 0,
//                     expenseSummary: dayBookData?.expenseSummary || {},
//                     incomeSummary: dayBookData?.incomeSummary || {},
//                 },

//                 company: selectedCompany
//                     ? {
//                         CompId: selectedCompany.CompId,
//                         CompanyName: selectedCompany.CompanyName || "",
//                         Address: selectedCompany.Address || "",
//                         MobileNo: selectedCompany.MobileNo || "",
//                         GSTIN: selectedCompany.GSTNo || "",
//                     }
//                     : {},
//             };

//             // ✅ PRINT COMPLETE PAYLOAD
//             console.log("DAY BOOK PDF PAYLOAD =>", payload);
//             const pdfResp = await axios.post(`${pdfString}/api/ledger-pdf/day-book`, payload, { responseType: "blob" });

//             const url = URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" }));

//             const w = window.open(url, "_blank");
//             if (w) { w.focus(); }
//         } catch (err) {
//             console.error("DayBook PDF Error:", err);
//             setSnackbar({ open: true, message: "Failed to generate day book PDF", severity: "error", });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     // ── Shared PDF open helper ────────────────────────────────────────────────
//     const openPdfBlob = (blob) => {
//         const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
//         const w = window.open(url, "_blank");
//         if (w) w.focus();
//     };

//     const companyPayload = selectedCompany
//         ? { CompId: selectedCompany.CompId, CompanyName: selectedCompany.CompanyName || "", Address: selectedCompany.Address || "", MobileNo: selectedCompany.MobileNo || "", GSTIN: selectedCompany.GSTNo || "" }
//         : {};

//     // ── Level 1: Groupwise Summary PDF (all groups) ───────────────────────────
//     const handleExportGroupwiseSummaryPDF = async () => {
//         try {
//             setPdfLoading(true);
//             const printDate = new Date().toISOString().split("T")[0];

//             // Build groups in the format expected by renderGroupwiseSummaryPages
//             let srCounter = 0;
//             const pdfGroups = Object.values(groupwiseSummaryData || {}).map((grp) => {
//                 const subGroups = Object.values(grp.subGroups || {}).map((sg) => {
//                     srCounter++;
//                     const bal = (sg.clients || []).reduce((s, c) => s + Number(c.balance || 0), 0);
//                     return {
//                         srNo: srCounter,
//                         name: sg.subGroupName || "",
//                         balance: Math.abs(bal),
//                         balanceType: bal >= 0 ? "Cr" : "Dr",
//                     };
//                 });
//                 const grpBal = subGroups.reduce((s, sg) => s + (sg.balanceType === "Dr" ? sg.balance : -sg.balance), 0);
//                 return {
//                     groupName: grp.groupName || "",
//                     subGroupCount: subGroups.length,
//                     balance: Math.abs(grpBal),
//                     balanceType: grpBal >= 0 ? "Cr" : "Dr",
//                     subGroups,
//                 };
//             });

//             const grandBalRaw = Object.values(groupwiseSummaryData || {}).reduce((s, grp) =>
//                 s + Object.values(grp.subGroups || {}).reduce((ss, sg) =>
//                     ss + (sg.clients || []).reduce((sss, c) => sss + Number(c.balance || 0), 0), 0), 0);

//             const pdfGrandTotal = {
//                 balance: Math.abs(grandBalRaw),
//                 balanceType: grandBalRaw >= 0 ? "Cr" : "Dr",
//                 groupCount: pdfGroups.length,
//                 subGroupCount: srCounter,
//             };

//             const pdfResp = await axios.post(
//                 `${pdfString}/api/ledger-pdf/groupwise-summary`,
//                 {
//                     docId: "groupwise-summary",
//                     userId: user?.UserId || "usr1",
//                     data: {
//                         reportType: "Groupwise Summary",
//                         fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
//                         toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
//                         printDate,
//                         groups: pdfGroups,
//                         grandTotal: pdfGrandTotal,
//                     },
//                     company: companyPayload,
//                 },
//                 { responseType: "blob" }
//             );
//             openPdfBlob(pdfResp.data);
//         } catch (err) {
//             console.error("GroupwiseSummary PDF Error:", err);
//             setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     // ── Level 2: Sub-group clients PDF ────────────────────────────────────────
//     const handleExportClientsPagePDF = async () => {
//         if (!selectedSubGroup) return;
//         try {
//             setPdfLoading(true);
//             const printDate = new Date().toISOString().split("T")[0];
//             const pdfGroups = [{
//                 groupName: selectedSubGroup.groupName,
//                 clientCount: selectedSubGroup.clients.length,
//                 totalBalance: Math.abs(selectedSubGroup.totalBalance),
//                 balanceType: selectedSubGroup.totalBalance >= 0 ? "Dr" : "Cr",
//                 subGroups: [{
//                     subGroupName: selectedSubGroup.subGrpName,
//                     clients: selectedSubGroup.clients.map((c) => ({
//                         name: c.clientName || "",
//                         balance: Math.abs(Number(c.balance || 0)),
//                         balanceType: Number(c.balance || 0) >= 0 ? "Dr" : "Cr",
//                     })),
//                 }],
//             }];
//             const pdfResp = await axios.post(
//                 `${pdfString}/api/ledger-pdf/groupwise-summary-client`,
//                 {
//                     docId: "groupwise-summary-client",
//                     userId: user?.UserId || "usr1",
//                     data: {
//                         reportTitle: `${selectedSubGroup.groupName} — ${selectedSubGroup.subGrpName}`,
//                         fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
//                         toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
//                         printDate,
//                         groups: pdfGroups,
//                     },
//                     company: companyPayload,
//                 },
//                 { responseType: "blob" }
//             );
//             openPdfBlob(pdfResp.data);
//         } catch (err) {
//             console.error("Clients PDF Error:", err);
//             setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     // ── Level 3: Client monthly closing PDF ───────────────────────────────────
//     const handleExportMonthlyPagePDF = async () => {
//         if (!selectedClientForMonthly) return;
//         const cState = expandedClients[selectedClientForMonthly.clientId];
//         const months = cState?.months || [];
//         if (!months.length) return;
//         try {
//             setPdfLoading(true);
//             const printDate = new Date().toISOString().split("T")[0];

//             const totalDebit  = months.reduce((s, m) => s + Number(m.TotalDebit  || 0), 0);
//             const totalCredit = months.reduce((s, m) => s + Number(m.TotalCredit || 0), 0);
//             const closingBal  = Number(selectedClientForMonthly.balance || 0);

//             const pdfGroups = [{
//                 groupName:    selectedSubGroup?.groupName || "",
//                 totalBalance: Math.abs(closingBal),
//                 balanceType:  closingBal >= 0 ? "Dr" : "Cr",
//                 subGroups: [{
//                     subGroupName: selectedSubGroup?.subGrpName || "",
//                     clients: [{
//                         name: selectedClientForMonthly.clientName || "",
//                         months: months.map((m) => ({
//                             month:       `${m.MonthName} ${m.Month?.split("-")[0]}`,
//                             debit:       Number(m.TotalDebit  || 0),
//                             credit:      Number(m.TotalCredit || 0),
//                             closing:     Math.abs(Number(m.ClosingBalance || 0)),
//                             closingType: Number(m.ClosingBalance || 0) >= 0 ? "Dr" : "Cr",
//                         })),
//                         total: {
//                             monthCount:  months.length,
//                             debit:       totalDebit,
//                             credit:      totalCredit,
//                             closing:     Math.abs(closingBal),
//                             closingType: closingBal >= 0 ? "Dr" : "Cr",
//                         },
//                     }],
//                 }],
//             }];

//             const pdfResp = await axios.post(
//                 `${pdfString}/api/ledger-pdf/groupwise-summary-month`,
//                 {
//                     docId: "groupwise-summary-month",
//                     userId: user?.UserId || "usr1",
//                     data: {
//                         reportTitle: `${selectedClientForMonthly.clientName} — Monthly Closing`,
//                         fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
//                         toDate:   appliedFilters?.toDate   || getFinancialYearDates().toDate,
//                         printDate,
//                         groups: pdfGroups,
//                     },
//                     company: companyPayload,
//                 },
//                 { responseType: "blob" }
//             );
//             openPdfBlob(pdfResp.data);
//         } catch (err) {
//             console.error("Monthly PDF Error:", err);
//             setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     // ── Level 4: Month ledger PDF (reuses general-ledger endpoint) ────────────
//     const handleExportMonthLedgerPDF = async () => {
//         if (!monthLedgerData || !selectedClientForMonthly) return;
//         try {
//             setPdfLoading(true);
//             const printDate = new Date().toISOString().split("T")[0];
//             const clientDebit = (monthLedgerData.details || []).reduce((s, r) => s + Number(r.debit || 0), 0);
//             const clientCredit = (monthLedgerData.details || []).reduce((s, r) => s + Number(r.credit || 0), 0);
//             const opValue = Number(monthLedgerData.openingBalance?.absValue || 0);
//             const opType = monthLedgerData.openingBalance?.type || "Dr";
//             const opbalEntry = {
//                 clientName: selectedClientForMonthly.clientName,
//                 clientCode: "",
//                 date: selectedMonthForLedger?.fromDate || "—",
//                 particulars: "OPBAL",
//                 remark: "",
//                 BookName: "OPBAL",
//                 salePurchaseAC: "—",
//                 DocNo: "—",
//                 debit: opType === "Dr" ? opValue : 0,
//                 credit: opType === "Cr" ? opValue : 0,
//                 balance: opValue,
//                 balanceType: opType,
//                 clientTotalDebit: clientDebit,
//                 clientTotalCredit: clientCredit,
//                 srNo: 0,
//                 isOpeningRow: true,
//             };
//             const entries = [opbalEntry, ...(monthLedgerData.details || []).map((r, idx) => ({
//                 clientName: selectedClientForMonthly.clientName,
//                 clientCode: "",
//                 date: r.docDate,
//                 particulars: r.bookName || "",
//                 remark: r.remark || "",
//                 BookName: r.bookName || "",
//                 salePurchaseAC: r.salePurchaseAC || "—",
//                 DocNo: r.docNo || "",
//                 debit: Number(r.debit || 0),
//                 credit: Number(r.credit || 0),
//                 balance: r.balance,
//                 balanceType: r.balanceType,
//                 clientTotalDebit: clientDebit,
//                 clientTotalCredit: clientCredit,
//                 srNo: idx + 1,
//             }))];
//             const pdfResp = await axios.post(
//                 `${pdfString}/api/ledger-pdf/general-ledger`,
//                 {
//                     docId: "general-ledger",
//                     userId: user?.UserId || "usr1",
//                     data: {
//                         reportType: "General Ledger",
//                         accountName: `${selectedClientForMonthly.clientName} — ${selectedMonthForLedger?.MonthName} ${selectedMonthForLedger?.Month?.split("-")[0]}`,
//                         fromDate: selectedMonthForLedger?.fromDate || getFinancialYearDates().fromDate,
//                         toDate: selectedMonthForLedger?.toDate || getFinancialYearDates().toDate,
//                         printDate,
//                         entries,
//                         clientSummaries: [{
//                             firmName: selectedClientForMonthly.clientName,
//                             clientCode: "",
//                             openingBalance: monthLedgerData.openingBalance?.opBal || 0,
//                             openingType: monthLedgerData.openingBalance?.type || "Dr",
//                             closingBalance: monthLedgerData.closingBalance?.closingBal || 0,
//                             closingType: monthLedgerData.closingBalance?.type || "Dr",
//                             totalDebit: clientDebit,
//                             totalCredit: clientCredit,
//                             entries: monthLedgerData.details?.length || 0,
//                         }],
//                         totalDebit: clientDebit,
//                         totalCredit: clientCredit,
//                         totalClients: 1,
//                     },
//                     company: companyPayload,
//                 },
//                 { responseType: "blob" }
//             );
//             openPdfBlob(pdfResp.data);
//         } catch (err) {
//             console.error("Month Ledger PDF Error:", err);
//             setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
//         } finally {
//             setPdfLoading(false);
//         }
//     };

//     // ── Client Search/Filter Handler ─────────────────────────────────────────
//     const handleTempClientSearch = (searchText) => {
//         setTempClientSearchText(searchText);
//         if (searchText.trim() === "") {
//             setFilteredTempClients(allClients);
//         } else {
//             const filtered = allClients.filter(
//                 (client) =>
//                     (client.FirmName && client.FirmName.toLowerCase().includes(searchText.toLowerCase())) ||
//                     (client.ClientCode && client.ClientCode.toLowerCase().includes(searchText.toLowerCase())) ||
//                     (client.ContactPerson && client.ContactPerson.toLowerCase().includes(searchText.toLowerCase()))
//             );
//             setFilteredTempClients(filtered);
//         }
//     };

//     // ── Checkbox Change Handler ──────────────────────────────────────────────
//     const handleTempClientCheckbox = (client) => {
//         setTempSelectedClients((prevSelected) => {
//             const isSelected = prevSelected.some((c) => c.id === client.id);
//             if (isSelected) {
//                 return prevSelected.filter((c) => c.id !== client.id);
//             } else {
//                 return [...prevSelected, client];
//             }
//         });
//     };

//     // ── Fetch Party Detail ───────────────────────────────────────────────────
//     const fetchPartyDetail = async (partyId, fromDateVal, toDateVal) => {
//         try {
//             const params = { compId: companyId, partyId: partyId, fromDate: fromDateVal, toDate: toDateVal, bookNames: selectedBookNames.join(","), };
//             const res = await axios.get(`${connectionString}/api/getLedgerData`, { params });
//             console.log("data:", res);
//             if (res.data) {
//                 const detailsData = (res.data.details || []).map((item) => ({
//                     id: item.gLId,
//                     docDate: item.docDate,
//                     docNo: item.docNo,
//                     bookName: item.bookName,
//                     salePurchaseAC: item.salePurchaseAC || "—",
//                     debit: item.debit,
//                     credit: item.credit,
//                     remark: item.remark,
//                     balance: item.runningBalance,
//                     balanceType: item.balanceType,
//                 }));
//                 setLedgerDataMap((prev) => ({
//                     ...prev,
//                     [partyId]: {
//                         openingBalance: res.data.openingBalance || {},
//                         closingBalance: res.data.closingBalance || {},
//                         details: detailsData,
//                         summary: res.data.summary || {},
//                     },
//                 }));
//                 setDateFilters((prev) => ({
//                     ...prev,
//                     [partyId]: prev[partyId] || {
//                         fromDate: fromDateVal,
//                         toDate: toDateVal,
//                     },
//                 }));
//             }
//         } catch (err) {
//             console.error("Party detail fetch error:", err);
//             setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch party details", severity: "error", });
//         }
//     };

//     // ── View Selected Ledgers Handler ────────────────────────────────────────
//     const handleViewSelectedLedgers = async () => {
//         // For General Ledger: require at least one client
//         if (tempReportType === "general_ledger" && tempSelectedClients.length === 0) {
//             setSnackbar({ open: true, message: "Please select at least one client", severity: "warning" });
//             return;
//         }

//         try {
//             setLoading(true);

//             if (tempReportType === "general_ledger") {
//                 const promises = tempSelectedClients.map((client) =>
//                     fetchPartyDetail(client.id, tempFromDate, tempToDate)
//                 );
//                 await Promise.all(promises);
//                 setSelectedClients(tempSelectedClients);

//             } else if (tempReportType === "bank_book") {
//                 const account = bankAccounts.find((a) => a.id === selectedBankAccount);

//                 if (!account) {
//                     setSnackbar({ open: true, message: "Selected bank account not found", severity: "error" });
//                     return;
//                 }

//                 const data = await fetchBankBookStatement(account.AccountName, tempFromDate, tempToDate);

//                 const formattedBankBookData = {
//                     ...data,
//                     details: [
//                         // ─── Opening Balance Row ─────────────────────
//                         {
//                             id: "opbal-row",
//                             docDate: tempFromDate,
//                             salePurchaseAC: "Opening Balance",
//                             docNo: "-",
//                             bookName: "OPBAL",
//                             debit: data.openingBalance?.type === "Dr" ? Number(data.openingBalance?.absValue || 0) : 0,
//                             credit: data.openingBalance?.type === "Cr" ? Number(data.openingBalance?.absValue || 0) : 0,
//                             remark: `Opening Balance Before ${tempFromDate}`,
//                             balance: Number(data.openingBalance?.absValue || 0),
//                             balanceType: data.openingBalance?.type || "Dr",
//                         },

//                         // ─── Actual Transactions ─────────────────────
//                         ...(data.data || []).map((item, index) => ({
//                             id: item.gLId || index,
//                             docDate: item.DocDate,
//                             salePurchaseAC: item.AccName || "—",
//                             docNo: item.DocNo,
//                             bookName: item.BookName,
//                             debit: item.Debit || 0,
//                             credit: item.Credit || 0,
//                             remark: item.Remark || "",
//                             balance: item.RunningBalance || 0,
//                             balanceType: item.BalanceType || "Dr",
//                         })),
//                     ],
//                 };

//                 setBankBookData(formattedBankBookData);
//             } else if (tempReportType === "cash_book") {

//                 const data = await fetchCashBookStatement(
//                     tempFromDate,
//                     tempToDate
//                 );

//                 // ─── Flatten All Client Data With OPBAL Row ───────────────
//                 const allRows = (data.clients || []).flatMap((client) => {

//                     const openingBal = client.openingBalance || {};

//                     return [
//                         // ─── Opening Balance Row ─────────────────────
//                         {
//                             id: `opbal-${client.clientInfo?.id}`,
//                             docDate: tempFromDate,
//                             salePurchaseAC: client.clientInfo?.FirmName || "Opening Balance",
//                             docNo: "-",
//                             bookName: "OPBAL",
//                             debit: openingBal.type === "Dr" ? Number(openingBal.absValue || 0) : 0,
//                             credit: openingBal.type === "Cr" ? Number(openingBal.absValue || 0) : 0,
//                             remark: `Opening Balance Before ${tempFromDate}`,
//                             balance: Number(openingBal.absValue || 0),
//                             balanceType: openingBal.type || "Dr",
//                         },

//                         // ─── Actual Transactions ─────────────────────
//                         ...(client.data || []).map((item, index) => ({
//                             id: item.gLId || `${client.clientInfo?.id}-${index}`,
//                             docDate: item.DocDate,
//                             salePurchaseAC: item.AccName || "—",
//                             docNo: item.DocNo,
//                             bookName: item.BookName,
//                             debit: item.Debit || 0,
//                             credit: item.Credit || 0,
//                             remark: item.Remark || "",
//                             balance: item.RunningBalance || 0,
//                             balanceType: item.BalanceType || "Dr",
//                         })),
//                     ];
//                 });

//                 setCashBookData({
//                     ...data,
//                     details: allRows,
//                 });
//             } else if (tempReportType === "group_wise_summary") {

//                 const data = await fetchGroupwiseSummary(tempFromDate, tempToDate);
//                 setGroupwiseSummaryData(data.data || {});
//                 setExpandedSubGroups({});
//                 setExpandedClients({});
//                 setGroupwisePage("groups");
//                 setSelectedSubGroup(null);
//                 setSelectedClientForMonthly(null);
//                 setSelectedMonthForLedger(null);
//                 setMonthLedgerData(null);

//             } else if (tempReportType === "day_book") {

//                 const data = await fetchDayBookStatement(tempFromDate, tempToDate);

//                 const incomeNatures = ["Income (Trading)", "Income (P & L)"];
//                 const expenseNatures = ["Expense (Trading)", "Expense (P & L)"];

//                 const mapClientRows = (clients, prefix) =>
//                     (clients || []).flatMap((client) =>
//                         (client.data || []).map((item, index) => ({
//                             id: `${prefix}-${item.gLId || index}-${client.clientInfo.id}`,
//                             partyName: client.clientInfo.FirmName,
//                             docDate: item.DocDate,
//                             salePurchaseAC: item.AccName || "—",
//                             docNo: item.DocNo,
//                             bookName: item.BookName,
//                             debit: item.Debit || 0,
//                             credit: item.Credit || 0,
//                             remark: item.Remark || "",
//                             balance: item.RunningBalance || 0,
//                             balanceType: item.BalanceType || "Dr",
//                         }))
//                     );

//                 const incomeClientsList = (data.clients || []).filter((c) => incomeNatures.includes(c.clientInfo.NatureOfGroup));
//                 const expenseClientsList = (data.clients || []).filter((c) => expenseNatures.includes(c.clientInfo.NatureOfGroup));

//                 setDayBookData({
//                     clients: data.clients || [],
//                     incomeRows: mapClientRows(incomeClientsList, "income"),
//                     expenseRows: mapClientRows(expenseClientsList, "expense"),
//                     incomeSummary: data.incomeSummary || { totalCredit: 0, totalDebit: 0, totalRecords: 0 },
//                     expenseSummary: data.expenseSummary || { totalDebit: 0, totalCredit: 0, totalRecords: 0 },
//                 });
//             }

//             setAppliedFilters({
//                 fromDate: tempFromDate,
//                 toDate: tempToDate,
//                 clientCount: tempReportType === "general_ledger" ? tempSelectedClients.length : 0,
//                 selectedBookNames: selectedBookNames.length > 0 ? selectedBookNames : null,
//                 selectedBankAccount: tempReportType === "bank_book" ? selectedBankAccount : null,
//             });
//             setAppliedReportType(tempReportType);
//             setViewMode("detail");
//             setActiveTab(0);
//             setFilterOpen(false);
//         } catch (err) {
//             console.error("Error fetching selected ledgers:", err);
//             setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ── Handle Back to Filter ───────────────────────────────────────────────
//     const handleBackToFilter = () => {
//         setViewMode("filter");
//         setLedgerDataMap({});
//         setDateFilters({});
//         setActiveTab(0);
//         setSelectedClients([]);
//         setAppliedFilters(null);
//         setTempClientSearchText("");
//         setFilteredTempClients(allClients);
//         setTempSelectedClients([]);
//         setBankBookData(null);
//         setCashBookData(null);
//         setDayBookData(null);
//         setGroupwiseSummaryData(null);
//         setExpandedSubGroups({});
//         setExpandedClients({});
//         setGroupwisePage("groups");
//         setSelectedSubGroup(null);
//         setSelectedClientForMonthly(null);
//         setSelectedMonthForLedger(null);
//         setMonthLedgerData(null);
//     };

//     // ── Handle Clear (reset to filter view) ─────────────────────────────────
//     const handleClear = () => {
//         setViewMode("filter");
//         setLedgerDataMap({});
//         setDateFilters({});
//         setActiveTab(0);
//         setSelectedClients([]);
//         setAppliedFilters(null);
//         setTempClientSearchText("");
//         setFilteredTempClients(allClients);
//         setTempSelectedClients([]);
//         setBankBookData(null);
//         setCashBookData(null);
//         setDayBookData(null);
//         setGroupwiseSummaryData(null);
//         setExpandedSubGroups({});
//         setExpandedClients({});
//         setGroupwisePage("groups");
//         setSelectedSubGroup(null);
//         setSelectedClientForMonthly(null);
//         setSelectedMonthForLedger(null);
//         setMonthLedgerData(null);
//     };

//     // ── Handle Tab Change ───────────────────────────────────────────────────
//     const handleTabChange = (event, newValue) => {
//         setActiveTab(newValue);
//     };

//     // ── Get Current Tab Client ──────────────────────────────────────────────
//     const getCurrentTabClient = () => {
//         return selectedClients[activeTab] || null;
//     };

//     // ── Get Current Tab Data ────────────────────────────────────────────────
//     const getCurrentTabData = () => {
//         const client = getCurrentTabClient();
//         return client ? ledgerDataMap[client.id] : null;
//     };

//     // ── Apply Filter for Current Tab ──────────────────────────────────────
//     const handleApplyFilter = async () => {
//         const client = getCurrentTabClient();
//         if (!client) return;
//         const fromDate = dateFilters[client.id]?.fromDate;
//         const toDate = dateFilters[client.id]?.toDate;
//         if (!fromDate || !toDate) {
//             setSnackbar({ open: true, message: "Please select a date range", severity: "warning" });
//             return;
//         }
//         if (new Date(fromDate) > new Date(toDate)) {
//             setSnackbar({ open: true, message: "From Date must be before To Date", severity: "error" });
//             return;
//         }
//         try {
//             setLoading(true);
//             await fetchPartyDetail(client.id, fromDate, toDate);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // ── Handle Date Filter Change ───────────────────────────────────────────
//     const handleDateFilterChange = (clientId, field, value) => {
//         setDateFilters((prev) => ({
//             ...prev,
//             [clientId]: {
//                 ...prev[clientId],
//                 [field]: value,
//             },
//         }));
//     };

//     // ── Open Filter Dialog ───────────────────────────────────────────────────
//     const handleOpenFilter = () => {
//         const { fromDate: fyFromDate, toDate: fyToDate } = getFinancialYearDates();
//         setTempFromDate(fyFromDate);
//         setTempToDate(fyToDate);
//         setTempClientSearchText("");
//         setFilteredTempClients(allClients);
//         setTempSelectedClients([]);
//         setTempReportType(appliedReportType || "general_ledger");
//         setSelectedBankAccount('');
//         setSelectedBookNames([]);
//         setFilterOpen(true);
//         setIsDaywise(false);
//     };

//     // ── Effect: Initialize on Mount ────────────────────────────────────────
//     useEffect(() => {
//         if (companyId) {
//             fetchAllClients();
//         }
//     }, [companyId]);

//     // ── Effect: Fetch bank accounts when BankBook is selected ──────────────
//     useEffect(() => {
//         if (tempReportType === 'bank_book' && companyId) {
//             fetchBankAccounts();
//         }
//     }, [tempReportType, companyId]);

//     // ── Get dynamic column labels based on report type ──────────────────────
//     const { debitLabel, creditLabel } = getAmountColumnLabels(appliedReportType);

//     // ── DataGrid Columns - Detail View ─────────────────────────────────────
//     const columns = [
//         {
//             field: "docDate", headerName: "Date", flex: 1, minWidth: 115,
//             renderCell: ({ value }) => (
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: G500 }}>
//                     <CalendarTodayOutlinedIcon sx={{ fontSize: 12 }} />
//                     <Typography sx={{ fontSize: 13 }}>{fmtDate(value)}</Typography>
//                 </Box>
//             ),
//         },
//         {
//             field: "salePurchaseAC", headerName: "Narration", flex: 1.2, minWidth: 160,
//             renderCell: ({ row }) => (
//                 <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5, width: "100%" }}>
//                     <Box sx={{ display: "inline-flex", alignItems: "center", px: 0, py: "3px", maxWidth: "100%" }}>
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                             {row.salePurchaseAC || "—"}
//                         </Typography>
//                     </Box>
//                     {row.remark && row.remark.trim() !== "" && (
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, pl: "2px" }}>
//                             <Box sx={{ width: 3, height: 3, borderRadius: "50%", background: G500, flexShrink: 0 }} />
//                             <Typography sx={{ fontSize: 10.5, color: G500, fontStyle: "italic", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", lineHeight: 1.3 }}>
//                                 {row.remark}
//                             </Typography>
//                         </Box>
//                     )}
//                 </Box>
//             ),
//         },
//         {
//             field: "docNo", headerName: "Doc No", flex: 1.1, minWidth: 110,
//             renderCell: ({ value }) => (
//                 <Chip label={value} size="small" sx={{ fontSize: 11, height: 22, background: "transparent", color: FB, fontWeight: 700, border: "none", borderRadius: "7px", "& .MuiChip-label": { px: 0 } }} />
//             ),
//         },
//         {
//             field: "bookName", headerName: "BookName", flex: 1.4, minWidth: 130,
//             renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900, fontWeight: 500 }}>{value}</Typography>,
//         },
//         {
//             field: "debit", headerName: `${debitLabel} (₹)`, flex: 1, minWidth: 120,
//             renderCell: ({ value }) =>
//                 Number(value) > 0 ? (
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                         <TrendingUpIcon sx={{ fontSize: 14, color: G700 }} />
//                         <Typography sx={{ fontSize: 13, fontWeight: 600, color: G700 }}>{fmt(Number(value))}</Typography>
//                     </Box>
//                 ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
//         },
//         {
//             field: "credit", headerName: `${creditLabel} (₹)`, flex: 1, minWidth: 120,
//             renderCell: ({ value }) =>
//                 Number(value) > 0 ? (
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                         <TrendingDownIcon sx={{ fontSize: 14, color: FB }} />
//                         <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{fmt(Number(value))}</Typography>
//                     </Box>
//                 ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
//         },
//         {
//             field: "balance", headerName: "Balance (₹)", flex: 1.2, minWidth: 140,
//             renderCell: ({ row }) => {
//                 const balType = row.balanceType || "Dr";
//                 const bgColor = getBalanceBgColor(balType);
//                 const textColor = getBalanceColor(balType);
//                 return (
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
//                         {balType === "Dr" ? (
//                             <TrendingUpIcon sx={{ fontSize: 14, color: textColor }} />
//                         ) : (
//                             <TrendingDownIcon sx={{ fontSize: 14, color: textColor }} />
//                         )}
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, px: 1, py: 0.3, borderRadius: "6px", background: bgColor, border: `1px solid ${G300}` }}>
//                             <Typography sx={{ fontSize: 12, fontWeight: 700, color: textColor }}>
//                                 {fmt(Number(row.balance || 0))}
//                             </Typography>
//                             <Typography sx={{ fontSize: 10, fontWeight: 700, color: textColor, textTransform: "uppercase", letterSpacing: ".3px", }}>
//                                 {balType}
//                             </Typography>
//                         </Box>
//                     </Box>
//                 );
//             },
//         },
//     ];

//     // ─────────────────────────────────────────────────────────────────────────────
//     // RENDER - FILTER VIEW
//     // ─────────────────────────────────────────────────────────────────────────────
//     if (viewMode === "filter") {
//         return (
//             <Box sx={{ background: G200, display: "flex", flexDirection: "column", minHeight: "100%" }}>
//                 {/* ERP Header */}
//                 <Box sx={{ background: WHITE, borderBottom: `1px solid ${G300}`, display: "flex", alignItems: "stretch", flexShrink: 0, minHeight: 58 }}>
//                     <Box sx={{ width: 4, background: FB, flexShrink: 0 }} />
//                     <Box sx={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "space-between", px: { xs: 2, sm: 3 }, py: 1.25, gap: 2, flexWrap: "wrap" }}>
//                         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                             <Box sx={{ width: 36, height: 36, background: FB_LIGHT, borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                                 <ReceiptLongOutlinedIcon sx={{ fontSize: 20, color: FB }} />
//                             </Box>
//                             <Box>
//                                 <Typography sx={{ fontSize: 15, fontWeight: 700, color: G900, lineHeight: 1.2 }}>Ledger Report</Typography>
//                                 <Typography sx={{ fontSize: 11, color: G500, mt: "1px" }}>General ledger, bank book, cash book &amp; day book</Typography>
//                             </Box>
//                         </Box>
//                         <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 15 }} />} sx={btnPrimarySx}>
//                             Smart Filter
//                         </Button>
//                     </Box>
//                 </Box>

//                 {/* Empty State */}
//                 <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: { xs: 2, sm: 3 } }}>
//                     <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "10px", p: { xs: 3, sm: 4 }, textAlign: "center", maxWidth: 420, width: "100%" }}>
//                         <Box sx={{ width: 52, height: 52, background: FB_LIGHT, borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
//                             <ReceiptLongOutlinedIcon sx={{ fontSize: 26, color: FB }} />
//                         </Box>
//                         <Typography sx={{ fontSize: 15, fontWeight: 700, color: G900, mb: 0.75 }}>Select Report Parameters</Typography>
//                         <Typography sx={{ fontSize: 13, color: G700, lineHeight: 1.7, mb: 2.5 }}>
//                             Use Smart Filter to select report type, clients, and date range to view ledger data.
//                         </Typography>
//                         <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 15 }} />} sx={{ ...btnPrimarySx, height: 38, px: 3 }}>
//                             Open Smart Filter
//                         </Button>
//                     </Box>
//                 </Box>

//                 {/* Snackbar */}
//                 <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
//                     <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
//                         {snackbar.message}
//                     </Alert>
//                 </Snackbar>

//                 {/* Smart Filter Dialog */}
//                 <SmartFilterDialog
//                     open={filterOpen}
//                     onClose={() => setFilterOpen(false)}
//                     allClients={allClients}
//                     itemGroupsLoading={false}
//                     tempFromDate={tempFromDate}
//                     setTempFromDate={setTempFromDate}
//                     tempToDate={tempToDate}
//                     setTempToDate={setTempToDate}
//                     tempClientSearchText={tempClientSearchText}
//                     setTempClientSearchText={handleTempClientSearch}
//                     tempSelectedClients={tempSelectedClients}
//                     setTempSelectedClients={setTempSelectedClients}
//                     filteredTempClients={filteredTempClients}
//                     handleTempSelectAll={() => setTempSelectedClients(filteredTempClients)}
//                     handleTempDeselectAll={() => setTempSelectedClients([])}
//                     handleTempClientCheckbox={handleTempClientCheckbox}
//                     loading={loading}
//                     onGetData={handleViewSelectedLedgers}
//                     tempReportType={tempReportType}
//                     setTempReportType={setTempReportType}
//                     selectedBookNames={selectedBookNames}
//                     setSelectedBookNames={setSelectedBookNames}
//                     selectedBankAccount={selectedBankAccount}
//                     setSelectedBankAccount={setSelectedBankAccount}
//                     bankAccounts={bankAccounts}
//                     bankAccountsLoading={bankAccountsLoading}
//                     isDaywise={isDaywise}
//                     setIsDaywise={setIsDaywise}
//                 />
//             </Box>
//         );
//     }

//     // ─────────────────────────────────────────────────────────────────────────────
//     // RENDER - DETAIL VIEW
//     // ─────────────────────────────────────────────────────────────────────────────
//     const currentClient = getCurrentTabClient();
//     const currentData = getCurrentTabData();

//     return (
//         <Box sx={{ background: G200, display: "flex", flexDirection: "column", minHeight: "100%" }}>
//             {/* ── ERP Header ── */}
//             <Box sx={{ background: WHITE, borderBottom: `1px solid ${G300}`, display: "flex", alignItems: "stretch", flexShrink: 0, minHeight: 58 }}>
//                 <Box sx={{ width: 4, background: FB, flexShrink: 0 }} />
//                 <Box sx={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "space-between", px: { xs: 2, sm: 3 }, py: 1.25, gap: 2, flexWrap: "wrap" }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <Box sx={{ width: 36, height: 36, background: FB_LIGHT, borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                             <ReceiptLongOutlinedIcon sx={{ fontSize: 20, color: FB }} />
//                         </Box>
//                         <Box>
//                             <Typography sx={{ fontSize: 15, fontWeight: 700, color: G900, lineHeight: 1.2 }}>
//                                 {REPORT_TYPES.find((r) => r.value === appliedReportType)?.label || "Ledger Report"}
//                             </Typography>
//                             <Typography sx={{ fontSize: 11, color: G500, mt: "1px" }}>
//                                 {appliedFilters ? `${appliedReportType === "general_ledger" ? `${selectedClients.length} client${selectedClients.length !== 1 ? "s" : ""} · ` : ""}${fmtDate(appliedFilters.fromDate)} – ${fmtDate(appliedFilters.toDate)}` : ""}
//                             </Typography>
//                         </Box>
//                     </Box>
//                     <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
//                         {appliedReportType === "general_ledger" && selectedClients.length > 0 && (
//                             <Button onClick={handleExportPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
//                                 {isSmall ? "PDF" : "Export PDF"}
//                             </Button>
//                         )}
//                         {appliedReportType === "bank_book" && bankBookData && (
//                             <Button onClick={handleExportBankBookPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
//                                 {isSmall ? "PDF" : "Export PDF"}
//                             </Button>
//                         )}
//                         {appliedReportType === "cash_book" && cashBookData && (
//                             <Button onClick={handleExportCashBookPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
//                                 {isSmall ? "PDF" : "Export PDF"}
//                             </Button>
//                         )}
//                         {appliedReportType === "day_book" && dayBookData && (
//                             <Button onClick={handleExportDayBookPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
//                                 {isSmall ? "PDF" : "Export PDF"}
//                             </Button>
//                         )}
//                         {appliedReportType === "group_wise_summary" && groupwiseSummaryData && (
//                             <Button onClick={
//                                 groupwisePage === "ledger" && selectedMonthForLedger ? handleExportPDF :
//                                 groupwisePage === "clients" && selectedSubGroup ? handleExportClientsPagePDF :
//                                 groupwisePage === "monthly" && selectedClientForMonthly ? handleExportMonthlyPagePDF :
//                                 handleExportGroupwiseSummaryPDF
//                             } disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
//                                 {isSmall ? "PDF" : "Export PDF"}
//                             </Button>
//                         )}
//                         <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 15 }} />} sx={btnPrimarySx}>
//                             {isSmall ? "Filter" : "Smart Filter"}
//                         </Button>
//                     </Box>
//                 </Box>
//             </Box>

//             {/* ── Toolbar: filter tags + tabs ── */}
//             {appliedFilters && (
//                 <Box sx={{ background: WHITE, borderBottom: `1px solid ${G300}`, flexShrink: 0 }}>
//                     {/* Filter tags row */}
//                     <Box sx={{ px: { xs: 2, sm: 3 }, py: 1, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, background: G200, borderBottom: `1px solid ${G300}` }}>
//                         <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
//                             <Typography sx={{ fontSize: 11, color: G500, fontWeight: 600, textTransform: "uppercase", letterSpacing: ".4px", mr: 0.5 }}>Filter:</Typography>
//                             {[
//                                 REPORT_TYPES.find((r) => r.value === appliedReportType)?.label,
//                                 `${fmtDate(appliedFilters.fromDate)} – ${fmtDate(appliedFilters.toDate)}`,
//                                 ...(appliedReportType === "general_ledger" ? [`${appliedFilters.clientCount} client${appliedFilters.clientCount > 1 ? "s" : ""}`] : []),
//                             ].filter(Boolean).map(tag => (
//                                 <Box key={tag} sx={{ px: 1.25, py: "2px", background: FB_LIGHT, borderRadius: "4px", border: `1px solid ${G300}` }}>
//                                     <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{tag}</Typography>
//                                 </Box>
//                             ))}
//                         </Box>
//                         <Button onClick={handleClear} size="small" startIcon={<ClearIcon sx={{ fontSize: 12 }} />}
//                             sx={{ color: G700, border: `1px solid ${G300}`, background: "transparent", borderRadius: "6px", fontSize: 11, fontWeight: 500, textTransform: "none", px: 1.25, height: 26, "&:hover": { background: G200 } }}>
//                             Clear
//                         </Button>
//                     </Box>

//                     {/* Tabs for General Ledger */}
//                     {appliedReportType === "general_ledger" && selectedClients.length > 0 && (
//                         <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto"
//                             sx={{ px: 1, minHeight: 42, "& .MuiTabs-indicator": { background: FB, height: 2.5, borderRadius: "2px 2px 0 0" }, "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: 13, color: G500, minHeight: 42, px: 2, py: 0.75, "&.Mui-selected": { color: FB } } }}>
//                             {selectedClients.map((client, idx) => {
//                                 const clientData = ledgerDataMap[client.id];
//                                 const entryCount = clientData?.details?.length || 0;
//                                 return (
//                                     <Tab key={client.id}
//                                         label={
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
//                                                 <span>{client.FirmName}</span>
//                                                 <Box sx={{ minWidth: 18, height: 17, px: "4px", background: entryCount > 0 ? FB : G300, borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                                     <Typography sx={{ fontSize: 10, fontWeight: 700, color: WHITE, lineHeight: 1 }}>{entryCount}</Typography>
//                                                 </Box>
//                                             </Box>
//                                         }
//                                         id={`ledger-tab-${idx}`}
//                                         aria-controls={`ledger-tabpanel-${idx}`}
//                                     />
//                                 );
//                             })}
//                         </Tabs>
//                     )}
//                 </Box>
//             )}

//             {/* ── Content area ─────────────────────────────────────────────────────── */}
//             <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>

//                 {/* ── Tab Content — General Ledger ────────────────────────────────────── */}
//                 {appliedReportType === "general_ledger" &&
//                     selectedClients.map((client, idx) => {
//                         const clientData = ledgerDataMap[client.id];
//                         const isActive = idx === activeTab;

//                         const displayRows = (() => {
//                             if (!clientData?.details) return [];
//                             const opValue = Number(clientData.openingBalance.absValue || 0);
//                             const opType = clientData.openingBalance.type || "Dr";
//                             const openingRow = {
//                                 id: "opening-balance",
//                                 docDate: fmtDate(appliedFilters?.fromDate || dateFilters[client.id]?.fromDate) || "—",
//                                 salePurchaseAC: "—",
//                                 docNo: "—",
//                                 bookName: "OPBAL",
//                                 debit: clientData.openingBalance.type === "Dr" ? Number(clientData.openingBalance.absValue || 0) : 0,
//                                 credit: clientData.openingBalance.type === "Cr" ? Number(clientData.openingBalance.absValue || 0) : 0,
//                                 remark: "",
//                                 balance: opValue,
//                                 balanceType: opType,
//                                 isOpeningRow: true,
//                             };
//                             return [openingRow, ...clientData.details];
//                         })();

//                         return (
//                             <TabPanel key={client.id} value={activeTab} index={idx}>
//                                 {isActive && (
//                                     <Box>
//                                         {/* KPI Strip */}
//                                         {clientData && clientData.details && clientData.details.length > 0 && (
//                                             <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", mb: 2, overflow: "hidden" }}>
//                                                 <Box sx={{ display: "flex", px: { xs: 2, sm: 3 }, py: 1.5, overflowX: "auto" }}>
//                                                     {[
//                                                         { label: "ENTRIES", value: String(clientData.summary.totalTransactions || clientData.details.length), accent: false },
//                                                         { label: `TOTAL ${debitLabel.toUpperCase()}`, value: `₹ ${fmt(clientData.summary.totalDebit || 0)}`, accent: false },
//                                                         { label: `TOTAL ${creditLabel.toUpperCase()}`, value: `₹ ${fmt(clientData.summary.totalCredit || 0)}`, accent: false },
//                                                         { label: "CLOSING BALANCE", value: `${fmt(Number(clientData.closingBalance?.absValue || 0))} ${clientData.closingBalance?.type || "Dr"}`, accent: true },
//                                                     ].map((item, i, arr) => (
//                                                         <Box key={i} sx={{ pr: { xs: 2.5, sm: 3.5 }, pl: i === 0 ? 0 : { xs: 2.5, sm: 3.5 }, borderRight: i < arr.length - 1 ? `1px solid ${G300}` : "none", flexShrink: 0 }}>
//                                                             <Typography sx={{ fontSize: 10, fontWeight: 700, color: G500, textTransform: "uppercase", letterSpacing: ".6px", lineHeight: 1, mb: "4px" }}>{item.label}</Typography>
//                                                             <Typography sx={{ fontSize: 16, fontWeight: 700, color: item.accent ? FB : G900, fontFamily: "monospace", lineHeight: 1 }}>{item.value}</Typography>
//                                                         </Box>
//                                                     ))}
//                                                 </Box>
//                                             </Box>
//                                         )}

//                                         {/* DataGrid */}
//                                         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
//                                             {loading ? (
//                                                 <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
//                                                     <CircularProgress sx={{ color: FB }} />
//                                                     <Typography sx={{ color: G500, fontSize: 13 }}>Loading ledger entries…</Typography>
//                                                 </Box>
//                                             ) : displayRows.length > 0 ? (
//                                                 <DataGrid rows={displayRows} columns={columns} autoHeight rowHeight={44} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={dgSx} />
//                                             ) : (
//                                                 <Box sx={{ py: "2.5rem" }}>
//                                                     <NoDataComponent />
//                                                 </Box>
//                                             )}
//                                         </Box>
//                                     </Box>
//                                 )}
//                             </TabPanel>
//                         );
//                     })}

//                 {/* ── BankBook Statement View ──────────────────────────────────────────── */}
//                 {appliedReportType === "bank_book" && (
//                     <Box>
//                         {loading ? (
//                             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
//                                 <CircularProgress sx={{ color: FB }} />
//                                 <Typography sx={{ color: G500, fontSize: 13 }}>Loading bank book statement…</Typography>
//                             </Box>
//                         ) : bankBookData ? (
//                             <>
//                                 <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap" }}>
//                                     <StatCard label="Opening Balance" value={`₹ ${fmt(bankBookData.openingBalance?.opBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
//                                     <StatCard label="Total Withdrawal" value={`₹ ${fmt(bankBookData.summary?.totalDebit ?? 0)}`} icon={<TrendingUpIcon fontSize="small" />} />
//                                     <StatCard label="Total Deposit" value={`₹ ${fmt(bankBookData.summary?.totalCredit ?? 0)}`} icon={<TrendingDownIcon fontSize="small" />} />
//                                     <StatCard label="Closing Balance" value={`₹ ${fmt(bankBookData.closingBalance?.closingBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
//                                 </Box>
//                                 <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
//                                     {bankBookData.data && bankBookData.data.length > 0 ? (
//                                         <DataGrid rows={bankBookData?.details || []} columns={columns} autoHeight rowHeight={44} getRowId={(row) => row.id} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={dgSx} />
//                                     ) : (
//                                         <Box sx={{ py: "2.5rem" }}><NoDataComponent /></Box>
//                                     )}
//                                 </Box>
//                             </>
//                         ) : (
//                             <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
//                                 <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
//                             </Box>
//                         )}
//                     </Box>
//                 )}

//                 {/* ── CashBook Statement View ──────────────────────────────────────────── */}
//                 {appliedReportType === "cash_book" && (
//                     <Box>
//                         {loading ? (
//                             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
//                                 <CircularProgress sx={{ color: FB }} />
//                                 <Typography sx={{ color: G500, fontSize: 13 }}>Loading cash book statement…</Typography>
//                             </Box>
//                         ) : cashBookData ? (
//                             <>
//                                 {cashBookData.clients && cashBookData.clients.length > 0 ? (
//                                     <>
//                                         {cashBookData.clients.length > 1 && (
//                                             <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px 12px 0 0", mb: 0 }}>
//                                                 <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto"
//                                                     sx={{
//                                                         "& .MuiTabs-indicator": { background: FB, height: 3 },
//                                                         "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: 13, color: G500, padding: "12px 20px", minHeight: 48, "&.Mui-selected": { color: FB } },
//                                                     }}
//                                                 >
//                                                     {cashBookData.clients.map((clientItem, idx) => {
//                                                         const entryCount = clientItem?.data?.length || 0;
//                                                         return (
//                                                             <Tab key={clientItem.clientInfo.id}
//                                                                 label={
//                                                                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                                         <span>{clientItem.clientInfo.FirmName}</span>
//                                                                         <Chip label={entryCount} size="small" sx={{ height: 20, fontSize: 11, fontWeight: 700, background: entryCount > 0 ? FB_LIGHT : G200, color: entryCount > 0 ? FB : G500 }} />
//                                                                     </Box>
//                                                                 }
//                                                                 id={`cash-tab-${idx}`}
//                                                                 aria-controls={`cash-tabpanel-${idx}`}
//                                                             />
//                                                         );
//                                                     })}
//                                                 </Tabs>
//                                             </Box>
//                                         )}
//                                         {cashBookData.clients.map((clientItem, idx) => (
//                                             <TabPanel key={clientItem.clientInfo.id} value={activeTab} index={idx}>
//                                                 <Box>
//                                                     <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap" }}>
//                                                         <StatCard label="Opening Balance" value={`₹ ${fmt(clientItem.openingBalance?.opBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
//                                                         <StatCard label="Total Withdrawal" value={`₹ ${fmt(clientItem.summary?.totalDebit ?? 0)}`} icon={<TrendingUpIcon fontSize="small" />} />
//                                                         <StatCard label="Total Deposit" value={`₹ ${fmt(clientItem.summary?.totalCredit ?? 0)}`} icon={<TrendingDownIcon fontSize="small" />} />
//                                                         <StatCard label="Closing Balance" value={`₹ ${fmt(clientItem.closingBalance?.closingBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
//                                                     </Box>
//                                                     <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
//                                                         {clientItem.data && clientItem.data.length > 0 ? (
//                                                             <DataGrid rows={cashBookData?.details || []} columns={columns} getRowId={(row) => row.id} autoHeight rowHeight={44} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={dgSx} />
//                                                         ) : (
//                                                             <Box sx={{ py: "2.5rem" }}><NoDataComponent /></Box>
//                                                         )}
//                                                     </Box>
//                                                 </Box>
//                                             </TabPanel>
//                                         ))}
//                                     </>
//                                 ) : (
//                                     <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
//                                         <Typography sx={{ fontSize: 14, color: G500 }}>No cash book records found.</Typography>
//                                     </Box>
//                                 )}
//                             </>
//                         ) : (
//                             <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
//                                 <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
//                             </Box>
//                         )}
//                     </Box>
//                 )}

//                 {/* ── DayBook Statement View ───────────────────────────────────────────── */}
//                 {appliedReportType === "day_book" && (
//                     <Box>
//                         {loading ? (
//                             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
//                                 <CircularProgress sx={{ color: FB }} />
//                                 <Typography sx={{ color: G500, fontSize: 13 }}>Loading day book statement…</Typography>
//                             </Box>
//                         ) : dayBookData ? (() => {
//                             const totalIncome = Number(dayBookData.incomeSummary?.totalCredit ?? 0);
//                             const totalExpense = Number(dayBookData.expenseSummary?.totalDebit ?? 0);
//                             const netPL = totalIncome - totalExpense;
//                             const isProfit = netPL >= 0;

//                             // ── Month-wise grouping ──────────────────────────────
//                             const monthMap = {};
//                             const fmtMonthKey = (mk) => {
//                                 const [yyyy, mm] = mk.split("-");
//                                 const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//                                 return `${names[parseInt(mm) - 1]} ${yyyy}`;
//                             };
//                             (dayBookData.expenseRows || []).forEach((r) => {
//                                 const mk = String(r.docDate || "").substring(0, 7);
//                                 if (!monthMap[mk]) monthMap[mk] = { id: mk, period: fmtMonthKey(mk), expense: 0, income: 0 };
//                                 monthMap[mk].expense += Number(r.debit || 0);
//                             });
//                             (dayBookData.incomeRows || []).forEach((r) => {
//                                 const mk = String(r.docDate || "").substring(0, 7);
//                                 if (!monthMap[mk]) monthMap[mk] = { id: mk, period: fmtMonthKey(mk), expense: 0, income: 0 };
//                                 monthMap[mk].income += Number(r.credit || 0);
//                             });
//                             const monthRows = Object.values(monthMap)
//                                 .sort((a, b) => a.id.localeCompare(b.id))
//                                 .map((r) => ({ ...r, net: r.income - r.expense }));

//                             // ── Day-wise grouping ────────────────────────────────
//                             const dayMap = {};
//                             (dayBookData.expenseRows || []).forEach((r) => {
//                                 const dk = String(r.docDate || "");
//                                 if (!dayMap[dk]) dayMap[dk] = { id: dk, period: fmtDate(dk), expense: 0, income: 0 };
//                                 dayMap[dk].expense += Number(r.debit || 0);
//                             });
//                             (dayBookData.incomeRows || []).forEach((r) => {
//                                 const dk = String(r.docDate || "");
//                                 if (!dayMap[dk]) dayMap[dk] = { id: dk, period: fmtDate(dk), expense: 0, income: 0 };
//                                 dayMap[dk].income += Number(r.credit || 0);
//                             });
//                             const dayRows = Object.values(dayMap)
//                                 .sort((a, b) => a.id.localeCompare(b.id))
//                                 .map((r) => ({ ...r, net: r.income - r.expense }));

//                             // ── All Transactions combined ────────────────────────
//                             const allTxRows = [
//                                 ...(dayBookData.expenseRows || []),
//                                 ...(dayBookData.incomeRows || []),
//                             ].sort((a, b) => String(a.docDate || "").localeCompare(String(b.docDate || "")));

//                             // ── Shared columns for month/day views ───────────────
//                             const periodGridSx = dgSx;

//                             const periodColumns = [
//                                 {
//                                     field: "period", headerName: dayBookView === "month" ? "Month" : "Date",
//                                     flex: 1.2, minWidth: 130,
//                                     renderCell: ({ value }) => (
//                                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
//                                             <CalendarTodayOutlinedIcon sx={{ fontSize: 12, color: G500 }} />
//                                             <Typography sx={{ fontSize: 13, fontWeight: 500, color: G900 }}>{value}</Typography>
//                                         </Box>
//                                     ),
//                                 },
//                                 {
//                                     field: "expense", headerName: "Expense (₹)", flex: 1.1, minWidth: 130,
//                                     renderCell: ({ value }) => Number(value) > 0 ? (
//                                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 1, py: 0.4, background: G200, borderRadius: "7px" }}>
//                                             <TrendingUpIcon sx={{ fontSize: 13, color: G700 }} />
//                                             <Typography sx={{ fontSize: 13, fontWeight: 700, color: G700 }}>{fmt(Number(value))}</Typography>
//                                         </Box>
//                                     ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
//                                 },
//                                 {
//                                     field: "income", headerName: "Income (₹)", flex: 1.1, minWidth: 130,
//                                     renderCell: ({ value }) => Number(value) > 0 ? (
//                                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 1, py: 0.4, background: FB_LIGHT, borderRadius: "7px" }}>
//                                             <TrendingDownIcon sx={{ fontSize: 13, color: FB }} />
//                                             <Typography sx={{ fontSize: 13, fontWeight: 700, color: FB }}>{fmt(Number(value))}</Typography>
//                                         </Box>
//                                     ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
//                                 },
//                                 {
//                                     field: "net", headerName: "Net P&L (₹)", flex: 1.2, minWidth: 140,
//                                     renderCell: ({ value }) => {
//                                         const n = Number(value);
//                                         const profit = n >= 0;
//                                         return (
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, px: 1, py: 0.4, background: profit ? FB_LIGHT : G200, borderRadius: "7px", border: `1px solid ${profit ? G300 : G300}` }}>
//                                                 {profit
//                                                     ? <TrendingDownIcon sx={{ fontSize: 13, color: FB }} />
//                                                     : <TrendingUpIcon sx={{ fontSize: 13, color: G700 }} />
//                                                 }
//                                                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: profit ? FB : G700 }}>
//                                                     {profit ? "+" : "-"}{fmt(Math.abs(n))}
//                                                 </Typography>
//                                             </Box>
//                                         );
//                                     },
//                                 },
//                             ];

//                             return (
//                                 <>
//                                     {/* ── Summary Cards ───────────────────────────── */}
//                                     <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap" }}>
//                                         <StatCard label="Total Income" value={`₹ ${fmt(totalIncome)}`} icon={<TrendingDownIcon fontSize="small" />} />
//                                         <StatCard label="Total Expense" value={`₹ ${fmt(totalExpense)}`} icon={<TrendingUpIcon fontSize="small" />} />
//                                         <StatCard label={isProfit ? "Net Profit" : "Net Loss"} value={`₹ ${fmt(Math.abs(netPL))}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
//                                     </Box>

//                                     {/* ── View Toggle ─────────────────────────────── */}
//                                     <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
//                                         {[
//                                             { key: "month", label: "Month Wise" },
//                                             { key: "day", label: "Day Wise" },
//                                             { key: "all", label: "All Transactions" },
//                                         ].map((v) => (
//                                             <Button key={v.key} onClick={() => setDayBookView(v.key)}
//                                                 sx={{ fontSize: 13, fontWeight: 500, textTransform: "none", borderRadius: "8px", px: 2, height: 34, background: dayBookView === v.key ? FB : "transparent", color: dayBookView === v.key ? WHITE : G500, border: `1.5px solid ${dayBookView === v.key ? FB : G300}`,
//                                                     "&:hover": { background: dayBookView === v.key ? FB_DARK : FB_LIGHT, color: dayBookView === v.key ? WHITE : FB },
//                                                 }}
//                                             >
//                                                 {v.label}
//                                             </Button>
//                                         ))}
//                                     </Box>

//                                     {/* ── Month Wise / Day Wise DataGrid ───────────── */}
//                                     {(dayBookView === "month" || dayBookView === "day") && (
//                                         <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
//                                             <DataGrid rows={dayBookView === "month" ? monthRows : dayRows} columns={periodColumns} autoHeight rowHeight={44} getRowId={(row) => row.id} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={periodGridSx} />
//                                         </Box>
//                                     )}

//                                     {/* ── All Transactions DataGrid ────────────────── */}
//                                     {dayBookView === "all" && (
//                                         <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
//                                             {allTxRows.length > 0 ? (
//                                                 <DataGrid
//                                                     rows={allTxRows}
//                                                     columns={[
//                                                         {
//                                                             field: "docDate", headerName: "Date", flex: 1, minWidth: 115,
//                                                             renderCell: ({ value }) => (
//                                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: G500 }}>
//                                                                     <CalendarTodayOutlinedIcon sx={{ fontSize: 12 }} />
//                                                                     <Typography sx={{ fontSize: 13 }}>{fmtDate(value)}</Typography>
//                                                                 </Box>
//                                                             ),
//                                                         },
//                                                         {
//                                                             field: "partyName", headerName: "Client Name", flex: 1.4, minWidth: 150,
//                                                             renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: G900 }}>{value}</Typography>,
//                                                         },
//                                                         {
//                                                             field: "salePurchaseAC", headerName: "Narration", flex: 1.2, minWidth: 160,
//                                                             renderCell: ({ row }) => (
//                                                                 <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5, width: "100%" }}>
//                                                                     <Box sx={{ display: "inline-flex", alignItems: "center", px: 0, py: "3px", maxWidth: "100%" }}>
//                                                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                                                                             {row.salePurchaseAC || "—"}
//                                                                         </Typography>
//                                                                     </Box>
//                                                                     {row.remark && row.remark.trim() !== "" && (
//                                                                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, pl: "2px" }}>
//                                                                             <Box sx={{ width: 3, height: 3, borderRadius: "50%", background: G500, flexShrink: 0 }} />
//                                                                             <Typography sx={{ fontSize: 10.5, color: G500, fontStyle: "italic", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", lineHeight: 1.3 }}>
//                                                                                 {row.remark}
//                                                                             </Typography>
//                                                                         </Box>
//                                                                     )}
//                                                                 </Box>
//                                                             ),
//                                                         },
//                                                         {
//                                                             field: "docNo", headerName: "Doc No", flex: 1.1, minWidth: 110,
//                                                             renderCell: ({ value }) => (
//                                                                 <Chip label={value} size="small" sx={{ fontSize: 11, height: 22, background: "transparent", color: FB, fontWeight: 700, border: "none", borderRadius: "7px", "& .MuiChip-label": { px: 0 } }} />
//                                                             ),
//                                                         },
//                                                         {
//                                                             field: "bookName", headerName: "BookName", flex: 1.4, minWidth: 130,
//                                                             renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900, fontWeight: 500 }}>{value}</Typography>,
//                                                         },
//                                                         {
//                                                             field: "debit", headerName: "Debit (₹)", flex: 1, minWidth: 120,
//                                                             renderCell: ({ value }) => Number(value) > 0 ? (
//                                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                                                                     <TrendingUpIcon sx={{ fontSize: 14, color: G700 }} />
//                                                                     <Typography sx={{ fontSize: 13, fontWeight: 600, color: G700 }}>{fmt(Number(value))}</Typography>
//                                                                 </Box>
//                                                             ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
//                                                         },
//                                                         {
//                                                             field: "credit", headerName: "Credit (₹)", flex: 1, minWidth: 120,
//                                                             renderCell: ({ value }) => Number(value) > 0 ? (
//                                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                                                                     <TrendingDownIcon sx={{ fontSize: 14, color: FB }} />
//                                                                     <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{fmt(Number(value))}</Typography>
//                                                                 </Box>
//                                                             ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
//                                                         },
//                                                         {
//                                                             field: "balance", headerName: "Balance (₹)", flex: 1.2, minWidth: 140,
//                                                             renderCell: ({ row }) => {
//                                                                 const balType = row.balanceType || "Dr";
//                                                                 const bgColor = getBalanceBgColor(balType);
//                                                                 const textColor = getBalanceColor(balType);
//                                                                 return (
//                                                                     <Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
//                                                                         {balType === "Dr"
//                                                                             ? <TrendingUpIcon sx={{ fontSize: 14, color: textColor }} />
//                                                                             : <TrendingDownIcon sx={{ fontSize: 14, color: textColor }} />
//                                                                         }
//                                                                         <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, px: 1, py: 0.3, borderRadius: "6px", background: bgColor, border: `1px solid ${G300}` }}>
//                                                                             <Typography sx={{ fontSize: 12, fontWeight: 700, color: textColor }}>{fmt(Number(row.balance || 0))}</Typography>
//                                                                             <Typography sx={{ fontSize: 10, fontWeight: 700, color: textColor, textTransform: "uppercase", letterSpacing: ".3px" }}>{balType}</Typography>
//                                                                         </Box>
//                                                                     </Box>
//                                                                 );
//                                                             },
//                                                         },
//                                                     ]}
//                                                     autoHeight
//                                                     rowHeight={44}
//                                                     getRowId={(row) => row.id}
//                                                     disableRowSelectionOnClick
//                                                     pageSizeOptions={[25, 50, 100]}
//                                                     initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
//                                                     slots={{ noResultsOverlay: CustomNoDataOverlay }}
//                                                     sx={dgSx}
//                                                 />
//                                             ) : (
//                                                 <Box sx={{ py: "2.5rem" }}><NoDataComponent /></Box>
//                                             )}
//                                         </Box>
//                                     )}
//                                 </>
//                             );
//                         })() : (
//                             <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
//                                 <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
//                             </Box>
//                         )}
//                     </Box>
//                 )}

//                 {/* ── Groupwise Summary View ──────────────────────────────────────────── */}
//                 {appliedReportType === "group_wise_summary" && (
//                     <Box>
//                         {loading ? (
//                             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
//                                 <CircularProgress sx={{ color: FB }} />
//                                 <Typography sx={{ color: G500, fontSize: 13 }}>Loading groupwise summary…</Typography>
//                             </Box>
//                         ) : groupwiseSummaryData && Object.keys(groupwiseSummaryData).length > 0 ? (() => {

//                             const groups = Object.values(groupwiseSummaryData).map((grp) => {
//                                 const subGroups = Object.values(grp.subGroups || {}).map((sg) => ({
//                                     subGrpName: sg.subGroupName,
//                                     clients: sg.clients || [],
//                                     totalBalance: (sg.clients || []).reduce((s, c) => s + Number(c.balance || 0), 0),
//                                 }));
//                                 return {
//                                     groupName: grp.groupName,
//                                     subGroups,
//                                     totalBalance: subGroups.reduce((s, sg) => s + sg.totalBalance, 0),
//                                 };
//                             });

//                             const grandTotal = groups.reduce((s, g) => s + g.totalBalance, 0);
//                             const totalSubGroups = groups.reduce((s, g) => s + g.subGroups.length, 0);
//                             const totalClients = groups.reduce((s, g) => s + g.subGroups.reduce((ss, sg) => ss + sg.clients.length, 0), 0);

//                             const BalBadge = ({ value, size = "md" }) => {
//                                 const isNeg = value < 0;
//                                 return (
//                                     <Box sx={{ display: "inline-flex", alignItems: "center", gap: "3px", px: size === "sm" ? "8px" : "10px", py: size === "sm" ? "2px" : "4px", borderRadius: "7px", background: isNeg ? "#FFF0F0" : FB_LIGHT, border: `1px solid ${isNeg ? "#FFCDD2" : "#BBDEFB"}`, flexShrink: 0 }}>
//                                         <Typography sx={{ fontSize: size === "sm" ? 11 : 12, fontWeight: 700, color: isNeg ? "#C62828" : FB, fontVariantNumeric: "tabular-nums" }}>
//                                             ₹ {fmt(Math.abs(value))}
//                                         </Typography>
//                                         {isNeg && <Typography sx={{ fontSize: 9, fontWeight: 700, color: "#C62828", textTransform: "uppercase", letterSpacing: ".3px" }}>Dr</Typography>}
//                                     </Box>
//                                 );
//                             };

//                             // ── PAGE: GROUPS ─────────────────────────────────────────
//                             if (groupwisePage === "groups") {
//                                 let srNo = 0;
//                                 return (
//                                     <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>

//                                         {/* Title bar */}
//                                         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.5, background: `linear-gradient(90deg, ${FB} 0%, #1a5fce 100%)` }}>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                                                 <Typography sx={{ fontSize: 15, fontWeight: 700, color: WHITE }}>Groupwise Summary</Typography>
//                                                 <Box sx={{ px: "8px", py: "2px", background: "rgba(255,255,255,0.18)", borderRadius: "6px", display: { xs: "none", sm: "block" } }}>
//                                                     <Typography sx={{ fontSize: 11, color: WHITE, fontWeight: 600 }}>{totalSubGroups} sub-groups · {totalClients} clients</Typography>
//                                                 </Box>
//                                             </Box>
//                                             <BalBadge value={grandTotal} />
//                                         </Box>

//                                         <Table size="small" sx={{ tableLayout: "fixed" }}>
//                                             <TableHead>
//                                                 <TableRow sx={{ background: FB_LIGHT }}>
//                                                     <TableCell sx={{ width: 40, fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2, display: { xs: "none", sm: "table-cell" } }}>#</TableCell>
//                                                     <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2 }}>Sub Group</TableCell>
//                                                     <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pr: 2 }}>Balance (₹)</TableCell>
//                                                 </TableRow>
//                                             </TableHead>
//                                             <TableBody>
//                                                 {groups.map((group) => (
//                                                     <>
//                                                         {/* Group header row */}
//                                                         <TableRow key={`grp-${group.groupName}`} sx={{ background: G200 }}>
//                                                             <TableCell sx={{ display: { xs: "none", sm: "table-cell" }, borderBottom: `1px solid ${G300}`, py: "7px", pl: 2 }} />
//                                                             <TableCell sx={{ borderBottom: `1px solid ${G300}`, py: "7px", pl: 2 }}>
//                                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                                     <Box sx={{ width: 3, height: 16, background: G700, borderRadius: 1, flexShrink: 0 }} />
//                                                                     <Typography sx={{ fontSize: 12, fontWeight: 700, color: G900, textTransform: "uppercase", letterSpacing: ".3px" }}>{group.groupName}</Typography>
//                                                                     <Box sx={{ display: { xs: "none", sm: "flex" }, px: "6px", py: "1px", background: G300, borderRadius: "4px" }}>
//                                                                         <Typography sx={{ fontSize: 10, fontWeight: 700, color: G700 }}>{group.subGroups.length} sub-group{group.subGroups.length !== 1 ? "s" : ""}</Typography>
//                                                                     </Box>
//                                                                 </Box>
//                                                             </TableCell>
//                                                             <TableCell align="right" sx={{ borderBottom: `1px solid ${G300}`, py: "7px", pr: 2 }}>
//                                                                 <BalBadge value={group.totalBalance} size="sm" />
//                                                             </TableCell>
//                                                         </TableRow>

//                                                         {/* Sub-group rows */}
//                                                         {group.subGroups.map((sg, sgIdx) => {
//                                                             srNo++;
//                                                             return (
//                                                                 <TableRow key={sg.subGrpName}
//                                                                     onClick={() => {
//                                                                         setSelectedSubGroup({ groupName: group.groupName, ...sg });
//                                                                         setGroupwisePage("clients");
//                                                                     }}
//                                                                     sx={{ cursor: "pointer", background: sgIdx % 2 === 0 ? WHITE : "#FAFBFD",
//                                                                         "& td": { borderBottom: `1px solid ${G200}` },
//                                                                         "& td:first-of-type": { borderLeft: `3px solid transparent` },
//                                                                         "&:hover td": { background: "#EEF4FF" },
//                                                                         "&:hover td:first-of-type": { borderLeft: `3px solid ${FB}` },
//                                                                     }}
//                                                                 >
//                                                                     <TableCell sx={{ display: { xs: "none", sm: "table-cell" }, py: 1.25, pl: 2, color: G500, fontSize: 12 }}>{srNo}</TableCell>
//                                                                     <TableCell sx={{ py: 1.25, pl: 2 }}>
//                                                                         <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{sg.subGrpName}</Typography>
//                                                                     </TableCell>
//                                                                     <TableCell align="right" sx={{ py: 1.25, pr: 2 }}>
//                                                                         <BalBadge value={sg.totalBalance} size="sm" />
//                                                                     </TableCell>
//                                                                 </TableRow>
//                                                             );
//                                                         })}
//                                                     </>
//                                                 ))}

//                                                 {/* Grand Total row */}
//                                                 <TableRow sx={{ background: FB_LIGHT, "& td": { borderTop: `2px solid ${G300}`, borderBottom: "none", py: 1.5 } }}>
//                                                     <TableCell sx={{ display: { xs: "none", sm: "table-cell" }, pl: 2 }} />
//                                                     <TableCell sx={{ pl: 2 }}>
//                                                         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                             <Box sx={{ width: 3, height: 18, background: FB, borderRadius: 1, flexShrink: 0 }} />
//                                                             <Typography sx={{ fontSize: 12, fontWeight: 700, color: G900 }}>Grand Total</Typography>
//                                                             <Typography sx={{ fontSize: 11, color: G500, display: { xs: "none", sm: "block" } }}>· {groups.length} group{groups.length !== 1 ? "s" : ""} · {totalSubGroups} sub-groups</Typography>
//                                                         </Box>
//                                                     </TableCell>
//                                                     <TableCell align="right" sx={{ pr: 2 }}>
//                                                         <BalBadge value={grandTotal} />
//                                                     </TableCell>
//                                                 </TableRow>
//                                             </TableBody>
//                                         </Table>
//                                     </Box>
//                                 );
//                             }

//                             // ── PAGE: CLIENTS (after clicking a SubGrpName) ──────────
//                             if (groupwisePage === "clients" && selectedSubGroup) {
//                                 return (
//                                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>

//                                         {/* Breadcrumb / Back header */}
//                                         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//                                                 <Button onClick={() => { setGroupwisePage("groups"); setSelectedSubGroup(null); }}
//                                                     startIcon={<ArrowBackIcon sx={{ fontSize: 15 }} />}
//                                                     sx={{ ...btnGhostSx, height: 32, px: 1.5, fontSize: 12 }}>
//                                                     Back
//                                                 </Button>
//                                                 <Box sx={{ width: 1, height: 20, background: G300, mx: 0.5 }} />
//                                                 <Typography sx={{ fontSize: 12, color: G500 }}>Groupwise Summary</Typography>
//                                                 <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
//                                                 <Typography sx={{ fontSize: 12, color: G700 }}>{selectedSubGroup.groupName}</Typography>
//                                                 <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
//                                                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: FB }}>{selectedSubGroup.subGrpName}</Typography>
//                                             </Box>
//                                             <BalBadge value={selectedSubGroup.totalBalance} />
//                                         </Box>

//                                         {/* Sub-group summary cards */}
//                                         <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, 1fr)" }, gap: 1.5 }}>
//                                             {[
//                                                 { label: "Group", text: selectedSubGroup.groupName },
//                                                 { label: "Clients", num: selectedSubGroup.clients.length },
//                                                 { label: "Total Balance", badge: selectedSubGroup.totalBalance },
//                                             ].map(({ label, text, num, badge }) => (
//                                                 <Box key={label} sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.5, display: "flex", flexDirection: "column", gap: "4px" }}>
//                                                     <Typography sx={{ fontSize: 11, color: G500, fontWeight: 500, textTransform: "uppercase", letterSpacing: ".4px" }}>{label}</Typography>
//                                                     {badge !== undefined
//                                                         ? <BalBadge value={badge} />
//                                                         : <Typography sx={{ fontSize: text ? 13 : 20, fontWeight: 700, color: G900, lineHeight: 1 }}>{text ?? num}</Typography>
//                                                     }
//                                                 </Box>
//                                             ))}
//                                         </Box>

//                                         {/* Client list */}
//                                         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden" }}>
//                                             <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: "8px", background: `linear-gradient(90deg, ${FB_LIGHT} 0%, #F0F7FF 100%)`, borderBottom: `1px solid ${G300}` }}>
//                                                 <Typography sx={{ fontSize: 10, fontWeight: 700, color: G700, letterSpacing: ".5px", textTransform: "uppercase" }}>Client Name</Typography>
//                                                 <Typography sx={{ fontSize: 10, fontWeight: 700, color: G700, letterSpacing: ".5px", textTransform: "uppercase" }}>Balance (₹)</Typography>
//                                             </Box>

//                                             {selectedSubGroup.clients.length === 0 ? (
//                                                 <Box sx={{ py: "2rem", textAlign: "center" }}>
//                                                     <Typography sx={{ fontSize: 13, color: G500 }}>No clients in this sub-group.</Typography>
//                                                 </Box>
//                                             ) : selectedSubGroup.clients.map((client, cIdx) => (
//                                                 <Box key={client.clientId}
//                                                     onClick={() => {
//                                                         setSelectedClientForMonthly(client);
//                                                         setGroupwisePage("monthly");
//                                                         if (!expandedClients[client.clientId]) {
//                                                             fetchClientMonthlyClosing(client.clientId);
//                                                         }
//                                                     }}
//                                                     sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: "11px", cursor: "pointer", background: cIdx % 2 === 0 ? WHITE : "#FAFAFA", borderBottom: cIdx < selectedSubGroup.clients.length - 1 ? `1px solid ${G200}` : "none", borderLeft: "3px solid transparent", transition: "all .15s",
//                                                         "&:hover": { background: "#EEF4FF", borderLeft: `3px solid #5C9BD4` },
//                                                     }}
//                                                 >
//                                                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
//                                                         <Box sx={{ width: 20, height: 20, borderRadius: "5px", background: G200, border: `1px solid ${G300}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//                                                             <Typography sx={{ fontSize: 12, color: G700, fontWeight: 700, lineHeight: 1 }}>›</Typography>
//                                                         </Box>
//                                                         <Typography sx={{ fontSize: 13, fontWeight: 500, color: G700 }}>{client.clientName}</Typography>
//                                                     </Box>
//                                                     <BalBadge value={Number(client.balance || 0)} size="sm" />
//                                                 </Box>
//                                             ))}
//                                         </Box>
//                                     </Box>
//                                 );
//                             }

//                             // ── PAGE: MONTHLY CLOSING (after clicking a client) ───────
//                             if (groupwisePage === "monthly" && selectedClientForMonthly) {
//                                 const cState = expandedClients[selectedClientForMonthly.clientId];
//                                 const cLoading = cState?.loading;
//                                 const months = cState?.months || [];

//                                 const getMonthDateRange = (monthStr) => {
//                                     const [year, month] = monthStr.split("-").map(Number);
//                                     const fromDate = `${year}-${String(month).padStart(2, "0")}-01`;
//                                     const lastDay = new Date(year, month, 0).getDate();
//                                     const toDate = `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
//                                     return { fromDate, toDate };
//                                 };

//                                 return (
//                                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//                                         {/* Breadcrumb / Back header */}
//                                         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//                                                 <Button onClick={() => { setGroupwisePage("clients"); setSelectedClientForMonthly(null); }}
//                                                     startIcon={<ArrowBackIcon sx={{ fontSize: 15 }} />}
//                                                     sx={{ ...btnGhostSx, height: 32, px: 1.5, fontSize: 12 }}>
//                                                     Back
//                                                 </Button>
//                                                 <Box sx={{ width: 1, height: 20, background: G300, mx: 0.5 }} />
//                                                 <Typography sx={{ fontSize: 12, color: G500 }}>Groupwise Summary</Typography>
//                                                 <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
//                                                 <Typography sx={{ fontSize: 12, color: G700 }}>{selectedSubGroup?.subGrpName}</Typography>
//                                                 <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
//                                                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: FB }}>{selectedClientForMonthly.clientName}</Typography>
//                                             </Box>
//                                             <BalBadge value={Number(selectedClientForMonthly.balance || 0)} />
//                                         </Box>

//                                         {/* Monthly data table */}
//                                         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
//                                             {cLoading ? (
//                                                 <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
//                                                     <CircularProgress sx={{ color: FB }} />
//                                                     <Typography sx={{ color: G500, fontSize: 13 }}>Loading monthly data…</Typography>
//                                                 </Box>
//                                             ) : months.length > 0 ? (
//                                                 <Table size="small" sx={{ tableLayout: "fixed" }}>
//                                                     <TableHead>
//                                                         <TableRow sx={{ background: FB_LIGHT }}>
//                                                             <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2 }}>Month</TableCell>
//                                                             <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25 }}>Debit (₹)</TableCell>
//                                                             <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25 }}>Credit (₹)</TableCell>
//                                                             <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pr: 2 }}>Closing (₹)</TableCell>
//                                                         </TableRow>
//                                                     </TableHead>
//                                                     <TableBody>
//                                                         {months.map((m, mIdx) => (
//                                                             <TableRow key={m.Month}
//                                                                 onClick={() => {
//                                                                     const { fromDate, toDate } = getMonthDateRange(m.Month);
//                                                                     setSelectedMonthForLedger({ ...m, fromDate, toDate });
//                                                                     setGroupwisePage("ledger");
//                                                                     fetchMonthLedger(selectedClientForMonthly.clientId, fromDate, toDate);
//                                                                 }}
//                                                                 sx={{ cursor: "pointer", background: mIdx % 2 === 0 ? WHITE : "#FAFBFD", transition: "all .15s",
//                                                                     "&:hover": { background: "#EEF4FF" },
//                                                                     "& td": { borderBottom: `1px solid ${G200}`, py: 1.25 },
//                                                                 }}
//                                                             >
//                                                                 <TableCell sx={{ pl: 2 }}>
//                                                                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                                         <CalendarTodayOutlinedIcon sx={{ fontSize: 13, color: G500 }} />
//                                                                         <Typography sx={{ fontSize: 13, fontWeight: 600, color: G900 }}>{m.MonthName} {m.Month?.split("-")[0]}</Typography>
//                                                                     </Box>
//                                                                 </TableCell>
//                                                                 <TableCell align="right">
//                                                                     <Typography sx={{ fontSize: 12, color: "#C62828", fontVariantNumeric: "tabular-nums", fontWeight: 500 }}>{fmt(Number(m.TotalDebit || 0))}</Typography>
//                                                                 </TableCell>
//                                                                 <TableCell align="right">
//                                                                     <Typography sx={{ fontSize: 12, color: FB, fontVariantNumeric: "tabular-nums", fontWeight: 500 }}>{fmt(Number(m.TotalCredit || 0))}</Typography>
//                                                                 </TableCell>
//                                                                 <TableCell align="right" sx={{ pr: 2 }}>
//                                                                     <BalBadge value={Number(m.ClosingBalance || 0)} size="sm" />
//                                                                 </TableCell>
//                                                             </TableRow>
//                                                         ))}
//                                                         {/* Totals footer row */}
//                                                         <TableRow sx={{ background: FB_LIGHT, "& td": { borderTop: `2px solid ${G300}`, borderBottom: "none", py: 1.5 } }}>
//                                                             <TableCell sx={{ pl: 2 }}>
//                                                                 <Typography sx={{ fontSize: 12, fontWeight: 700, color: FB }}>Total ({months.length} month{months.length !== 1 ? "s" : ""})</Typography>
//                                                             </TableCell>
//                                                             <TableCell align="right">
//                                                                 <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#C62828", fontVariantNumeric: "tabular-nums" }}>{fmt(months.reduce((s, m) => s + Number(m.TotalDebit || 0), 0))}</Typography>
//                                                             </TableCell>
//                                                             <TableCell align="right">
//                                                                 <Typography sx={{ fontSize: 12, fontWeight: 700, color: FB, fontVariantNumeric: "tabular-nums" }}>{fmt(months.reduce((s, m) => s + Number(m.TotalCredit || 0), 0))}</Typography>
//                                                             </TableCell>
//                                                             <TableCell align="right" sx={{ pr: 2 }}>
//                                                                 <BalBadge value={Number(selectedClientForMonthly.balance || 0)} />
//                                                             </TableCell>
//                                                         </TableRow>
//                                                     </TableBody>
//                                                 </Table>
//                                             ) : (
//                                                 <Box sx={{ py: "2.5rem", textAlign: "center" }}>
//                                                     <Typography sx={{ fontSize: 13, color: G500 }}>No monthly closing data available.</Typography>
//                                                 </Box>
//                                             )}
//                                         </Box>
//                                     </Box>
//                                 );
//                             }

//                             // ── PAGE: MONTH LEDGER (after clicking a month row) ───────
//                             if (groupwisePage === "ledger" && selectedMonthForLedger && selectedClientForMonthly) {
//                                 const opValue = Number(monthLedgerData?.openingBalance?.absValue || 0);
//                                 const opType = monthLedgerData?.openingBalance?.type || "Dr";
//                                 const displayRows = (() => {
//                                     if (!monthLedgerData?.details) return [];
//                                     const openingRow = {
//                                         id: "opening-balance",
//                                         docDate: fmtDate(selectedMonthForLedger.fromDate) || "—",
//                                         salePurchaseAC: "—",
//                                         docNo: "—",
//                                         bookName: "OPBAL",
//                                         debit: opType === "Dr" ? opValue : 0,
//                                         credit: opType === "Cr" ? opValue : 0,
//                                         remark: "",
//                                         balance: opValue,
//                                         balanceType: opType,
//                                         isOpeningRow: true,
//                                     };
//                                     return [openingRow, ...monthLedgerData.details];
//                                 })();

//                                 return (
//                                     <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>

//                                         {/* Breadcrumb / Back header */}
//                                         <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
//                                             <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
//                                                 <Button onClick={() => { setGroupwisePage("monthly"); setSelectedMonthForLedger(null); setMonthLedgerData(null); }}
//                                                     startIcon={<ArrowBackIcon sx={{ fontSize: 15 }} />}
//                                                     sx={{ ...btnGhostSx, height: 32, px: 1.5, fontSize: 12 }}>
//                                                     Back
//                                                 </Button>
//                                                 <Box sx={{ width: 1, height: 20, background: G300, mx: 0.5 }} />
//                                                 <Typography sx={{ fontSize: 12, color: G500 }}>{selectedClientForMonthly.clientName}</Typography>
//                                                 <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
//                                                 <Typography sx={{ fontSize: 13, fontWeight: 700, color: FB }}>{selectedMonthForLedger.MonthName} {selectedMonthForLedger.Month?.split("-")[0]}</Typography>
//                                             </Box>
//                                             <Typography sx={{ fontSize: 11, color: G500 }}>{fmtDate(selectedMonthForLedger.fromDate)} – {fmtDate(selectedMonthForLedger.toDate)}</Typography>
//                                         </Box>

//                                         {monthLedgerLoading ? (
//                                             <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2, background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px" }}>
//                                                 <CircularProgress sx={{ color: FB }} />
//                                                 <Typography sx={{ color: G500, fontSize: 13 }}>Loading ledger entries…</Typography>
//                                             </Box>
//                                         ) : monthLedgerData ? (
//                                             <>
//                                                 {/* KPI Strip */}
//                                                 {monthLedgerData.details && monthLedgerData.details.length > 0 && (
//                                                     <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
//                                                         <Box sx={{ display: "flex", px: { xs: 2, sm: 3 }, py: 1.5, overflowX: "auto" }}>
//                                                             {[
//                                                                 { label: "ENTRIES", value: String(monthLedgerData.summary?.totalTransactions || monthLedgerData.details.length) },
//                                                                 { label: "TOTAL DEBIT", value: `₹ ${fmt(monthLedgerData.summary?.totalDebit || 0)}` },
//                                                                 { label: "TOTAL CREDIT", value: `₹ ${fmt(monthLedgerData.summary?.totalCredit || 0)}` },
//                                                                 { label: "CLOSING BALANCE", value: `${fmt(Number(monthLedgerData.closingBalance?.absValue || 0))} ${monthLedgerData.closingBalance?.type || "Dr"}`, accent: true },
//                                                             ].map((item, i, arr) => (
//                                                                 <Box key={i} sx={{ pr: { xs: 2.5, sm: 3.5 }, pl: i === 0 ? 0 : { xs: 2.5, sm: 3.5 }, borderRight: i < arr.length - 1 ? `1px solid ${G300}` : "none", flexShrink: 0 }}>
//                                                                     <Typography sx={{ fontSize: 10, fontWeight: 700, color: G500, textTransform: "uppercase", letterSpacing: ".6px", lineHeight: 1, mb: "4px" }}>{item.label}</Typography>
//                                                                     <Typography sx={{ fontSize: 16, fontWeight: 700, color: item.accent ? FB : G900, fontFamily: "monospace", lineHeight: 1 }}>{item.value}</Typography>
//                                                                 </Box>
//                                                             ))}
//                                                         </Box>
//                                                     </Box>
//                                                 )}

//                                                 {/* DataGrid — same columns as General Ledger */}
//                                                 <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
//                                                     {displayRows.length > 0 ? (
//                                                         <DataGrid
//                                                             rows={displayRows}
//                                                             columns={columns}
//                                                             autoHeight
//                                                             rowHeight={44}
//                                                             getRowId={(row) => row.id}
//                                                             disableRowSelectionOnClick
//                                                             pageSizeOptions={[25, 50, 100]}
//                                                             initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
//                                                             slots={{ noResultsOverlay: CustomNoDataOverlay }}
//                                                             sx={dgSx}
//                                                         />
//                                                     ) : (
//                                                         <Box sx={{ py: "2.5rem" }}>
//                                                             <NoDataComponent />
//                                                         </Box>
//                                                     )}
//                                                 </Box>
//                                             </>
//                                         ) : (
//                                             <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
//                                                 <Typography sx={{ fontSize: 14, color: G500 }}>No ledger data available.</Typography>
//                                             </Box>
//                                         )}
//                                     </Box>
//                                 );
//                             }

//                             return null;
//                         })() : (
//                             <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
//                                 <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
//                             </Box>
//                         )}
//                     </Box>
//                 )}

//             </Box>{/* end content area */}

//             {/* ── Smart Filter Dialog ──────────────────────────────────────────── */}
//             <SmartFilterDialog
//                 open={filterOpen}
//                 onClose={() => setFilterOpen(false)}
//                 allClients={allClients}
//                 itemGroupsLoading={false}
//                 tempFromDate={tempFromDate}
//                 setTempFromDate={setTempFromDate}
//                 tempToDate={tempToDate}
//                 setTempToDate={setTempToDate}
//                 tempClientSearchText={tempClientSearchText}
//                 setTempClientSearchText={handleTempClientSearch}
//                 tempSelectedClients={tempSelectedClients}
//                 setTempSelectedClients={setTempSelectedClients}
//                 filteredTempClients={filteredTempClients}
//                 handleTempSelectAll={() => setTempSelectedClients(filteredTempClients)}
//                 handleTempDeselectAll={() => setTempSelectedClients([])}
//                 handleTempClientCheckbox={handleTempClientCheckbox}
//                 loading={loading}
//                 onGetData={handleViewSelectedLedgers}
//                 tempReportType={tempReportType}
//                 setTempReportType={setTempReportType}
//                 selectedBookNames={selectedBookNames}
//                 setSelectedBookNames={setSelectedBookNames}
//                 selectedBankAccount={selectedBankAccount}
//                 setSelectedBankAccount={setSelectedBankAccount}
//                 bankAccounts={bankAccounts}
//                 bankAccountsLoading={bankAccountsLoading}
//                 isDaywise={isDaywise}
//                 setIsDaywise={setIsDaywise}
//             />

//             {/* ── Snackbar ─────────────────────────────────────────────────────── */}
//             <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
//                 <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }








import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography, Paper, useTheme, useMediaQuery, Button, Snackbar, Alert, CircularProgress, TextField, Grid, Chip, Tabs, Tab, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, FormControlLabel, MenuItem, Select, FormControl, InputLabel, Autocomplete, Accordion, AccordionSummary, AccordionDetails, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import useDataLoadingState from "../hooks/useDataLoadingState";
import LoadingSpinner from "../components/Common/LoadingSpinner";
import CustomNoDataOverlay from "../components/CustomNoDataOverlay";
import NoDataComponent from "../components/NoDataComponent";
import SearchIcon from '@mui/icons-material/Search';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GetAppIcon from '@mui/icons-material/GetApp';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from 'recharts';
import { FB, FB_DARK, FB_LIGHT, FB_MID, SURFACE, BG, BORDER, T1, T2, RED_BG, RED_FG, GRN_BG, GRN_FG, G200, G300, G500, G700, G900, WHITE, CARD_SHADOW, CARD_HOVER, REPORT_TYPES, BOOK_NAMES, cardSx, btnOutlineSx, btnGhostSx, btnPrimarySx, inputSx, selectSx, dgSx, } from "./ReportDetailsConstants";
import { StatCard, TabPanel, getBalanceColor, getBalanceBgColor, getFinancialYearDates, fmt, fmtDate, getAmountColumnLabels, } from "./LedgerDetailsHelpers";
import SmartFilterDialog from "./SmartFilterLedgerDetails";

const ThreeDBar = ({ x, y, width, height, fill }) => {
    if (!height || height <= 0) return null;
    const dx = 18, dy = 9;
    const gid = `b3d-${Math.round(x)}-${Math.round(y)}`;
    return (
        <g>
            <defs>
                <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="white" stopOpacity={0.28} />
                    <stop offset="100%" stopColor="white" stopOpacity={0} />
                </linearGradient>
            </defs>
            <rect x={x} y={y} width={width} height={height} fill={fill} />
            <rect x={x} y={y} width={width} height={height} fill={`url(#${gid})`} />
            <path d={`M${x},${y} L${x + dx},${y - dy} L${x + width + dx},${y - dy} L${x + width},${y} Z`} fill={fill} />
            <path d={`M${x},${y} L${x + dx},${y - dy} L${x + width + dx},${y - dy} L${x + width},${y} Z`} fill="white" opacity={0.58} />
            <path d={`M${x + width},${y} L${x + width + dx},${y - dy} L${x + width + dx},${y + height - dy} L${x + width},${y + height} Z`} fill={fill} />
            <path d={`M${x + width},${y} L${x + width + dx},${y - dy} L${x + width + dx},${y + height - dy} L${x + width},${y + height} Z`} fill="black" opacity={0.38} />
            <line x1={x} y1={y} x2={x + dx} y2={y - dy} stroke="white" strokeWidth={1.2} opacity={0.7} />
            <line x1={x + dx} y1={y - dy} x2={x + width + dx} y2={y - dy} stroke="white" strokeWidth={1.2} opacity={0.7} />
            <line x1={x + width + dx} y1={y - dy} x2={x + width + dx} y2={y + height - dy} stroke="white" strokeWidth={0.8} opacity={0.3} />
        </g>
    );
};

const BLOCK_H = 16;
const BLOCK_GAP = 2;
const AnimatedBlockBar = ({ x, y, width, height, fill }) => {
    if (!width || !height || height <= 0) return null;
    const dx = 18, dy = 9;
    const blockCount = Math.max(1, Math.round(height / (BLOCK_H + BLOCK_GAP)));
    const blockH = (height - (blockCount - 1) * BLOCK_GAP) / blockCount;
    return (
        <g>
            {Array.from({ length: blockCount }, (_, i) => {
                const blockY = y + height - (i + 1) * (blockH + BLOCK_GAP) + BLOCK_GAP;
                const begin = `${i * 120}ms`;
                const isTop = i === blockCount - 1;
                return (
                    <g key={i} opacity="0">
                        <animate attributeName="opacity" from="0" to="1" dur="0.05s" begin={begin} fill="freeze" />
                        <animateTransform attributeName="transform" type="translate"
                            values="0 -80; 0 5; 0 -2; 0 0"
                            keyTimes="0; 0.65; 0.83; 1"
                            dur="0.75s" begin={begin} fill="freeze" />
                        <rect x={x} y={blockY} width={width} height={blockH} fill={fill} />
                        <rect x={x} y={blockY} width={width} height={2} fill="white" opacity={0.25} />
                        {isTop && (
                            <>
                                <path d={`M${x},${blockY} L${x+dx},${blockY-dy} L${x+width+dx},${blockY-dy} L${x+width},${blockY} Z`} fill={fill} />
                                <path d={`M${x},${blockY} L${x+dx},${blockY-dy} L${x+width+dx},${blockY-dy} L${x+width},${blockY} Z`} fill="white" opacity={0.58} />
                            </>
                        )}
                        <path d={`M${x+width},${blockY} L${x+width+dx},${blockY-dy} L${x+width+dx},${blockY+blockH-dy} L${x+width},${blockY+blockH} Z`} fill={fill} />
                        <path d={`M${x+width},${blockY} L${x+width+dx},${blockY-dy} L${x+width+dx},${blockY+blockH-dy} L${x+width},${blockY+blockH} Z`} fill="black" opacity={0.28} />
                    </g>
                );
            })}
            {(() => {
                const topBlockY = y + height - blockCount * (blockH + BLOCK_GAP) + BLOCK_GAP;
                const begin = `${(blockCount - 1) * 120}ms`;
                return (
                    <g opacity="0">
                        <animate attributeName="opacity" from="0" to="0.7" dur="0.05s" begin={begin} fill="freeze" />
                        <animateTransform attributeName="transform" type="translate"
                            values="0 -80; 0 5; 0 -2; 0 0"
                            keyTimes="0; 0.65; 0.83; 1"
                            dur="0.75s" begin={begin} fill="freeze" />
                        <line x1={x} y1={topBlockY} x2={x+dx} y2={topBlockY-dy} stroke="white" strokeWidth={1.2} />
                        <line x1={x+dx} y1={topBlockY-dy} x2={x+width+dx} y2={topBlockY-dy} stroke="white" strokeWidth={1.2} />
                    </g>
                );
            })()}
        </g>
    );
};

// ─── Main Component ───────────────────────────────────────────────────────────
export default function LedgerDetails({ connectionString, pdfString, initialReportType, openFilterTrigger }) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down(500));
    const { user, selectedCompany } = useAuth();

    // ── View Mode State ──────────────────────────────────────────────────────
    const [viewMode, setViewMode] = useState("filter"); // 'filter', 'detail'

    // ── Filter Dialog State ──────────────────────────────────────────────────
    const [filterOpen, setFilterOpen] = useState(false);
    const [allClients, setAllClients] = useState([]);
    const [tempClientSearchText, setTempClientSearchText] = useState("");
    const [filteredTempClients, setFilteredTempClients] = useState([]);
    const [tempSelectedClients, setTempSelectedClients] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState(null);

    // ── NEW: Report Type State ───────────────────────────────────────────────
    const [tempReportType, setTempReportType] = useState("general_ledger");
    const [appliedReportType, setAppliedReportType] = useState("general_ledger");

    // ── Bank Book States ──────────────────────────────────────────────────────
    const [selectedBookNames, setSelectedBookNames] = useState([]);
    const [selectedBankAccount, setSelectedBankAccount] = useState('');
    const [bankAccounts, setBankAccounts] = useState([]);
    const [bankAccountsLoading, setBankAccountsLoading] = useState(false);
    const [bankBookData, setBankBookData] = useState(null);
    const [isDaywise, setIsDaywise] = useState(false);

    // ── Cash Book State ───────────────────────────────────────────────────────
    const [cashBookData, setCashBookData] = useState(null);

    // ── Day Book State ────────────────────────────────────────────────────────
    const [dayBookData, setDayBookData] = useState(null);
    const [dayBookView, setDayBookView] = useState("month"); // 'month' | 'day' | 'all'

    // ── Groupwise Summary State ───────────────────────────────────────────────
    const [groupwiseSummaryData, setGroupwiseSummaryData] = useState(null);
    const [expandedSubGroups, setExpandedSubGroups] = useState({});
    const [expandedClients, setExpandedClients] = useState({});
    const [groupwisePage, setGroupwisePage] = useState("groups"); // "groups" | "clients" | "monthly" | "ledger"
    const [selectedSubGroup, setSelectedSubGroup] = useState(null);
    const [selectedClientForMonthly, setSelectedClientForMonthly] = useState(null);
    const [selectedMonthForLedger, setSelectedMonthForLedger] = useState(null);
    const [monthLedgerData, setMonthLedgerData] = useState(null);
    const [monthLedgerLoading, setMonthLedgerLoading] = useState(false);

    // ── Detail View State ────────────────────────────────────────────────────
    const [selectedClients, setSelectedClients] = useState([]);
    const [ledgerDataMap, setLedgerDataMap] = useState({});
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success", });
    const [activeTab, setActiveTab] = useState(0);
    const [dateFilters, setDateFilters] = useState({});

    // ── Temp Filter Dialog State ─────────────────────────────────────────────
    const getTodayDate = () => new Date().toISOString().split("T")[0];
    const [tempFromDate, setTempFromDate] = useState(getTodayDate());
    const [tempToDate, setTempToDate] = useState(getTodayDate());

    const [pdfLoading, setPdfLoading] = useState(false);
    const [graphPdfLoading, setGraphPdfLoading] = useState(false);

    // ── Sale VS Purchase State ────────────────────────────────────────────────
    const [allSalesAccountClients, setAllSalesAccountClients] = useState([]);
    const [salesClientsLoading, setSalesClientsLoading] = useState(false);
    const [allPurchaseAccountClients, setAllPurchaseAccountClients] = useState([]);
    const [purchaseClientsLoading, setPurchaseClientsLoading] = useState(false);
    const [tempSelectedSalesClients, setTempSelectedSalesClients] = useState([]);
    const [tempSelectedPurchaseClients, setTempSelectedPurchaseClients] = useState([]);
    const [salesClientSearchText, setSalesClientSearchText] = useState("");
    const [purchaseClientSearchText, setPurchaseClientSearchText] = useState("");
    const [salesVsPurchaseData, setSalesVsPurchaseData] = useState(null);
    const [salesVsPurchaseLoading, setSalesVsPurchaseLoading] = useState(false);
    const [showSalesVsGraph, setShowSalesVsGraph] = useState(false);
    const [showPurchaseVsGraph, setShowPurchaseVsGraph] = useState(false);
    const [saleGraphAnimKey, setSaleGraphAnimKey] = useState(0);
    const [incVsExpGraphAnimKey, setIncVsExpGraphAnimKey] = useState(0);

    // ── Inc. VS Exp. State ───────────────────────────────────────────────────
    const [allIncomeAccountClients, setAllIncomeAccountClients] = useState([]);
    const [incomeClientsLoading, setIncomeClientsLoading] = useState(false);
    const [allExpenseAccountClients, setAllExpenseAccountClients] = useState([]);
    const [expenseClientsLoading, setExpenseClientsLoading] = useState(false);
    const [tempSelectedIncomeClients, setTempSelectedIncomeClients] = useState([]);
    const [tempSelectedExpenseClients, setTempSelectedExpenseClients] = useState([]);
    const [incomeClientSearchText, setIncomeClientSearchText] = useState("");
    const [expenseClientSearchText, setExpenseClientSearchText] = useState("");
    const [incVsExpData, setIncVsExpData] = useState(null);
    const [incVsExpLoading, setIncVsExpLoading] = useState(false);
    const [showIncVsExpGraph, setShowIncVsExpGraph] = useState(false);

    const companyId = selectedCompany?.CompId;

    // ── API: Fetch All Clients ───────────────────────────────────────────────
    const fetchAllClients = async () => {
        try {
            const { fromDate: fyFromDate, toDate: fyToDate } = getFinancialYearDates();
            const params = { compId: companyId, fromDate: fyFromDate, toDate: fyToDate, reportType: "with_parties", };
            const res = await axios.get(`${connectionString}/api/getLedgerData`, { params });
            console.log(res);
            if (res.data && res.data.parties) {
                const sortedClients = res.data.parties.sort((a, b) =>
                    a.FirmName.localeCompare(b.FirmName)
                );
                setAllClients(sortedClients);
                setFilteredTempClients(sortedClients);
            }
        } catch (err) {
            console.error("Clients fetch error:", err);
            setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch clients", severity: "error", });
        }
    };

    // ── Fetch Bank Accounts ──────────────────────────────────────────────────
    const fetchBankAccounts = async () => {
        try {
            setBankAccountsLoading(true);
            const res = await axios.get(`${connectionString}/api/getBankAccounts`, {
                params: { companyId }
            });
            const accountsData = res.data?.data || res.data?.accounts || res.data || [];
            const formattedAccounts = Array.isArray(accountsData)
                ? accountsData.map(account => ({
                    id: account.id || account.AccountId || account.accountId,
                    AccountName: account.accountName || account.AccountName || account.name || '',
                    AccountNumber: account.AccountNumber || account.accountNumber || account.number || ''
                }))
                : [];
            setBankAccounts(formattedAccounts);
        } catch (err) {
            console.error("Bank accounts fetch error:", err);
            setBankAccounts([]);
            setSnackbar({ open: true, message: "Failed to fetch bank accounts", severity: "error" });
        } finally {
            setBankAccountsLoading(false);
        }
    };

    // ── Fetch Sales Account Clients ──────────────────────────────────────────
    const fetchSalesAccountClients = async () => {
        try {
            setSalesClientsLoading(true);
            const res = await axios.get(`${connectionString}/api/mis/sales-accounts-clients`, {
                params: { companyId: companyId, reportType: "sales" }
            });
            if (res.data?.success && Array.isArray(res.data.data)) {
                setAllSalesAccountClients(res.data.data || []);
            } else {
                setAllSalesAccountClients([]);
            }
        } catch (err) {
            console.error("Sales account clients fetch error:", err);
            setAllSalesAccountClients([]);
        } finally {
            setSalesClientsLoading(false);
        }
    };

    // ── Fetch Purchase Account Clients ───────────────────────────────────────
    const fetchPurchaseAccountClients = async () => {
        try {
            setPurchaseClientsLoading(true);
            const res = await axios.get(`${connectionString}/api/mis/sales-accounts-clients`, {
                params: { companyId: companyId, reportType: "purchase" }
            });
            if (res.data && res.data.data) {
                setAllPurchaseAccountClients(res.data.data.map(r => ({ id: r.id, FirmName: r.FirmName, AccGrpID: r.AccGrpID })));
            }
        } catch (err) {
            console.error("Purchase account clients fetch error:", err);
            setAllPurchaseAccountClients([]);
        } finally {
            setPurchaseClientsLoading(false);
        }
    };

    // ── Fetch Income Account Clients ─────────────────────────────────────────
    const fetchIncomeAccountClients = async () => {
        try {
            setIncomeClientsLoading(true);
            const res = await axios.get(`${connectionString}/api/mis/sales-accounts-clients`, {
                params: { companyId: companyId, reportType: "income" }
            });
            if (res.data && res.data.data) {
                setAllIncomeAccountClients(res.data.data || []);
            } else {
                setAllIncomeAccountClients([]);
            }
        } catch (err) {
            console.error("Income account clients fetch error:", err);
            setAllIncomeAccountClients([]);
        } finally {
            setIncomeClientsLoading(false);
        }
    };

    // ── Fetch Expense Account Clients ────────────────────────────────────────
    const fetchExpenseAccountClients = async () => {
        try {
            setExpenseClientsLoading(true);
            const res = await axios.get(`${connectionString}/api/mis/sales-accounts-clients`, {
                params: { companyId: companyId, reportType: "expense" }
            });
            if (res.data && res.data.data) {
                setAllExpenseAccountClients(res.data.data || []);
            } else {
                setAllExpenseAccountClients([]);
            }
        } catch (err) {
            console.error("Expense account clients fetch error:", err);
            setAllExpenseAccountClients([]);
        } finally {
            setExpenseClientsLoading(false);
        }
    };

    // ── Fetch Bank Book Statement ────────────────────────────────────────────
    const fetchBankBookStatement = async (bankAccountName, fromDateVal, toDateVal) => {
        const res = await axios.get(`${connectionString}/api/bankbook-statement`, {
            params: { bankAc: bankAccountName, fromDate: fromDateVal, toDate: toDateVal, compId: companyId, bookNames: selectedBookNames.join(","), },
        });
        return res.data;
    };

    // ── Fetch Cash Book Statement (NEW) ──────────────────────────────────────
    const fetchCashBookStatement = async (fromDateVal, toDateVal) => {
        const res = await axios.get(`${connectionString}/api/cashbook-statement`, {
            params: { compId: companyId, fromDate: fromDateVal, toDate: toDateVal, bookNames: selectedBookNames.join(","), },
        });
        return res.data;
    };

    // ── Fetch Groupwise Summary ───────────────────────────────────────────────
    const fetchGroupwiseSummary = async (fromDateVal, toDateVal) => {
        const res = await axios.get(`${connectionString}/api/LedgerGroupwisesummary`, {
            params: { companyId: companyId, fromDate: fromDateVal, toDate: toDateVal, },
        });
        console.log(res);
        return res.data;
    };

    // ── Fetch Client Monthly Closing ──────────────────────────────────────────
    const fetchClientMonthlyClosing = async (clientId) => {
        setExpandedClients((prev) => ({
            ...prev,
            [clientId]: { loading: true, months: prev[clientId]?.months || [] },
        }));
        try {
            const res = await axios.get(`${connectionString}/api/LedgerClientMonthlyClosing`, {
                params: {
                    clientId,
                    companyId,
                    fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
                    toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
                },
            });
            console.log(res);
            setExpandedClients((prev) => ({
                ...prev,
                [clientId]: { loading: false, months: res.data?.data || [] },
            }));
        } catch (err) {
            console.error("Monthly closing fetch error:", err);
            setExpandedClients((prev) => ({
                ...prev,
                [clientId]: { loading: false, months: [] },
            }));
        }
    };

    // ── Fetch Month Ledger (Groupwise drill-down) ─────────────────────────────
    const fetchMonthLedger = async (clientId, fromDate, toDate) => {
        setMonthLedgerLoading(true);
        setMonthLedgerData(null);
        try {
            const params = { compId: companyId, partyId: clientId, fromDate, toDate };
            const res = await axios.get(`${connectionString}/api/getLedgerData`, { params });
            if (res.data) {
                const detailsData = (res.data.details || []).map((item) => ({
                    id: item.gLId,
                    docDate: item.docDate,
                    docNo: item.docNo,
                    bookName: item.bookName,
                    salePurchaseAC: item.salePurchaseAC || "—",
                    debit: item.debit,
                    credit: item.credit,
                    remark: item.remark,
                    balance: item.runningBalance,
                    balanceType: item.balanceType,
                    opBal: item.opBal,
                }));
                const transformedDetails = detailsData.map(r => {
                    if (r.bookName === "OPBAL") {
                        const opBal = Number(r.opBal || 0);
                        return {
                            ...r,
                            debit: opBal < 0 ? Math.abs(opBal) : 0,
                            credit: opBal > 0 ? opBal : 0,
                            balance: Math.abs(opBal),
                            balanceType: opBal < 0 ? "Dr" : "Cr",
                        };
                    }
                    return r;
                });
                const closingBalanceValue = transformedDetails.length > 0
                    ? Number(transformedDetails[transformedDetails.length - 1].balance || 0)
                    : Number(res.data.closingBalance?.closingBal || 0);
                const closingBalanceType = transformedDetails.length > 0
                    ? transformedDetails[transformedDetails.length - 1].balanceType || "Dr"
                    : res.data.closingBalance?.type || "Dr";
                setMonthLedgerData({
                    openingBalance: res.data.openingBalance || {},
                    closingBalance: { closingBal: String(closingBalanceValue), absValue: String(closingBalanceValue), type: closingBalanceType },
                    details: transformedDetails,
                    summary: res.data.summary || {},
                });
            }
        } catch (err) {
            console.error("Month ledger fetch error:", err);
            setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
            setMonthLedgerData(null);
        } finally {
            setMonthLedgerLoading(false);
        }
    };

    // ── Fetch Day Book Statement ──────────────────────────────────────────────
    const fetchDayBookStatement = async (fromDateVal, toDateVal) => {
        const res = await axios.get(`${connectionString}/api/daybook-statement`, {
            params: {
                compId: companyId,
                fromDate: fromDateVal,
                toDate: toDateVal,
                bookNames: selectedBookNames.join(","),
            },
        });
        console.log(res)
        return res.data;
    };

    // ─── Direct PDF Export Handler ────────────────────────────────────────────
    const handleExportPDF = async () => {
        // When called from Groupwise Summary ledger stage, delegate to the dedicated handler
        if (groupwisePage === "ledger" && monthLedgerData && selectedClientForMonthly) {
            return handleExportMonthLedgerPDF();
        }
        try {
            setPdfLoading(true);
            let allEntries = [];
            let totalClientDebit = 0;
            let totalClientCredit = 0;
            let clientSummaries = [];

            const printDate = new Date().toISOString().split("T")[0];

            selectedClients.forEach((client) => {
                const clientData = ledgerDataMap[client.id];

                if (clientData && clientData.details) {
                    const opValue = Number(clientData.openingBalance?.absValue || 0);
                    const opType = clientData.openingBalance?.type || "Dr";

                    // clientData.details may or may not include an API-provided OPBAL row (depends on
                    // whether the party has an explicit opening-balance record), so summing it directly
                    // is unreliable — exclude any such row and add the opening balance back in exactly
                    // once, on whichever side (debit/credit) it belongs.
                    const periodDetails = clientData.details.filter((r) => r.bookName !== "OPBAL");

                    const clientDebit = periodDetails.reduce(
                        (sum, item) => sum + Number(item.debit || 0),
                        0
                    ) + (opType === "Dr" ? opValue : 0);

                    const clientCredit = periodDetails.reduce(
                        (sum, item) => sum + Number(item.credit || 0),
                        0
                    ) + (opType === "Cr" ? opValue : 0);

                    const opbalEntry = {
                        clientName: client.FirmName,
                        clientCode: client.ClientCode,
                        date: dateFilters[client.id]?.fromDate || "—",
                        particulars: "OPBAL",
                        remark: "",
                        BookName: "OPBAL",
                        salePurchaseAC: "—",
                        DocNo: "—",
                        debit: opType === "Dr" ? opValue : 0,
                        credit: opType === "Cr" ? opValue : 0,
                        balance: opValue,
                        balanceType: opType,
                        clientTotalDebit: clientDebit,
                        clientTotalCredit: clientCredit,
                        srNo: 0,
                        isOpeningRow: true,
                    };

                    const clientEntries = [opbalEntry, ...periodDetails.map((r, idx) => ({
                        clientName: client.FirmName,
                        clientCode: client.ClientCode,
                        date: r.docDate,
                        particulars: r.bookName || "",
                        remark: r.remark || "",
                        BookName: r.bookName || "",
                        salePurchaseAC: r.salePurchaseAC || "—",
                        DocNo: r.docNo || "",
                        debit: Number(r.debit || 0),
                        credit: Number(r.credit || 0),
                        balance: r.balance,
                        balanceType: r.balanceType,
                        clientTotalDebit: clientDebit,
                        clientTotalCredit: clientCredit,
                        srNo: idx + 1,
                    }))];

                    allEntries = [...allEntries, ...clientEntries];
                    totalClientDebit += clientDebit;
                    totalClientCredit += clientCredit;

                    clientSummaries.push({
                        firmName: client.FirmName,
                        clientCode: client.ClientCode,
                        openingBalance: clientData.openingBalance.opBal || 0,
                        openingType: clientData.openingBalance.type || "Dr",
                        closingBalance: clientData.closingBalance.closingBal || 0,
                        closingType: clientData.closingBalance.type || "Dr",
                        totalDebit: clientDebit,
                        totalCredit: clientCredit,
                        entries: clientData.details.length,
                    });
                }
            });

            const pdfResp = await axios.post(
                `${pdfString}/api/ledger-pdf/general-ledger`,
                {
                    docId: "general-ledger",
                    userId: user?.UserId || "usr1",
                    data: {
                        reportType: "General Ledger",
                        accountName: `General Ledger - ${selectedClients.length} Clients`,
                        fromDate: dateFilters[selectedClients[0].id]?.fromDate || getFinancialYearDates().fromDate,
                        toDate: dateFilters[selectedClients[0].id]?.toDate || getFinancialYearDates().toDate,
                        printDate,
                        entries: allEntries,
                        clientSummaries: clientSummaries,
                        totalDebit: totalClientDebit,
                        totalCredit: totalClientCredit,
                        totalClients: selectedClients.length,
                    },
                    company: selectedCompany
                        ? {
                            CompId: selectedCompany.CompId,
                            CompanyName: selectedCompany.CompanyName || "",
                            Address: selectedCompany.Address || "",
                            MobileNo: selectedCompany.MobileNo || "",
                            GSTIN: selectedCompany.GSTNo || "",
                        }
                        : {},
                },
                { responseType: "blob" }
            );

            const w = window.open(
                URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" })),
                "_blank"
            );
            if (w) w.focus();
        } catch (err) {
            console.error("PDF Error:", err);
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally {
            setPdfLoading(false);
        }
    };

    // ✅ NEW FUNCTION - BankBook PDF Export Handler
    const handleExportBankBookPDF = async () => {
        try {
            setPdfLoading(true);

            const account = bankAccounts.find((a) => a.id === selectedBankAccount);

            if (!account) {
                setSnackbar({
                    open: true,
                    message: "Bank account not found",
                    severity: "error"
                });
                return;
            }

            const printDate = new Date().toISOString().split("T")[0];

            // ── Map details to a clean, consistent format for PDF ──────────────
            const mappedEntries = (bankBookData?.details || []).map((row) => ({
                clientName: account.AccountName,
                date: row.docDate || row.DocDate || "—",
                salePurchaseAC: row.salePurchaseAC || row.AccName || "—",
                DocNo: row.docNo || "",
                BookName: row.bookName || row.BookName || "—",
                debit: Number(row.debit || row.Debit || 0),
                credit: Number(row.credit || row.Credit || 0),
                remark: row.remark || row.Remark || "",
                balance: Number(row.balance || row.RunningBalance || 0),
                balanceType: row.balanceType || row.BalanceType || "Dr",
            }));

            const pdfResp = await axios.post(
                `${pdfString}/api/ledger-pdf/bank-book`,
                {
                    docId: "bank-book",
                    userId: user?.UserId || "usr1",
                    data: {
                        reportType: "Bank Book",
                        bankAccountName: account.AccountName,
                        bankAccountNo: account.AccountNumber || "",
                        fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
                        toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
                        printDate,
                        openingBalance: bankBookData?.openingBalance?.opBal || 0,
                        openingType: bankBookData?.openingBalance?.type || "Dr",
                        closingBalance: bankBookData?.closingBalance?.closingBal || 0,
                        closingType: bankBookData?.closingBalance?.type || "Dr",
                        totalDebit: bankBookData?.summary?.totalDebit || 0,
                        totalCredit: bankBookData?.summary?.totalCredit || 0,
                        totalRecords: bankBookData?.summary?.totalRecords || mappedEntries.length,
                        entries: mappedEntries,
                        isDaywise: isDaywise,
                        summary: bankBookData?.summary || {},
                    },
                    company: selectedCompany
                        ? {
                            CompId: selectedCompany.CompId,
                            CompanyName: selectedCompany.CompanyName || "",
                            Address: selectedCompany.Address || "",
                            MobileNo: selectedCompany.MobileNo || "",
                            GSTIN: selectedCompany.GSTNo || "",
                        }
                        : {},
                },
                { responseType: "blob" }
            );

            const url = URL.createObjectURL(
                new Blob([pdfResp.data], { type: "application/pdf" })
            );
            const w = window.open(url, "_blank");
            if (w) w.focus();

        } catch (err) {
            console.error("BankBook PDF Error:", err);
            setSnackbar({
                open: true,
                message: "Failed to generate bank book PDF",
                severity: "error"
            });
        } finally {
            setPdfLoading(false);
        }
    };

    const handleExportCashBookPDF = async () => {
        try {
            setPdfLoading(true);

            const printDate = new Date().toISOString().split("T")[0];

            const activeClient = cashBookData?.clients?.[activeTab];
            const activeClientName = activeClient?.clientInfo?.FirmName || "Cash Book";

            const mappedEntries = (cashBookData?.details || []).map((row) => ({
                clientName: activeClientName,  // ← CHANGED: use actual client name
                date: row.docDate || "—",
                salePurchaseAC: row.salePurchaseAC || "—",
                DocNo: row.docNo || "",
                BookName: row.bookName || "—",
                debit: Number(row.debit || 0),
                credit: Number(row.credit || 0),
                remark: row.remark || "",
                balance: Number(row.balance || 0),
                balanceType: row.balanceType || "Dr",
            }));

            const pdfResp = await axios.post(
                `${pdfString}/api/ledger-pdf/bank-book`,
                {
                    docId: "bank-book",
                    userId: user?.UserId || "usr1",
                    data: {
                        reportType: "Cash Book",
                        bankAccountName: "Cash Book",
                        bankAccountNo: "",
                        fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
                        toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
                        printDate,
                        openingBalance: cashBookData?.clients?.[activeTab]?.openingBalance?.opBal || 0,
                        openingType: cashBookData?.clients?.[activeTab]?.openingBalance?.type || "Dr",
                        closingBalance: cashBookData?.clients?.[activeTab]?.closingBalance?.closingBal || 0,
                        closingType: cashBookData?.clients?.[activeTab]?.closingBalance?.type || "Dr",
                        totalDebit: cashBookData?.clients?.[activeTab]?.summary?.totalDebit || 0,
                        totalCredit: cashBookData?.clients?.[activeTab]?.summary?.totalCredit || 0,
                        totalRecords: mappedEntries.length,
                        entries: mappedEntries,
                        isDaywise: isDaywise,
                        summary: cashBookData?.clients?.[activeTab]?.summary || {},
                    },
                    company: selectedCompany
                        ? {
                            CompId: selectedCompany.CompId,
                            CompanyName: selectedCompany.CompanyName || "",
                            Address: selectedCompany.Address || "",
                            MobileNo: selectedCompany.MobileNo || "",
                            GSTIN: selectedCompany.GSTNo || "",
                        }
                        : {},
                },
                { responseType: "blob" }
            );

            const url = URL.createObjectURL(
                new Blob([pdfResp.data], { type: "application/pdf" })
            );
            const w = window.open(url, "_blank");
            if (w) w.focus();

        } catch (err) {
            console.error("CashBook PDF Error:", err);
            setSnackbar({
                open: true,
                message: "Failed to generate cash book PDF",
                severity: "error"
            });
        } finally {
            setPdfLoading(false);
        }
    };



    const handleExportDayBookPDF = async () => {

        try {
            setPdfLoading(true);

            const printDate =
                new Date().toISOString().split("T")[0];

            // ✅ DATE NORMALIZER

            const normalizeDate = (inputDate) => {
                if (!inputDate) { return "—"; }

                const raw = String(inputDate).trim();

                if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
                    const [y, m, d] = raw.split("-");
                    return `${d}-${m}-${y}`;
                }

                if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) {
                    return raw;
                }

                if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {

                    return raw.replace(/\//g, "-");
                }

                const dt = new Date(raw);

                if (!isNaN(dt.getTime())) {

                    const d = String(dt.getDate()).padStart(2, "0");
                    const m = String(dt.getMonth() + 1).padStart(2, "0");
                    const y = dt.getFullYear();

                    return `${d}-${m}-${y}`;
                }

                return raw;
            };

            // ✅ NORMALIZE ROWS

            const mapRows = (rows, type) =>

                (rows || []).map((row) => ({
                    partyName: row.partyName || row.PartyName || "—",
                    date: normalizeDate(row.docDate || row.DocDate || row.date || ""),
                    salePurchaseAC: row.salePurchaseAC || row.AccName || "—",
                    DocNo: row.docNo || row.DocNo || "",
                    BookName: row.bookName || row.BookName || "—",
                    debit: Number(row.debit || row.Debit || 0),
                    credit: Number(row.credit || row.Credit || 0),
                    remark: row.remark || row.Remark || "",
                    type,
                }));

            // ✅ RAW ROWS

            const incomeRows = mapRows(dayBookData?.incomeRows, "income");
            const expenseRows = mapRows(dayBookData?.expenseRows, "expense");

            // ✅ UNIQUE DATES

            const allDates = [
                ...new Set([
                    ...incomeRows.map(r => r.date),
                    ...expenseRows.map(r => r.date),
                ])
            ].sort((a, b) => {

                const [da, ma, ya] = a.split(/[-\/]/).map(Number);
                const [db, mb, yb] = b.split(/[-\/]/).map(Number);

                return (new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db));
            });

            // ✅ GROUP DATE WISE

            // ✅ GROUP DATE WISE
            const groupedEntries = allDates.map((date) => {

                const incomeEntries = incomeRows.filter(r => r.date === date);
                const expenseEntries = expenseRows.filter(r => r.date === date);

                // Calculate income total: check both debit and credit, take whichever has value
                const incomeTotal = incomeEntries.reduce((s, r) => {
                    const val = Number(r.debit || 0) > 0 ? Number(r.debit || 0) : Number(r.credit || 0);
                    return s + val;
                }, 0);

                // Calculate expense total: check both credit and debit, take whichever has value
                const expenseTotal = expenseEntries.reduce((s, r) => {
                    const val = Number(r.credit || 0) > 0 ? Number(r.credit || 0) : Number(r.debit || 0);
                    return s + val;
                }, 0);

                return { date, incomeEntries, expenseEntries, incomeTotal, expenseTotal, };
            });

            const payload = {
                docId: "day-book",
                userId: user?.UserId || "usr1",
                data: {
                    reportType: "Day Book",
                    fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
                    toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
                    printDate,
                    groupedEntries,
                    totalIncome: groupedEntries.reduce((s, g) => s + g.incomeTotal, 0),
                    totalExpense: groupedEntries.reduce((s, g) => s + g.expenseTotal, 0),
                    totalExpenseRecords: dayBookData?.expenseSummary?.totalRecords || 0,
                    totalIncomeRecords: dayBookData?.incomeSummary?.totalRecords || 0,
                    expenseSummary: dayBookData?.expenseSummary || {},
                    incomeSummary: dayBookData?.incomeSummary || {},
                },

                company: selectedCompany
                    ? {
                        CompId: selectedCompany.CompId,
                        CompanyName: selectedCompany.CompanyName || "",
                        Address: selectedCompany.Address || "",
                        MobileNo: selectedCompany.MobileNo || "",
                        GSTIN: selectedCompany.GSTNo || "",
                    }
                    : {},
            };

            // ✅ PRINT COMPLETE PAYLOAD
            console.log("DAY BOOK PDF PAYLOAD =>", payload);
            const pdfResp = await axios.post(`${pdfString}/api/ledger-pdf/day-book`, payload, { responseType: "blob" });

            const url = URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" }));

            const w = window.open(url, "_blank");
            if (w) { w.focus(); }
        } catch (err) {
            console.error("DayBook PDF Error:", err);
            setSnackbar({ open: true, message: "Failed to generate day book PDF", severity: "error", });
        } finally {
            setPdfLoading(false);
        }
    };

    // ── Shared PDF open helper ────────────────────────────────────────────────
    const openPdfBlob = (blob) => {
        const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
        const w = window.open(url, "_blank");
        if (w) w.focus();
    };

    const companyPayload = selectedCompany
        ? { CompId: selectedCompany.CompId, CompanyName: selectedCompany.CompanyName || "", Address: selectedCompany.Address || "", MobileNo: selectedCompany.MobileNo || "", GSTIN: selectedCompany.GSTNo || "" }
        : {};

    // ── Level 1: Groupwise Summary PDF (all groups) ───────────────────────────
    const handleExportGroupwiseSummaryPDF = async () => {
        try {
            setPdfLoading(true);
            const printDate = new Date().toISOString().split("T")[0];

            // Build groups in the format expected by renderGroupwiseSummaryPages
            let srCounter = 0;
            const pdfGroups = Object.values(groupwiseSummaryData || {}).map((grp) => {
                const subGroups = Object.values(grp.subGroups || {}).map((sg) => {
                    srCounter++;
                    const bal = (sg.clients || []).reduce((s, c) => s + Number(c.balance || 0), 0);
                    return {
                        srNo: srCounter,
                        name: sg.subGroupName || "",
                        balance: Math.abs(bal),
                        balanceType: bal >= 0 ? "Cr" : "Dr",
                    };
                });
                const grpBal = subGroups.reduce((s, sg) => s + (sg.balanceType === "Dr" ? sg.balance : -sg.balance), 0);
                return {
                    groupName: grp.groupName || "",
                    subGroupCount: subGroups.length,
                    balance: Math.abs(grpBal),
                    balanceType: grpBal >= 0 ? "Cr" : "Dr",
                    subGroups,
                };
            });

            const grandBalRaw = Object.values(groupwiseSummaryData || {}).reduce((s, grp) =>
                s + Object.values(grp.subGroups || {}).reduce((ss, sg) =>
                    ss + (sg.clients || []).reduce((sss, c) => sss + Number(c.balance || 0), 0), 0), 0);

            const pdfGrandTotal = {
                balance: Math.abs(grandBalRaw),
                balanceType: grandBalRaw >= 0 ? "Cr" : "Dr",
                groupCount: pdfGroups.length,
                subGroupCount: srCounter,
            };

            const pdfResp = await axios.post(
                `${pdfString}/api/ledger-pdf/groupwise-summary`,
                {
                    docId: "groupwise-summary",
                    userId: user?.UserId || "usr1",
                    data: {
                        reportType: "Groupwise Summary",
                        fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
                        toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
                        printDate,
                        groups: pdfGroups,
                        grandTotal: pdfGrandTotal,
                    },
                    company: companyPayload,
                },
                { responseType: "blob" }
            );
            openPdfBlob(pdfResp.data);
        } catch (err) {
            console.error("GroupwiseSummary PDF Error:", err);
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally {
            setPdfLoading(false);
        }
    };

    // ── Level 2: Sub-group clients PDF ────────────────────────────────────────
    const handleExportClientsPagePDF = async () => {
        if (!selectedSubGroup) return;
        try {
            setPdfLoading(true);
            const printDate = new Date().toISOString().split("T")[0];
            const pdfGroups = [{
                groupName: selectedSubGroup.groupName,
                clientCount: selectedSubGroup.clients.length,
                totalBalance: Math.abs(selectedSubGroup.totalBalance),
                balanceType: selectedSubGroup.totalBalance >= 0 ? "Dr" : "Cr",
                subGroups: [{
                    subGroupName: selectedSubGroup.subGrpName,
                    clients: selectedSubGroup.clients.map((c) => ({
                        name: c.clientName || "",
                        balance: Math.abs(Number(c.balance || 0)),
                        balanceType: Number(c.balance || 0) >= 0 ? "Dr" : "Cr",
                    })),
                }],
            }];
            const pdfResp = await axios.post(
                `${pdfString}/api/ledger-pdf/groupwise-summary-client`,
                {
                    docId: "groupwise-summary-client",
                    userId: user?.UserId || "usr1",
                    data: {
                        reportTitle: `${selectedSubGroup.groupName} — ${selectedSubGroup.subGrpName}`,
                        fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
                        toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
                        printDate,
                        groups: pdfGroups,
                    },
                    company: companyPayload,
                },
                { responseType: "blob" }
            );
            openPdfBlob(pdfResp.data);
        } catch (err) {
            console.error("Clients PDF Error:", err);
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally {
            setPdfLoading(false);
        }
    };

    // ── Level 3: Client monthly closing PDF ───────────────────────────────────
    const handleExportMonthlyPagePDF = async () => {
        if (!selectedClientForMonthly) return;
        const cState = expandedClients[selectedClientForMonthly.clientId];
        const months = cState?.months || [];
        if (!months.length) return;
        try {
            setPdfLoading(true);
            const printDate = new Date().toISOString().split("T")[0];

            const totalDebit = months.reduce((s, m) => s + Number(m.TotalDebit || 0), 0);
            const totalCredit = months.reduce((s, m) => s + Number(m.TotalCredit || 0), 0);
            const closingBal = Number(selectedClientForMonthly.balance || 0);

            const pdfGroups = [{
                groupName: selectedSubGroup?.groupName || "",
                totalBalance: Math.abs(closingBal),
                balanceType: closingBal >= 0 ? "Dr" : "Cr",
                subGroups: [{
                    subGroupName: selectedSubGroup?.subGrpName || "",
                    clients: [{
                        name: selectedClientForMonthly.clientName || "",
                        months: months.map((m) => ({
                            month: `${m.MonthName} ${m.Month?.split("-")[0]}`,
                            debit: Number(m.TotalDebit || 0),
                            credit: Number(m.TotalCredit || 0),
                            closing: Math.abs(Number(m.ClosingBalance || 0)),
                            closingType: Number(m.ClosingBalance || 0) >= 0 ? "Dr" : "Cr",
                        })),
                        total: {
                            monthCount: months.length,
                            debit: totalDebit,
                            credit: totalCredit,
                            closing: Math.abs(closingBal),
                            closingType: closingBal >= 0 ? "Dr" : "Cr",
                        },
                    }],
                }],
            }];

            const pdfResp = await axios.post(
                `${pdfString}/api/ledger-pdf/groupwise-summary-month`,
                {
                    docId: "groupwise-summary-month",
                    userId: user?.UserId || "usr1",
                    data: {
                        reportTitle: `${selectedClientForMonthly.clientName} — Monthly Closing`,
                        fromDate: appliedFilters?.fromDate || getFinancialYearDates().fromDate,
                        toDate: appliedFilters?.toDate || getFinancialYearDates().toDate,
                        printDate,
                        groups: pdfGroups,
                    },
                    company: companyPayload,
                },
                { responseType: "blob" }
            );
            openPdfBlob(pdfResp.data);
        } catch (err) {
            console.error("Monthly PDF Error:", err);
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally {
            setPdfLoading(false);
        }
    };

    // ── Level 4: Month ledger PDF (reuses general-ledger endpoint) ────────────
    const handleExportMonthLedgerPDF = async () => {
        if (!monthLedgerData || !selectedClientForMonthly) return;
        try {
            setPdfLoading(true);
            const printDate = new Date().toISOString().split("T")[0];
            const opValue = Number(monthLedgerData.openingBalance?.absValue || 0);
            const opType = monthLedgerData.openingBalance?.type || "Dr";

            // monthLedgerData.details may or may not include an API-provided OPBAL row, so summing it
            // directly is unreliable — exclude any such row and add the opening balance back in exactly
            // once, on whichever side (debit/credit) it belongs.
            const periodDetails = (monthLedgerData.details || []).filter((r) => r.bookName !== "OPBAL");
            const clientDebit = periodDetails.reduce((s, r) => s + Number(r.debit || 0), 0) + (opType === "Dr" ? opValue : 0);
            const clientCredit = periodDetails.reduce((s, r) => s + Number(r.credit || 0), 0) + (opType === "Cr" ? opValue : 0);
            const opbalEntry = {
                clientName: selectedClientForMonthly.clientName,
                clientCode: "",
                date: selectedMonthForLedger?.fromDate || "—",
                particulars: "OPBAL",
                remark: "",
                BookName: "OPBAL",
                salePurchaseAC: "—",
                DocNo: "—",
                debit: opType === "Dr" ? opValue : 0,
                credit: opType === "Cr" ? opValue : 0,
                balance: opValue,
                balanceType: opType,
                clientTotalDebit: clientDebit,
                clientTotalCredit: clientCredit,
                srNo: 0,
                isOpeningRow: true,
            };
            const entries = [opbalEntry, ...periodDetails.map((r, idx) => ({
                clientName: selectedClientForMonthly.clientName,
                clientCode: "",
                date: r.docDate,
                particulars: r.bookName || "",
                remark: r.remark || "",
                BookName: r.bookName || "",
                salePurchaseAC: r.salePurchaseAC || "—",
                DocNo: r.docNo || "",
                debit: Number(r.debit || 0),
                credit: Number(r.credit || 0),
                balance: r.balance,
                balanceType: r.balanceType,
                clientTotalDebit: clientDebit,
                clientTotalCredit: clientCredit,
                srNo: idx + 1,
            }))];
            const pdfResp = await axios.post(
                `${pdfString}/api/ledger-pdf/general-ledger`,
                {
                    docId: "general-ledger",
                    userId: user?.UserId || "usr1",
                    data: {
                        reportType: "General Ledger",
                        accountName: `${selectedClientForMonthly.clientName} — ${selectedMonthForLedger?.MonthName} ${selectedMonthForLedger?.Month?.split("-")[0]}`,
                        fromDate: selectedMonthForLedger?.fromDate || getFinancialYearDates().fromDate,
                        toDate: selectedMonthForLedger?.toDate || getFinancialYearDates().toDate,
                        printDate,
                        entries,
                        clientSummaries: [{
                            firmName: selectedClientForMonthly.clientName,
                            clientCode: "",
                            openingBalance: monthLedgerData.openingBalance?.opBal || 0,
                            openingType: monthLedgerData.openingBalance?.type || "Dr",
                            closingBalance: monthLedgerData.closingBalance?.closingBal || 0,
                            closingType: monthLedgerData.closingBalance?.type || "Dr",
                            totalDebit: clientDebit,
                            totalCredit: clientCredit,
                            entries: monthLedgerData.details?.length || 0,
                        }],
                        totalDebit: clientDebit,
                        totalCredit: clientCredit,
                        totalClients: 1,
                    },
                    company: companyPayload,
                },
                { responseType: "blob" }
            );
            openPdfBlob(pdfResp.data);
        } catch (err) {
            console.error("Month Ledger PDF Error:", err);
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally {
            setPdfLoading(false);
        }
    };

    // ── Client Search/Filter Handler ─────────────────────────────────────────
    const handleTempClientSearch = (searchText) => {
        setTempClientSearchText(searchText);
        if (searchText.trim() === "") {
            setFilteredTempClients(allClients);
        } else {
            const filtered = allClients.filter(
                (client) =>
                    (client.FirmName && client.FirmName.toLowerCase().includes(searchText.toLowerCase())) ||
                    (client.ClientCode && client.ClientCode.toLowerCase().includes(searchText.toLowerCase())) ||
                    (client.ContactPerson && client.ContactPerson.toLowerCase().includes(searchText.toLowerCase()))
            );
            setFilteredTempClients(filtered);
        }
    };

    // ── Checkbox Change Handler ──────────────────────────────────────────────
    const handleTempClientCheckbox = (client) => {
        setTempSelectedClients((prevSelected) => {
            const isSelected = prevSelected.some((c) => c.id === client.id);
            if (isSelected) {
                return prevSelected.filter((c) => c.id !== client.id);
            } else {
                return [...prevSelected, client];
            }
        });
    };

    // ── Fetch Party Detail ───────────────────────────────────────────────────
    const fetchPartyDetail = async (partyId, fromDateVal, toDateVal) => {
        try {
            const params = { compId: companyId, partyId: partyId, fromDate: fromDateVal, toDate: toDateVal, bookNames: selectedBookNames.join(","), };
            const res = await axios.get(`${connectionString}/api/getLedgerData`, { params });
            console.log("data:", res);
            if (res.data) {
                const detailsData = (res.data.details || []).map((item) => ({
                    id: item.gLId,
                    docDate: item.docDate,
                    docNo: item.docNo,
                    bookName: item.bookName,
                    salePurchaseAC: item.salePurchaseAC || "—",
                    debit: item.debit,
                    credit: item.credit,
                    remark: item.remark,
                    balance: item.runningBalance,
                    balanceType: item.balanceType,
                    opBal: item.opBal,
                }));
                const transformedDetails = detailsData.map(r => {
                    if (r.bookName === "OPBAL") {
                        const opBal = Number(r.opBal || 0);
                        return {
                            ...r,
                            debit: opBal < 0 ? Math.abs(opBal) : 0,
                            credit: opBal > 0 ? opBal : 0,
                            balance: Math.abs(opBal),
                            balanceType: opBal < 0 ? "Dr" : "Cr",
                        };
                    }
                    return r;
                });
                const closingBalanceValue = transformedDetails.length > 0
                    ? Number(transformedDetails[transformedDetails.length - 1].balance || 0)
                    : Number(res.data.closingBalance?.closingBal || 0);
                const closingBalanceType = transformedDetails.length > 0
                    ? transformedDetails[transformedDetails.length - 1].balanceType || "Dr"
                    : res.data.closingBalance?.type || "Dr";
                setLedgerDataMap((prev) => ({
                    ...prev,
                    [partyId]: {
                        openingBalance: res.data.openingBalance || {},
                        closingBalance: { closingBal: String(closingBalanceValue), absValue: String(closingBalanceValue), type: closingBalanceType },
                        details: transformedDetails,
                        summary: res.data.summary || {},
                    },
                }));
                setDateFilters((prev) => ({
                    ...prev,
                    [partyId]: prev[partyId] || {
                        fromDate: fromDateVal,
                        toDate: toDateVal,
                    },
                }));
            }
        } catch (err) {
            console.error("Party detail fetch error:", err);
            // setSnackbar({ open: true, message: err.response?.data?.error || "Failed to fetch party details", severity: "error", });
        }
    };

    // ── View Selected Ledgers Handler ────────────────────────────────────────
    const handleViewSelectedLedgers = async () => {
        // For General Ledger: if no client is selected, treat it as ALL clients selected
        const clientsToFetch =
            tempReportType === "general_ledger" && tempSelectedClients.length === 0
                ? allClients
                : tempSelectedClients;

        if (tempReportType === "general_ledger" && clientsToFetch.length === 0) {
            setSnackbar({ open: true, message: "No clients available", severity: "warning" });
            return;
        }

        try {
            setLoading(true);

            if (tempReportType === "general_ledger") {
                const promises = clientsToFetch.map((client) =>
                    fetchPartyDetail(client.id, tempFromDate, tempToDate)
                );
                await Promise.all(promises);
                setSelectedClients(clientsToFetch);

            } else if (tempReportType === "bank_book") {
                const account = bankAccounts.find((a) => a.id === selectedBankAccount);

                if (!account) {
                    setSnackbar({ open: true, message: "Selected bank account not found", severity: "error" });
                    return;
                }

                const data = await fetchBankBookStatement(account.AccountName, tempFromDate, tempToDate);

                const formattedBankBookData = {
                    ...data,
                    details: [
                        // ─── Opening Balance Row ─────────────────────
                        {
                            id: "opbal-row",
                            docDate: tempFromDate,
                            salePurchaseAC: "Opening Balance",
                            docNo: "-",
                            bookName: "OPBAL",
                            debit: data.openingBalance?.type === "Dr" ? Number(data.openingBalance?.absValue || 0) : 0,
                            credit: data.openingBalance?.type === "Cr" ? Number(data.openingBalance?.absValue || 0) : 0,
                            remark: `Opening Balance Before ${tempFromDate}`,
                            balance: Number(data.openingBalance?.absValue || 0),
                            balanceType: data.openingBalance?.type || "Dr",
                        },

                        // ─── Actual Transactions ─────────────────────
                        ...(data.data || []).map((item, index) => ({
                            id: item.gLId || index,
                            docDate: item.DocDate,
                            salePurchaseAC: item.AccName || "—",
                            docNo: item.DocNo,
                            bookName: item.BookName,
                            debit: item.Debit || 0,
                            credit: item.Credit || 0,
                            remark: item.Remark || "",
                            balance: item.RunningBalance || 0,
                            balanceType: item.BalanceType || "Dr",
                        })),
                    ],
                };

                setBankBookData(formattedBankBookData);
            } else if (tempReportType === "cash_book") {

                const data = await fetchCashBookStatement(
                    tempFromDate,
                    tempToDate
                );

                // ─── Flatten All Client Data With OPBAL Row ───────────────
                const allRows = (data.clients || []).flatMap((client) => {

                    const openingBal = client.openingBalance || {};

                    return [
                        // ─── Opening Balance Row ─────────────────────
                        {
                            id: `opbal-${client.clientInfo?.id}`,
                            docDate: tempFromDate,
                            salePurchaseAC: client.clientInfo?.FirmName || "Opening Balance",
                            docNo: "-",
                            bookName: "OPBAL",
                            debit: openingBal.type === "Dr" ? Number(openingBal.absValue || 0) : 0,
                            credit: openingBal.type === "Cr" ? Number(openingBal.absValue || 0) : 0,
                            remark: `Opening Balance Before ${tempFromDate}`,
                            balance: Number(openingBal.absValue || 0),
                            balanceType: openingBal.type || "Dr",
                        },

                        // ─── Actual Transactions ─────────────────────
                        ...(client.data || []).map((item, index) => ({
                            id: item.gLId || `${client.clientInfo?.id}-${index}`,
                            docDate: item.DocDate,
                            salePurchaseAC: item.AccName || "—",
                            docNo: item.DocNo,
                            bookName: item.BookName,
                            debit: item.Debit || 0,
                            credit: item.Credit || 0,
                            remark: item.Remark || "",
                            balance: item.RunningBalance || 0,
                            balanceType: item.BalanceType || "Dr",
                        })),
                    ];
                });

                setCashBookData({
                    ...data,
                    details: allRows,
                });
            } else if (tempReportType === "group_wise_summary") {

                const data = await fetchGroupwiseSummary(tempFromDate, tempToDate);
                setGroupwiseSummaryData(data.data || {});
                setExpandedSubGroups({});
                setExpandedClients({});
                setGroupwisePage("groups");
                setSelectedSubGroup(null);
                setSelectedClientForMonthly(null);
                setSelectedMonthForLedger(null);
                setMonthLedgerData(null);

            } else if (tempReportType === "day_book") {

                const data = await fetchDayBookStatement(tempFromDate, tempToDate);

                // Old labels + the labels saved by the Account Group master / seed
                // data (INCOME (EXPENSE) is how the seed data names Income (P & L)).
                const incomeNatures = ["Income (Trading)", "Income (P & L)", "INCOME (TRADING)", "INCOME (P & L)", "INCOME (EXPENSE)"];
                const expenseNatures = ["Expense (Trading)", "Expense (P & L)", "EXPENSE (TRADING)", "EXPENSE (P & L)"];

                const mapClientRows = (clients, prefix) =>
                    (clients || []).flatMap((client) =>
                        (client.data || []).map((item, index) => ({
                            id: `${prefix}-${item.gLId || index}-${client.clientInfo.id}`,
                            partyName: client.clientInfo.FirmName,
                            docDate: item.DocDate,
                            salePurchaseAC: item.AccName || "—",
                            docNo: item.DocNo,
                            bookName: item.BookName,
                            debit: item.Debit || 0,
                            credit: item.Credit || 0,
                            remark: item.Remark || "",
                            balance: item.RunningBalance || 0,
                            balanceType: item.BalanceType || "Dr",
                        }))
                    );

                const incomeClientsList = (data.clients || []).filter((c) => incomeNatures.includes(c.clientInfo.NatureOfGroup));
                const expenseClientsList = (data.clients || []).filter((c) => expenseNatures.includes(c.clientInfo.NatureOfGroup));

                setDayBookData({
                    clients: data.clients || [],
                    incomeRows: mapClientRows(incomeClientsList, "income"),
                    expenseRows: mapClientRows(expenseClientsList, "expense"),
                    incomeSummary: data.incomeSummary || { totalCredit: 0, totalDebit: 0, totalRecords: 0 },
                    expenseSummary: data.expenseSummary || { totalDebit: 0, totalCredit: 0, totalRecords: 0 },
                });
            } else if (tempReportType === "sale_vs_purchase") {
                setSalesVsPurchaseData(null);
                setSalesVsPurchaseLoading(true);
                try {
                    const saleClientIds = (tempSelectedSalesClients || []).map(c => c.id).join(',');
                    const purchaseClientIds = (tempSelectedPurchaseClients || []).map(c => c.id).join(',');
                    const res = await axios.get(`${connectionString}/api/mis/sales-purchase-monthly-report`, {
                        params: {
                            compId: companyId,
                            fromDate: tempFromDate,
                            toDate: tempToDate,
                            saleClientIds,
                            purchaseClientIds,
                        }
                    });
                    console.log(res.data);
                    setSalesVsPurchaseData(res.data || null);
                } catch (err) {
                    console.error("Sale VS Purchase report error:", err);
                    setSnackbar({ open: true, message: "Failed to fetch Sale VS Purchase data", severity: "error" });
                } finally {
                    setSalesVsPurchaseLoading(false);
                }
            } else if (tempReportType === "inc_vs_exp") {
                setIncVsExpData(null);
                setIncVsExpLoading(true);
                try {
                    const incomeClientIds = (tempSelectedIncomeClients || []).map(c => c.id).join(',');
                    const expenseClientIds = (tempSelectedExpenseClients || []).map(c => c.id).join(',');
                    const res = await axios.get(`${connectionString}/api/mis/income-expense-monthly-report`, {
                        params: {
                            compId: companyId,
                            fromDate: tempFromDate,
                            toDate: tempToDate,
                            incomeClientIds,
                            expenseClientIds,
                        }
                    });
                    console.log(res.data);
                    setIncVsExpData(res.data || null);
                } catch (err) {
                    console.error("Inc. VS Exp. report error:", err);
                    setSnackbar({ open: true, message: "Failed to fetch Inc. VS Exp. data", severity: "error" });
                } finally {
                    setIncVsExpLoading(false);
                }
            }

            setAppliedFilters({
                fromDate: tempFromDate,
                toDate: tempToDate,
                clientCount: tempReportType === "general_ledger" ? tempSelectedClients.length : 0,
                selectedBookNames: selectedBookNames.length > 0 ? selectedBookNames : null,
                selectedBankAccount: tempReportType === "bank_book" ? selectedBankAccount : null,
            });
            setAppliedReportType(tempReportType);
            setViewMode("detail");
            setActiveTab(0);
            setFilterOpen(false);
        } catch (err) {
            console.error("Error fetching selected ledgers:", err);
            setSnackbar({ open: true, message: "Failed to fetch ledger data", severity: "error" });
        } finally {
            setLoading(false);
        }
    };

    // ── Handle Back to Filter ───────────────────────────────────────────────
    const handleBackToFilter = () => {
        setViewMode("filter");
        setLedgerDataMap({});
        setDateFilters({});
        setActiveTab(0);
        setSelectedClients([]);
        setAppliedFilters(null);
        setTempClientSearchText("");
        setFilteredTempClients(allClients);
        setTempSelectedClients([]);
        setBankBookData(null);
        setCashBookData(null);
        setDayBookData(null);
        setGroupwiseSummaryData(null);
        setExpandedSubGroups({});
        setExpandedClients({});
        setGroupwisePage("groups");
        setSelectedSubGroup(null);
        setSelectedClientForMonthly(null);
        setSelectedMonthForLedger(null);
        setMonthLedgerData(null);
        setSalesVsPurchaseData(null);
    };

    // ── Handle Clear (reset to filter view) ─────────────────────────────────
    const handleClear = () => {
        setViewMode("filter");
        setLedgerDataMap({});
        setDateFilters({});
        setActiveTab(0);
        setSelectedClients([]);
        setAppliedFilters(null);
        setTempClientSearchText("");
        setFilteredTempClients(allClients);
        setTempSelectedClients([]);
        setBankBookData(null);
        setCashBookData(null);
        setDayBookData(null);
        setGroupwiseSummaryData(null);
        setExpandedSubGroups({});
        setExpandedClients({});
        setGroupwisePage("groups");
        setSelectedSubGroup(null);
        setSelectedClientForMonthly(null);
        setSelectedMonthForLedger(null);
        setMonthLedgerData(null);
        setSalesVsPurchaseData(null);
        setTempSelectedSalesClients([]);
        setTempSelectedPurchaseClients([]);
        setSalesClientSearchText("");
        setPurchaseClientSearchText("");
    };

    // ── Handle Tab Change ───────────────────────────────────────────────────
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // ── Get Current Tab Client ──────────────────────────────────────────────
    const getCurrentTabClient = () => {
        return selectedClients[activeTab] || null;
    };

    // ── Get Current Tab Data ────────────────────────────────────────────────
    const getCurrentTabData = () => {
        const client = getCurrentTabClient();
        return client ? ledgerDataMap[client.id] : null;
    };

    // ── Apply Filter for Current Tab ──────────────────────────────────────
    const handleApplyFilter = async () => {
        const client = getCurrentTabClient();
        if (!client) return;
        const fromDate = dateFilters[client.id]?.fromDate;
        const toDate = dateFilters[client.id]?.toDate;
        if (!fromDate || !toDate) {
            setSnackbar({ open: true, message: "Please select a date range", severity: "warning" });
            return;
        }
        if (new Date(fromDate) > new Date(toDate)) {
            setSnackbar({ open: true, message: "From Date must be before To Date", severity: "error" });
            return;
        }
        try {
            setLoading(true);
            await fetchPartyDetail(client.id, fromDate, toDate);
        } finally {
            setLoading(false);
        }
    };

    // ── Handle Date Filter Change ───────────────────────────────────────────
    const handleDateFilterChange = (clientId, field, value) => {
        setDateFilters((prev) => ({
            ...prev,
            [clientId]: {
                ...prev[clientId],
                [field]: value,
            },
        }));
    };

    // ── Sale VS Purchase Graph PDF Export ────────────────────────────────────
    const handleSaleVsPurchasePDF = async () => {
        setGraphPdfLoading(true);
        try {
            const docId = `sale-vs-purchase-${appliedFilters?.fromDate || "-"}-${appliedFilters?.toDate || "-"}`;
            const printDate = new Date().toISOString().split("T")[0];
            const pdfResp = await axios.post(
                `${pdfString}/api/graph-pdf/${docId}`,
                {
                    docId,
                    data: {
                        ...salesVsPurchaseData,
                        fromDate: appliedFilters?.fromDate || "",
                        toDate: appliedFilters?.toDate || "",
                        reportTitle: "Sale VS Purchase",
                        printDate,
                        reportType: "sale_vs_purchase",
                    },
                    company: selectedCompany
                        ? { CompId: selectedCompany.CompId, CompanyName: selectedCompany.CompanyName || "", Address: selectedCompany.Address || "", MobileNo: selectedCompany.MobileNo || "", EmailId: selectedCompany.EmailId || "", GSTNo: selectedCompany.GSTNo || "" }
                        : {},
                },
                { responseType: "blob" }
            );
            console.log(pdfResp);
            const w = window.open(
                URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" })),
                "_blank"
            );
            if (w) w.focus();
        } catch (err) {
            console.error("Sale VS Purchase PDF export error:", err);
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally {
            setGraphPdfLoading(false);
        }
    };

    // ── Inc. VS Exp. Graph PDF Export ────────────────────────────────────────
    const handleIncVsExpPDF = async () => {
        setGraphPdfLoading(true);
        try {
            const docId = `inc-vs-exp-${appliedFilters?.fromDate || "-"}-${appliedFilters?.toDate || "-"}`;
            const printDate = new Date().toISOString().split("T")[0];
            const pdfResp = await axios.post(
                `${pdfString}/api/graph-pdf/${docId}`,
                {
                    docId,
                    data: {
                        ...incVsExpData,
                        fromDate: appliedFilters?.fromDate || "",
                        toDate: appliedFilters?.toDate || "",
                        reportTitle: "Inc. VS Exp.",
                        printDate,
                        reportType: "inc_vs_exp",
                    },
                    company: selectedCompany
                        ? { CompId: selectedCompany.CompId, CompanyName: selectedCompany.CompanyName || "", Address: selectedCompany.Address || "", MobileNo: selectedCompany.MobileNo || "", EmailId: selectedCompany.EmailId || "", GSTNo: selectedCompany.GSTNo || "" }
                        : {},
                },
                { responseType: "blob" }
            );
            console.log(pdfResp);
            const w = window.open(
                URL.createObjectURL(new Blob([pdfResp.data], { type: "application/pdf" })),
                "_blank"
            );
            if (w) w.focus();
        } catch (err) {
            console.error("Inc. VS Exp. PDF export error:", err);
            setSnackbar({ open: true, message: "Failed to generate PDF", severity: "error" });
        } finally {
            setGraphPdfLoading(false);
        }
    };

    // ── Open Filter Dialog ───────────────────────────────────────────────────
    const handleOpenFilter = (overrideReportType) => {
        const rt = typeof overrideReportType === "string" ? overrideReportType : null;
        const finalRt = rt || appliedReportType || "general_ledger";
        const { fromDate: fyFromDate, toDate: fyToDate } = getFinancialYearDates();
        setTempFromDate(fyFromDate);
        setTempToDate(fyToDate);
        setTempClientSearchText("");
        setFilteredTempClients(allClients);
        setTempSelectedClients([]);
        setTempReportType(finalRt);
        setSelectedBankAccount('');
        setSelectedBookNames([]);
        setFilterOpen(true);
        setIsDaywise(false);
        setTempSelectedSalesClients([]);
        setTempSelectedPurchaseClients([]);
        setSalesClientSearchText("");
        setPurchaseClientSearchText("");
        setTempSelectedIncomeClients([]);
        setTempSelectedExpenseClients([]);
        setIncomeClientSearchText("");
        setExpenseClientSearchText("");
        if (finalRt === 'sale_vs_purchase' && companyId && allSalesAccountClients.length === 0) {
            fetchSalesAccountClients();
            fetchPurchaseAccountClients();
        }
        if (finalRt === 'inc_vs_exp' && companyId && allIncomeAccountClients.length === 0) {
            fetchIncomeAccountClients();
            fetchExpenseAccountClients();
        }
    };

    // Mirrors OSandODSaleReport effect 1: keep appliedReportType in sync with
    // the sidebar selection so re-opening from inside the page uses the right type.
    useEffect(() => {
        if (initialReportType) {
            setAppliedReportType(initialReportType);
        }
    }, [initialReportType]);

    useEffect(() => {
        if (openFilterTrigger > 0 && companyId) {
            handleOpenFilter(initialReportType);
        }
    }, [openFilterTrigger, companyId, initialReportType]);

    // ── Effect: Initialize on Mount ────────────────────────────────────────
    useEffect(() => {
        if (companyId) {
            fetchAllClients();
            fetchSalesAccountClients();
            fetchPurchaseAccountClients();
        }
    }, [companyId]);

    // ── Effect: Fetch bank accounts when BankBook is selected ──────────────
    useEffect(() => {
        if (tempReportType === 'bank_book' && companyId) {
            fetchBankAccounts();
        }
    }, [tempReportType, companyId]);


    // ── Get dynamic column labels based on report type ──────────────────────
    const { debitLabel, creditLabel } = getAmountColumnLabels(appliedReportType);

    // ── DataGrid Columns - Detail View ─────────────────────────────────────
    const columns = [
        {
            field: "docDate", headerName: "Date", flex: 1, minWidth: 115,
            renderCell: ({ value }) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: G500 }}>
                    <CalendarTodayOutlinedIcon sx={{ fontSize: 12 }} />
                    <Typography sx={{ fontSize: 13 }}>{fmtDate(value)}</Typography>
                </Box>
            ),
        },
        {
            field: "salePurchaseAC", headerName: "Narration", flex: 1.2, minWidth: 160,
            renderCell: ({ row }) => (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5, width: "100%" }}>
                    <Box sx={{ display: "inline-flex", alignItems: "center", px: 0, py: "3px", maxWidth: "100%" }}>
                        <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {row.salePurchaseAC || "—"}
                        </Typography>
                    </Box>
                    {row.remark && row.remark.trim() !== "" && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, pl: "2px" }}>
                            <Box sx={{ width: 3, height: 3, borderRadius: "50%", background: G500, flexShrink: 0 }} />
                            <Typography sx={{ fontSize: 10.5, color: G500, fontStyle: "italic", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", lineHeight: 1.3 }}>
                                {row.remark}
                            </Typography>
                        </Box>
                    )}
                </Box>
            ),
        },
        {
            field: "docNo", headerName: "Doc No", flex: 1.1, minWidth: 110,
            renderCell: ({ value }) => (
                <Chip label={value} size="small" sx={{ fontSize: 11, height: 22, background: "transparent", color: FB, fontWeight: 700, border: "none", borderRadius: "7px", "& .MuiChip-label": { px: 0 } }} />
            ),
        },
        {
            field: "bookName", headerName: "BookName", flex: 1.4, minWidth: 130,
            renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900, fontWeight: 500 }}>{value}</Typography>,
        },
        {
            field: "debit", headerName: `${debitLabel} (₹)`, flex: 1, minWidth: 120, align: "right", headerAlign: "right",
            renderCell: ({ value }) =>
                Number(value) > 0 ? (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5, width: "100%" }}>
                        <TrendingUpIcon sx={{ fontSize: 14, color: "#C62828" }} />
                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#C62828" }}>{fmt(Number(value))}</Typography>
                    </Box>
                ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
        },
        {
            field: "credit", headerName: `${creditLabel} (₹)`, flex: 1, minWidth: 120, align: "right", headerAlign: "right",
            renderCell: ({ value }) =>
                Number(value) > 0 ? (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5, width: "100%" }}>
                        <TrendingDownIcon sx={{ fontSize: 14, color: "#2E7D32" }} />
                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#2E7D32" }}>{fmt(Number(value))}</Typography>
                    </Box>
                ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
        },
        {
            field: "balance", headerName: "Balance (₹)", flex: 1.2, minWidth: 140, align: "right", headerAlign: "right",
            renderCell: ({ row }) => {
                const balType = row.balanceType || "Dr";
                const textColor = balType === "Dr" ? "#C62828" : "#2E7D32";
                return (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.6, width: "100%" }}>
                        {balType === "Dr"
                            ? <TrendingUpIcon sx={{ fontSize: 14, color: textColor }} />
                            : <TrendingDownIcon sx={{ fontSize: 14, color: textColor }} />
                        }
                        <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: textColor }}>{fmt(Number(row.balance || 0))}</Typography>
                        <Typography sx={{ fontSize: 10, fontWeight: 700, color: textColor, textTransform: "uppercase", letterSpacing: ".3px" }}>{balType}</Typography>
                    </Box>
                );
            },
        },
    ];

    // ─────────────────────────────────────────────────────────────────────────────
    // RENDER - FILTER VIEW
    // ─────────────────────────────────────────────────────────────────────────────
    if (viewMode === "filter") {
        return (
            <Box sx={{ background: G200, display: "flex", flexDirection: "column", minHeight: "100%" }}>
                {/* ERP Header */}
                <Box sx={{ background: WHITE, borderBottom: `1px solid ${G300}`, display: "flex", alignItems: "stretch", flexShrink: 0, minHeight: 58 }}>
                    <Box sx={{ width: 4, background: FB, flexShrink: 0 }} />
                    <Box sx={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "space-between", px: { xs: 2, sm: 3 }, py: 1.25, gap: 2, flexWrap: "wrap" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{ width: 36, height: 36, background: FB_LIGHT, borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <ReceiptLongOutlinedIcon sx={{ fontSize: 20, color: FB }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 15, fontWeight: 700, color: G900, lineHeight: 1.2 }}>Ledger Report</Typography>
                                <Typography sx={{ fontSize: 11, color: G500, mt: "1px" }}>General ledger, bank book, cash book &amp; day book</Typography>
                            </Box>
                        </Box>
                        <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 15 }} />} sx={btnPrimarySx}>
                            Smart Filter
                        </Button>
                    </Box>
                </Box>

                {/* Empty State */}
                <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: { xs: 2, sm: 3 } }}>
                    <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "10px", p: { xs: 3, sm: 4 }, textAlign: "center", maxWidth: 420, width: "100%" }}>
                        <Box sx={{ width: 52, height: 52, background: FB_LIGHT, borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                            <ReceiptLongOutlinedIcon sx={{ fontSize: 26, color: FB }} />
                        </Box>
                        <Typography sx={{ fontSize: 15, fontWeight: 700, color: G900, mb: 0.75 }}>Select Report Parameters</Typography>
                        <Typography sx={{ fontSize: 13, color: G700, lineHeight: 1.7, mb: 2.5 }}>
                            Use Smart Filter to select report type, clients, and date range to view ledger data.
                        </Typography>
                        <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 15 }} />} sx={{ ...btnPrimarySx, height: 38, px: 3 }}>
                            Open Smart Filter
                        </Button>
                    </Box>
                </Box>

                {/* Snackbar */}
                <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                    <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
                        {snackbar.message}
                    </Alert>
                </Snackbar>

                {/* Smart Filter Dialog */}
                <SmartFilterDialog
                    open={filterOpen}
                    onClose={() => setFilterOpen(false)}
                    allClients={allClients}
                    itemGroupsLoading={false}
                    tempFromDate={tempFromDate}
                    setTempFromDate={setTempFromDate}
                    tempToDate={tempToDate}
                    setTempToDate={setTempToDate}
                    tempClientSearchText={tempClientSearchText}
                    setTempClientSearchText={handleTempClientSearch}
                    tempSelectedClients={tempSelectedClients}
                    setTempSelectedClients={setTempSelectedClients}
                    filteredTempClients={filteredTempClients}
                    handleTempSelectAll={() => setTempSelectedClients(filteredTempClients)}
                    handleTempDeselectAll={() => setTempSelectedClients([])}
                    handleTempClientCheckbox={handleTempClientCheckbox}
                    loading={loading}
                    onGetData={handleViewSelectedLedgers}
                    tempReportType={tempReportType}
                    setTempReportType={setTempReportType}
                    selectedBookNames={selectedBookNames}
                    setSelectedBookNames={setSelectedBookNames}
                    selectedBankAccount={selectedBankAccount}
                    setSelectedBankAccount={setSelectedBankAccount}
                    bankAccounts={bankAccounts}
                    bankAccountsLoading={bankAccountsLoading}
                    isDaywise={isDaywise}
                    setIsDaywise={setIsDaywise}
                    allSalesAccountClients={allSalesAccountClients}
                    salesClientsLoading={salesClientsLoading}
                    tempSelectedSalesClients={tempSelectedSalesClients}
                    setTempSelectedSalesClients={setTempSelectedSalesClients}
                    salesClientSearchText={salesClientSearchText}
                    setSalesClientSearchText={setSalesClientSearchText}
                    allPurchaseAccountClients={allPurchaseAccountClients}
                    purchaseClientsLoading={purchaseClientsLoading}
                    tempSelectedPurchaseClients={tempSelectedPurchaseClients}
                    setTempSelectedPurchaseClients={setTempSelectedPurchaseClients}
                    purchaseClientSearchText={purchaseClientSearchText}
                    setPurchaseClientSearchText={setPurchaseClientSearchText}
                    allIncomeAccountClients={allIncomeAccountClients}
                    incomeClientsLoading={incomeClientsLoading}
                    tempSelectedIncomeClients={tempSelectedIncomeClients}
                    setTempSelectedIncomeClients={setTempSelectedIncomeClients}
                    incomeClientSearchText={incomeClientSearchText}
                    setIncomeClientSearchText={setIncomeClientSearchText}
                    allExpenseAccountClients={allExpenseAccountClients}
                    expenseClientsLoading={expenseClientsLoading}
                    tempSelectedExpenseClients={tempSelectedExpenseClients}
                    setTempSelectedExpenseClients={setTempSelectedExpenseClients}
                    expenseClientSearchText={expenseClientSearchText}
                    setExpenseClientSearchText={setExpenseClientSearchText}
                />
            </Box>
        );
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // RENDER - DETAIL VIEW
    // ─────────────────────────────────────────────────────────────────────────────
    const currentClient = getCurrentTabClient();
    const currentData = getCurrentTabData();

    return (
        <Box sx={{ background: G200, display: "flex", flexDirection: "column", minHeight: "100%" }}>
            {/* ── ERP Header ── */}
            <Box sx={{ background: WHITE, borderBottom: `1px solid ${G300}`, display: "flex", alignItems: "stretch", flexShrink: 0, minHeight: 58 }}>
                <Box sx={{ width: 4, background: FB, flexShrink: 0 }} />
                <Box sx={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "space-between", px: { xs: 2, sm: 3 }, py: 1.25, gap: 2, flexWrap: "wrap" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box sx={{ width: 36, height: 36, background: FB_LIGHT, borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <ReceiptLongOutlinedIcon sx={{ fontSize: 20, color: FB }} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: 15, fontWeight: 700, color: G900, lineHeight: 1.2 }}>
                                {REPORT_TYPES.find((r) => r.value === appliedReportType)?.label || "Ledger Report"}
                            </Typography>
                            <Typography sx={{ fontSize: 11, color: G500, mt: "1px" }}>
                                {appliedFilters ? `${appliedReportType === "general_ledger" ? `${selectedClients.length} client${selectedClients.length !== 1 ? "s" : ""} · ` : ""}${fmtDate(appliedFilters.fromDate)} – ${fmtDate(appliedFilters.toDate)}` : ""}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
                        {appliedReportType === "general_ledger" && selectedClients.length > 0 && (
                            <Button onClick={handleExportPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
                                {isSmall ? "PDF" : "Export PDF"}
                            </Button>
                        )}
                        {appliedReportType === "bank_book" && bankBookData && (
                            <Button onClick={handleExportBankBookPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
                                {isSmall ? "PDF" : "Export PDF"}
                            </Button>
                        )}
                        {appliedReportType === "cash_book" && cashBookData && (
                            <Button onClick={handleExportCashBookPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
                                {isSmall ? "PDF" : "Export PDF"}
                            </Button>
                        )}
                        {appliedReportType === "day_book" && dayBookData && (
                            <Button onClick={handleExportDayBookPDF} disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
                                {isSmall ? "PDF" : "Export PDF"}
                            </Button>
                        )}
                        {appliedReportType === "group_wise_summary" && groupwiseSummaryData && (
                            <Button onClick={
                                groupwisePage === "ledger" && selectedMonthForLedger ? handleExportPDF :
                                    groupwisePage === "clients" && selectedSubGroup ? handleExportClientsPagePDF :
                                        groupwisePage === "monthly" && selectedClientForMonthly ? handleExportMonthlyPagePDF :
                                            handleExportGroupwiseSummaryPDF
                            } disabled={pdfLoading} startIcon={pdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
                                {isSmall ? "PDF" : "Export PDF"}
                            </Button>
                        )}
                        {appliedReportType === "sale_vs_purchase" && salesVsPurchaseData && (
                            <Button onClick={handleSaleVsPurchasePDF} disabled={graphPdfLoading} startIcon={graphPdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
                                {isSmall ? "PDF" : "Export PDF"}
                            </Button>
                        )}
                        {appliedReportType === "inc_vs_exp" && incVsExpData && (
                            <Button onClick={handleIncVsExpPDF} disabled={graphPdfLoading} startIcon={graphPdfLoading ? <CircularProgress size={13} sx={{ color: FB }} /> : <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />} sx={btnOutlineSx}>
                                {isSmall ? "PDF" : "Export PDF"}
                            </Button>
                        )}
                        <Button onClick={handleOpenFilter} startIcon={<TuneIcon sx={{ fontSize: 15 }} />} sx={btnPrimarySx}>
                            {isSmall ? "Filter" : "Smart Filter"}
                        </Button>
                    </Box>
                </Box>
            </Box>

            {/* ── Toolbar: filter tags + tabs ── */}
            {appliedFilters && (
                <Box sx={{ background: WHITE, borderBottom: `1px solid ${G300}`, flexShrink: 0 }}>
                    {/* Filter tags row */}
                    <Box sx={{ px: { xs: 2, sm: 3 }, py: 1, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, background: G200, borderBottom: `1px solid ${G300}` }}>
                        <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", alignItems: "center" }}>
                            <Typography sx={{ fontSize: 11, color: G500, fontWeight: 600, textTransform: "uppercase", letterSpacing: ".4px", mr: 0.5 }}>Filter:</Typography>
                            {[
                                REPORT_TYPES.find((r) => r.value === appliedReportType)?.label,
                                `${fmtDate(appliedFilters.fromDate)} – ${fmtDate(appliedFilters.toDate)}`,
                                ...(appliedReportType === "general_ledger" ? [`${appliedFilters.clientCount} client${appliedFilters.clientCount > 1 ? "s" : ""}`] : []),
                            ].filter(Boolean).map(tag => (
                                <Box key={tag} sx={{ px: 1.25, py: "2px", background: FB_LIGHT, borderRadius: "4px", border: `1px solid ${G300}` }}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: FB }}>{tag}</Typography>
                                </Box>
                            ))}
                        </Box>
                        <Button onClick={handleClear} size="small" startIcon={<ClearIcon sx={{ fontSize: 12 }} />}
                            sx={{ color: G700, border: `1px solid ${G300}`, background: "transparent", borderRadius: "6px", fontSize: 11, fontWeight: 500, textTransform: "none", px: 1.25, height: 26, "&:hover": { background: G200 } }}>
                            Clear
                        </Button>
                    </Box>

                    {/* Tabs for General Ledger — not shown any more: all selected clients are listed one
                        under another (client name row, then its records) */}
                    {false && appliedReportType === "general_ledger" && selectedClients.length > 0 && (
                        <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto"
                            sx={{ px: 1, minHeight: 42, "& .MuiTabs-indicator": { background: FB, height: 2.5, borderRadius: "2px 2px 0 0" }, "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: 13, color: G500, minHeight: 42, px: 2, py: 0.75, "&.Mui-selected": { color: FB } } }}>
                            {selectedClients.map((client, idx) => {
                                const clientData = ledgerDataMap[client.id];
                                const entryCount = clientData?.details?.length || 0;
                                return (
                                    <Tab key={client.id}
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                                                <span>{client.FirmName}</span>
                                                <Box sx={{ minWidth: 18, height: 17, px: "4px", background: entryCount > 0 ? FB : G300, borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: WHITE, lineHeight: 1 }}>{entryCount}</Typography>
                                                </Box>
                                            </Box>
                                        }
                                        id={`ledger-tab-${idx}`}
                                        aria-controls={`ledger-tabpanel-${idx}`}
                                    />
                                );
                            })}
                        </Tabs>
                    )}
                </Box>
            )}

            {/* ── Content area ─────────────────────────────────────────────────────── */}
            <Box sx={{ p: { xs: 1.5, sm: 2 }, flex: 1 }}>

                {/* ── General Ledger: a dropdown with all clients (only ONE can be selected at a time); the ledger
                    of the selected client is shown below it ─────────────────────────────────────────────── */}
                {appliedReportType === "general_ledger" && selectedClients.length > 0 && (
                <Box>
                    <Box sx={{ mb: 2 }}>
                        <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: "6px", letterSpacing: ".3px", textTransform: "uppercase" }}>
                            Clients ({selectedClients.length})
                        </Typography>
                        {/* Searchable: type to filter the clients; only ONE client can be selected */}
                        <Autocomplete size="small" disableClearable fullWidth
                            options={selectedClients}
                            value={selectedClients[activeTab] || null}
                            onChange={(e, client) => { if (client) setActiveTab(selectedClients.findIndex((c) => c.id === client.id)); }}
                            getOptionLabel={(client) => client?.FirmName || ""}
                            isOptionEqualToValue={(opt, val) => opt.id === val.id}
                            noOptionsText="No clients found"
                            ListboxProps={{ sx: { maxHeight: 320 } }}
                            renderOption={(props, client) => {
                                const entryCount = ledgerDataMap[client.id]?.details?.length || 0;
                                return (
                                    <li {...props} key={client.id} style={{ ...props.style, display: "flex", justifyContent: "space-between", gap: 16 }}>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500 }}>{client.FirmName}</Typography>
                                        <Box sx={{ minWidth: 20, height: 18, px: "5px", background: entryCount > 0 ? FB : G300, borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: WHITE, lineHeight: 1 }}>{entryCount}</Typography>
                                        </Box>
                                    </li>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField {...params} placeholder="Search client..." sx={inputSx} />
                            )}
                        />
                    </Box>

                    <Box sx={{ minWidth: 0 }}>
                {selectedClients.map((client, idx) => {
                        const clientData = ledgerDataMap[client.id];
                        // Collapsible: only the expanded client (activeTab) shows its ledger; clicking another
                        // client expands it and collapses the previous one (-1 = all collapsed)
                        const isActive = idx === activeTab;

                        const opValueKPI = Number(clientData?.openingBalance?.absValue || 0);
                        const opTypeKPI = clientData?.openingBalance?.type || "Dr";
                        // summary.totalDebit/totalCredit (from the API) covers period transactions only —
                        // fold the opening balance into whichever side it belongs on so the KPI matches
                        // the sum of the debit/credit columns actually shown (which include the OPBAL row).
                        const kpiTotalDebit = Number(clientData?.summary?.totalDebit || 0) + (opTypeKPI === "Dr" ? opValueKPI : 0);
                        const kpiTotalCredit = Number(clientData?.summary?.totalCredit || 0) + (opTypeKPI === "Cr" ? opValueKPI : 0);

                        const displayRows = (() => {
                            if (!isActive || !clientData?.details) return [];
                            const opValue = Number(clientData.openingBalance.absValue || 0);
                            const opType = clientData.openingBalance.type || "Dr";
                            const openingRow = {
                                id: "opening-balance",
                                docDate: fmtDate(appliedFilters?.fromDate || dateFilters[client.id]?.fromDate) || "—",
                                salePurchaseAC: "—",
                                docNo: "—",
                                bookName: "OPBAL",
                                debit: clientData.openingBalance.type === "Dr" ? Number(clientData.openingBalance.absValue || 0) : 0,
                                credit: clientData.openingBalance.type === "Cr" ? Number(clientData.openingBalance.absValue || 0) : 0,
                                remark: "",
                                balance: opValue,
                                balanceType: opType,
                                isOpeningRow: true,
                            };
                            // clientData.details may already include an OPBAL row from the API (see fetchPartyDetail),
                            // which would duplicate the openingRow built above — exclude it here.
                            const nonOpeningDetails = clientData.details.filter((d) => d.bookName !== "OPBAL");
                            return [openingRow, ...nonOpeningDetails];
                        })();

                        return (
                            <Box key={client.id} id={`ledger-client-${idx}`} sx={{ mb: 1.5 }}>
                                {isActive && (
                                    <Box>
                                        {/* Selected client's name, then its ledger below */}
                                        <Typography sx={{ fontSize: 16, fontWeight: 800, color: G900, mb: 1, pb: 0.75, borderBottom: `2px solid ${G900}` }}>{client.FirmName}</Typography>

                                        {/* KPI Strip */}
                                        {clientData && clientData.details && clientData.details.length > 0 && (
                                            <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", mb: 2, overflow: "hidden" }}>
                                                <Box sx={{ display: "flex", px: { xs: 2, sm: 3 }, py: 1.5, overflowX: "auto" }}>
                                                    {[
                                                        { label: "ENTRIES", value: String(clientData.summary.totalTransactions || clientData.details.length), accent: false },
                                                        { label: `TOTAL ${debitLabel.toUpperCase()}`, value: `₹ ${fmt(kpiTotalDebit)}`, accent: false },
                                                        { label: `TOTAL ${creditLabel.toUpperCase()}`, value: `₹ ${fmt(kpiTotalCredit)}`, accent: false },
                                                        { label: "CLOSING BALANCE", value: `${fmt(Number(clientData.closingBalance?.absValue || 0))} ${clientData.closingBalance?.type || "Dr"}`, accent: true },
                                                    ].map((item, i, arr) => (
                                                        <Box key={i} sx={{ pr: { xs: 2.5, sm: 3.5 }, pl: i === 0 ? 0 : { xs: 2.5, sm: 3.5 }, borderRight: i < arr.length - 1 ? `1px solid ${G300}` : "none", flexShrink: 0 }}>
                                                            <Typography sx={{ fontSize: 10, fontWeight: 700, color: G500, textTransform: "uppercase", letterSpacing: ".6px", lineHeight: 1, mb: "4px" }}>{item.label}</Typography>
                                                            <Typography sx={{ fontSize: 16, fontWeight: 700, color: item.accent ? FB : G900, fontFamily: "monospace", lineHeight: 1 }}>{item.value}</Typography>
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        )}

                                        {/* DataGrid */}
                                        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
                                            {loading ? (
                                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
                                                    <CircularProgress sx={{ color: FB }} />
                                                    <Typography sx={{ color: G500, fontSize: 13 }}>Loading ledger entries…</Typography>
                                                </Box>
                                            ) : displayRows.length > 0 ? (
                                                <DataGrid rows={displayRows} columns={columns} autoHeight rowHeight={44} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={dgSx} />
                                            ) : (
                                                <Box sx={{ py: "2.5rem" }}>
                                                    <NoDataComponent />
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        );
                    })}
                    </Box>
                </Box>
                )}

                {/* ── BankBook Statement View ──────────────────────────────────────────── */}
                {appliedReportType === "bank_book" && (
                    <Box>
                        {loading ? (
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
                                <CircularProgress sx={{ color: FB }} />
                                <Typography sx={{ color: G500, fontSize: 13 }}>Loading bank book statement…</Typography>
                            </Box>
                        ) : bankBookData ? (
                            <>
                                <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap" }}>
                                    <StatCard label="Opening Balance" value={`₹ ${fmt(bankBookData.openingBalance?.opBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
                                    <StatCard label="Total Withdrawal" value={`₹ ${fmt(bankBookData.summary?.totalDebit ?? 0)}`} icon={<TrendingUpIcon fontSize="small" />} />
                                    <StatCard label="Total Deposit" value={`₹ ${fmt(bankBookData.summary?.totalCredit ?? 0)}`} icon={<TrendingDownIcon fontSize="small" />} />
                                    <StatCard label="Closing Balance" value={`₹ ${fmt(bankBookData.closingBalance?.closingBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
                                </Box>
                                <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
                                    {bankBookData.data && bankBookData.data.length > 0 ? (
                                        <DataGrid rows={bankBookData?.details || []} columns={columns} autoHeight rowHeight={44} getRowId={(row) => row.id} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={dgSx} />
                                    ) : (
                                        <Box sx={{ py: "2.5rem" }}><NoDataComponent /></Box>
                                    )}
                                </Box>
                            </>
                        ) : (
                            <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {/* ── CashBook Statement View ──────────────────────────────────────────── */}
                {appliedReportType === "cash_book" && (
                    <Box>
                        {loading ? (
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
                                <CircularProgress sx={{ color: FB }} />
                                <Typography sx={{ color: G500, fontSize: 13 }}>Loading cash book statement…</Typography>
                            </Box>
                        ) : cashBookData ? (
                            <>
                                {cashBookData.clients && cashBookData.clients.length > 0 ? (
                                    <>
                                        {cashBookData.clients.length > 1 && (
                                            <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px 12px 0 0", mb: 0 }}>
                                                <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto"
                                                    sx={{
                                                        "& .MuiTabs-indicator": { background: FB, height: 3 },
                                                        "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: 13, color: G500, padding: "12px 20px", minHeight: 48, "&.Mui-selected": { color: FB } },
                                                    }}
                                                >
                                                    {cashBookData.clients.map((clientItem, idx) => {
                                                        const entryCount = clientItem?.data?.length || 0;
                                                        return (
                                                            <Tab key={clientItem.clientInfo.id}
                                                                label={
                                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                        <span>{clientItem.clientInfo.FirmName}</span>
                                                                        <Chip label={entryCount} size="small" sx={{ height: 20, fontSize: 11, fontWeight: 700, background: entryCount > 0 ? FB_LIGHT : G200, color: entryCount > 0 ? FB : G500 }} />
                                                                    </Box>
                                                                }
                                                                id={`cash-tab-${idx}`}
                                                                aria-controls={`cash-tabpanel-${idx}`}
                                                            />
                                                        );
                                                    })}
                                                </Tabs>
                                            </Box>
                                        )}
                                        {cashBookData.clients.map((clientItem, idx) => (
                                            <TabPanel key={clientItem.clientInfo.id} value={activeTab} index={idx}>
                                                <Box>
                                                    <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap" }}>
                                                        <StatCard label="Opening Balance" value={`₹ ${fmt(clientItem.openingBalance?.opBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
                                                        <StatCard label="Total Withdrawal" value={`₹ ${fmt(clientItem.summary?.totalDebit ?? 0)}`} icon={<TrendingUpIcon fontSize="small" />} />
                                                        <StatCard label="Total Deposit" value={`₹ ${fmt(clientItem.summary?.totalCredit ?? 0)}`} icon={<TrendingDownIcon fontSize="small" />} />
                                                        <StatCard label="Closing Balance" value={`₹ ${fmt(clientItem.closingBalance?.closingBal ?? 0)}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
                                                    </Box>
                                                    <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
                                                        {clientItem.data && clientItem.data.length > 0 ? (
                                                            <DataGrid rows={cashBookData?.details || []} columns={columns} getRowId={(row) => row.id} autoHeight rowHeight={44} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={dgSx} />
                                                        ) : (
                                                            <Box sx={{ py: "2.5rem" }}><NoDataComponent /></Box>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </TabPanel>
                                        ))}
                                    </>
                                ) : (
                                    <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                        <Typography sx={{ fontSize: 14, color: G500 }}>No cash book records found.</Typography>
                                    </Box>
                                )}
                            </>
                        ) : (
                            <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {/* ── DayBook Statement View ───────────────────────────────────────────── */}
                {appliedReportType === "day_book" && (
                    <Box>
                        {loading ? (
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
                                <CircularProgress sx={{ color: FB }} />
                                <Typography sx={{ color: G500, fontSize: 13 }}>Loading day book statement…</Typography>
                            </Box>
                        ) : dayBookData ? (() => {
                            const totalIncome = Number(dayBookData.incomeSummary?.totalCredit ?? 0);
                            const totalExpense = Number(dayBookData.expenseSummary?.totalDebit ?? 0);
                            const netPL = totalIncome - totalExpense;
                            const isProfit = netPL >= 0;

                            // ── Month-wise grouping ──────────────────────────────
                            const monthMap = {};
                            const fmtMonthKey = (mk) => {
                                const [yyyy, mm] = mk.split("-");
                                const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                                return `${names[parseInt(mm) - 1]} ${yyyy}`;
                            };
                            (dayBookData.expenseRows || []).forEach((r) => {
                                const mk = String(r.docDate || "").substring(0, 7);
                                if (!monthMap[mk]) monthMap[mk] = { id: mk, period: fmtMonthKey(mk), expense: 0, income: 0 };
                                monthMap[mk].expense += Number(r.debit || 0);
                            });
                            (dayBookData.incomeRows || []).forEach((r) => {
                                const mk = String(r.docDate || "").substring(0, 7);
                                if (!monthMap[mk]) monthMap[mk] = { id: mk, period: fmtMonthKey(mk), expense: 0, income: 0 };
                                monthMap[mk].income += Number(r.credit || 0);
                            });
                            const monthRows = Object.values(monthMap)
                                .sort((a, b) => a.id.localeCompare(b.id))
                                .map((r) => ({ ...r, net: r.income - r.expense }));

                            // ── Day-wise grouping ────────────────────────────────
                            const dayMap = {};
                            (dayBookData.expenseRows || []).forEach((r) => {
                                const dk = String(r.docDate || "");
                                if (!dayMap[dk]) dayMap[dk] = { id: dk, period: fmtDate(dk), expense: 0, income: 0 };
                                dayMap[dk].expense += Number(r.debit || 0);
                            });
                            (dayBookData.incomeRows || []).forEach((r) => {
                                const dk = String(r.docDate || "");
                                if (!dayMap[dk]) dayMap[dk] = { id: dk, period: fmtDate(dk), expense: 0, income: 0 };
                                dayMap[dk].income += Number(r.credit || 0);
                            });
                            const dayRows = Object.values(dayMap)
                                .sort((a, b) => a.id.localeCompare(b.id))
                                .map((r) => ({ ...r, net: r.income - r.expense }));

                            // ── All Transactions combined ────────────────────────
                            const allTxRows = [
                                ...(dayBookData.expenseRows || []),
                                ...(dayBookData.incomeRows || []),
                            ].sort((a, b) => String(a.docDate || "").localeCompare(String(b.docDate || "")));

                            // ── Shared columns for month/day views ───────────────
                            const periodGridSx = dgSx;

                            const periodColumns = [
                                {
                                    field: "period", headerName: dayBookView === "month" ? "Month" : "Date",
                                    flex: 1.2, minWidth: 130,
                                    renderCell: ({ value }) => (
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                                            <CalendarTodayOutlinedIcon sx={{ fontSize: 12, color: G500 }} />
                                            <Typography sx={{ fontSize: 13, fontWeight: 500, color: G900 }}>{value}</Typography>
                                        </Box>
                                    ),
                                },
                                // Same design as the ledger columns: right aligned, no background box,
                                // outgoing (Expense) in RED and incoming (Income) in GREEN — amount and arrow.
                                {
                                    field: "expense", headerName: "Expense (₹)", flex: 1.1, minWidth: 130, align: "right", headerAlign: "right",
                                    renderCell: ({ value }) => Number(value) > 0 ? (
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5, width: "100%" }}>
                                            <TrendingUpIcon sx={{ fontSize: 14, color: "#C62828" }} />
                                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#C62828" }}>{fmt(Number(value))}</Typography>
                                        </Box>
                                    ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
                                },
                                {
                                    field: "income", headerName: "Income (₹)", flex: 1.1, minWidth: 130, align: "right", headerAlign: "right",
                                    renderCell: ({ value }) => Number(value) > 0 ? (
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5, width: "100%" }}>
                                            <TrendingDownIcon sx={{ fontSize: 14, color: "#2E7D32" }} />
                                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#2E7D32" }}>{fmt(Number(value))}</Typography>
                                        </Box>
                                    ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
                                },
                                {
                                    field: "net", headerName: "Net P&L (₹)", flex: 1.2, minWidth: 140, align: "right", headerAlign: "right",
                                    renderCell: ({ value }) => {
                                        const n = Number(value);
                                        const profit = n >= 0;
                                        const netColor = profit ? "#2E7D32" : "#C62828";
                                        return (
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5, width: "100%" }}>
                                                {profit
                                                    ? <TrendingDownIcon sx={{ fontSize: 14, color: netColor }} />
                                                    : <TrendingUpIcon sx={{ fontSize: 14, color: netColor }} />
                                                }
                                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: netColor }}>
                                                    {profit ? "+" : "-"}{fmt(Math.abs(n))}
                                                </Typography>
                                            </Box>
                                        );
                                    },
                                },
                            ];

                            return (
                                <>
                                    {/* ── Summary Cards ───────────────────────────── */}
                                    <Box sx={{ display: "flex", gap: 1.5, mb: 2, flexWrap: "wrap" }}>
                                        <StatCard label="Total Income" value={`₹ ${fmt(totalIncome)}`} icon={<TrendingDownIcon fontSize="small" />} />
                                        <StatCard label="Total Expense" value={`₹ ${fmt(totalExpense)}`} icon={<TrendingUpIcon fontSize="small" />} />
                                        <StatCard label={isProfit ? "Net Profit" : "Net Loss"} value={`₹ ${fmt(Math.abs(netPL))}`} icon={<AccountBalanceWalletOutlinedIcon fontSize="small" />} />
                                    </Box>

                                    {/* ── View Toggle ─────────────────────────────── */}
                                    <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
                                        {[
                                            { key: "month", label: "Month Wise" },
                                            { key: "day", label: "Day Wise" },
                                            { key: "all", label: "All Transactions" },
                                        ].map((v) => (
                                            <Button key={v.key} onClick={() => setDayBookView(v.key)}
                                                sx={{
                                                    fontSize: 13, fontWeight: 500, textTransform: "none", borderRadius: "8px", px: 2, height: 34, background: dayBookView === v.key ? FB : "transparent", color: dayBookView === v.key ? WHITE : G500, border: `1.5px solid ${dayBookView === v.key ? FB : G300}`,
                                                    "&:hover": { background: dayBookView === v.key ? FB_DARK : FB_LIGHT, color: dayBookView === v.key ? WHITE : FB },
                                                }}
                                            >
                                                {v.label}
                                            </Button>
                                        ))}
                                    </Box>

                                    {/* ── Month Wise / Day Wise DataGrid ───────────── */}
                                    {(dayBookView === "month" || dayBookView === "day") && (
                                        <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
                                            <DataGrid rows={dayBookView === "month" ? monthRows : dayRows} columns={periodColumns} autoHeight rowHeight={44} getRowId={(row) => row.id} disableRowSelectionOnClick pageSizeOptions={[25, 50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} slots={{ noResultsOverlay: CustomNoDataOverlay }} sx={periodGridSx} />
                                        </Box>
                                    )}

                                    {/* ── All Transactions DataGrid ────────────────── */}
                                    {dayBookView === "all" && (
                                        <Box sx={{ ...cardSx, p: 0, overflow: "hidden" }}>
                                            {allTxRows.length > 0 ? (
                                                <DataGrid
                                                    rows={allTxRows}
                                                    columns={[
                                                        {
                                                            field: "docDate", headerName: "Date", flex: 1, minWidth: 115,
                                                            renderCell: ({ value }) => (
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: G500 }}>
                                                                    <CalendarTodayOutlinedIcon sx={{ fontSize: 12 }} />
                                                                    <Typography sx={{ fontSize: 13 }}>{fmtDate(value)}</Typography>
                                                                </Box>
                                                            ),
                                                        },
                                                        {
                                                            field: "partyName", headerName: "Client Name", flex: 1.4, minWidth: 150,
                                                            renderCell: ({ value }) => <Typography sx={{ fontSize: 13, fontWeight: 600, color: G900 }}>{value}</Typography>,
                                                        },
                                                        {
                                                            field: "salePurchaseAC", headerName: "Narration", flex: 1.2, minWidth: 160,
                                                            renderCell: ({ row }) => (
                                                                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, py: 0.5, width: "100%" }}>
                                                                    <Box sx={{ display: "inline-flex", alignItems: "center", px: 0, py: "3px", maxWidth: "100%" }}>
                                                                        <Typography sx={{ fontSize: 12, fontWeight: 500, color: FB, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                                            {row.salePurchaseAC || "—"}
                                                                        </Typography>
                                                                    </Box>
                                                                    {row.remark && row.remark.trim() !== "" && (
                                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, pl: "2px" }}>
                                                                            <Box sx={{ width: 3, height: 3, borderRadius: "50%", background: G500, flexShrink: 0 }} />
                                                                            <Typography sx={{ fontSize: 10.5, color: G500, fontStyle: "italic", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", lineHeight: 1.3 }}>
                                                                                {row.remark}
                                                                            </Typography>
                                                                        </Box>
                                                                    )}
                                                                </Box>
                                                            ),
                                                        },
                                                        {
                                                            field: "docNo", headerName: "Doc No", flex: 1.1, minWidth: 110,
                                                            renderCell: ({ value }) => (
                                                                <Chip label={value} size="small" sx={{ fontSize: 11, height: 22, background: "transparent", color: FB, fontWeight: 700, border: "none", borderRadius: "7px", "& .MuiChip-label": { px: 0 } }} />
                                                            ),
                                                        },
                                                        {
                                                            field: "bookName", headerName: "BookName", flex: 1.4, minWidth: 130,
                                                            renderCell: ({ value }) => <Typography sx={{ fontSize: 13, color: G900, fontWeight: 500 }}>{value}</Typography>,
                                                        },
                                                        {
                                                            field: "debit", headerName: "Debit (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right",
                                                            renderCell: ({ value }) =>
                                                                Number(value) > 0 ? (
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5, width: "100%" }}>
                                                                        <TrendingUpIcon sx={{ fontSize: 14, color: "#C62828" }} />
                                                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#C62828" }}>{fmt(Number(value))}</Typography>
                                                                    </Box>
                                                                ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
                                                        },
                                                        {
                                                            field: "credit", headerName: "Credit (₹)", flex: 1, minWidth: 120, align: "right", headerAlign: "right",
                                                            renderCell: ({ value }) =>
                                                                Number(value) > 0 ? (
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5, width: "100%" }}>
                                                                        <TrendingDownIcon sx={{ fontSize: 14, color: "#2E7D32" }} />
                                                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#2E7D32" }}>{fmt(Number(value))}</Typography>
                                                                    </Box>
                                                                ) : <Typography sx={{ color: G300, fontSize: 14 }}>—</Typography>,
                                                        },
                                                        {
                                                            field: "balance", headerName: "Balance (₹)", flex: 1.2, minWidth: 140, align: "right", headerAlign: "right",
                                                            renderCell: ({ row }) => {
                                                                const balType = row.balanceType || "Dr";
                                                                const textColor = balType === "Dr" ? "#C62828" : "#2E7D32";
                                                                return (
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.6, width: "100%" }}>
                                                                        {balType === "Dr"
                                                                            ? <TrendingUpIcon sx={{ fontSize: 14, color: textColor }} />
                                                                            : <TrendingDownIcon sx={{ fontSize: 14, color: textColor }} />
                                                                        }
                                                                        <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: textColor }}>{fmt(Number(row.balance || 0))}</Typography>
                                                                        <Typography sx={{ fontSize: 10, fontWeight: 700, color: textColor, textTransform: "uppercase", letterSpacing: ".3px" }}>{balType}</Typography>
                                                                    </Box>
                                                                );
                                                            },
                                                        },
                                                    ]}
                                                    autoHeight
                                                    rowHeight={44}
                                                    getRowId={(row) => row.id}
                                                    disableRowSelectionOnClick
                                                    pageSizeOptions={[25, 50, 100]}
                                                    initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
                                                    slots={{ noResultsOverlay: CustomNoDataOverlay }}
                                                    sx={dgSx}
                                                />
                                            ) : (
                                                <Box sx={{ py: "2.5rem" }}><NoDataComponent /></Box>
                                            )}
                                        </Box>
                                    )}
                                </>
                            );
                        })() : (
                            <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {/* ── Groupwise Summary View ──────────────────────────────────────────── */}
                {appliedReportType === "group_wise_summary" && (
                    <Box>
                        {loading ? (
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
                                <CircularProgress sx={{ color: FB }} />
                                <Typography sx={{ color: G500, fontSize: 13 }}>Loading groupwise summary…</Typography>
                            </Box>
                        ) : groupwiseSummaryData && Object.keys(groupwiseSummaryData).length > 0 ? (() => {

                            const groups = Object.values(groupwiseSummaryData).map((grp) => {
                                const subGroups = Object.values(grp.subGroups || {}).map((sg) => ({
                                    subGrpName: sg.subGroupName,
                                    clients: sg.clients || [],
                                    totalBalance: (sg.clients || []).reduce((s, c) => s + Number(c.balance || 0), 0),
                                }));
                                return {
                                    groupName: grp.groupName,
                                    subGroups,
                                    totalBalance: subGroups.reduce((s, sg) => s + sg.totalBalance, 0),
                                };
                            });

                            const grandTotal = groups.reduce((s, g) => s + g.totalBalance, 0);
                            const totalSubGroups = groups.reduce((s, g) => s + g.subGroups.length, 0);
                            const totalClients = groups.reduce((s, g) => s + g.subGroups.reduce((ss, sg) => ss + sg.clients.length, 0), 0);

                            const BalBadge = ({ value, size = "md" }) => {
                                // Same design as the ledger / Day Book: right aligned, no background box,
                                // Dr (outgoing) in RED, Cr (incoming) in GREEN.
                                const isNeg = value < 0;
                                const balColor = isNeg ? "#C62828" : "#2E7D32";
                                return (
                                    <Box sx={{ display: "inline-flex", alignItems: "center", justifyContent: "flex-end", gap: "4px", flexShrink: 0 }}>
                                        <Typography sx={{ fontSize: size === "sm" ? 12.5 : 13.5, fontWeight: 700, color: balColor, fontVariantNumeric: "tabular-nums" }}>
                                            ₹ {fmt(Math.abs(value))}
                                        </Typography>
                                        {value !== 0 && <Typography sx={{ fontSize: 9.5, fontWeight: 700, color: balColor, textTransform: "uppercase", letterSpacing: ".3px" }}>{isNeg ? "Dr" : "Cr"}</Typography>}
                                    </Box>
                                );
                            };

                            // ── PAGE: GROUPS ─────────────────────────────────────────
                            if (groupwisePage === "groups") {
                                let srNo = 0;
                                return (
                                    <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>

                                        {/* Title bar */}
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.5, background: `linear-gradient(90deg, ${FB} 0%, #1a5fce 100%)` }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                                <Typography sx={{ fontSize: 15, fontWeight: 700, color: WHITE }}>Groupwise Summary</Typography>
                                                <Box sx={{ px: "8px", py: "2px", background: "rgba(255,255,255,0.18)", borderRadius: "6px", display: { xs: "none", sm: "block" } }}>
                                                    <Typography sx={{ fontSize: 11, color: WHITE, fontWeight: 600 }}>{totalSubGroups} sub-groups · {totalClients} clients</Typography>
                                                </Box>
                                            </Box>
                                            {/* Total is not shown in the Groupwise Summary header (it stays in the Grand Total row below) */}
                                            {/* <BalBadge value={grandTotal} /> */}
                                        </Box>

                                        <Table size="small" sx={{ tableLayout: "fixed" }}>
                                            <TableHead>
                                                <TableRow sx={{ background: FB_LIGHT }}>
                                                    <TableCell sx={{ width: 40, fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2, display: { xs: "none", sm: "table-cell" } }}>#</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2 }}>Sub Group</TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pr: 2 }}>Balance (₹)</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {groups.map((group) => (
                                                    <>
                                                        {/* Group header row */}
                                                        <TableRow key={`grp-${group.groupName}`} sx={{ background: G200 }}>
                                                            <TableCell sx={{ display: { xs: "none", sm: "table-cell" }, borderBottom: `1px solid ${G300}`, py: "7px", pl: 2 }} />
                                                            <TableCell sx={{ borderBottom: `1px solid ${G300}`, py: "7px", pl: 2 }}>
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                    <Box sx={{ width: 3, height: 16, background: G700, borderRadius: 1, flexShrink: 0 }} />
                                                                    <Typography sx={{ fontSize: 12, fontWeight: 700, color: G900, textTransform: "uppercase", letterSpacing: ".3px" }}>{group.groupName}</Typography>
                                                                    <Box sx={{ display: { xs: "none", sm: "flex" }, px: "6px", py: "1px", background: G300, borderRadius: "4px" }}>
                                                                        <Typography sx={{ fontSize: 10, fontWeight: 700, color: G700 }}>{group.subGroups.length} sub-group{group.subGroups.length !== 1 ? "s" : ""}</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ borderBottom: `1px solid ${G300}`, py: "7px", pr: 2 }}>
                                                                <BalBadge value={group.totalBalance} size="sm" />
                                                            </TableCell>
                                                        </TableRow>

                                                        {/* Sub-group rows */}
                                                        {group.subGroups.map((sg, sgIdx) => {
                                                            srNo++;
                                                            return (
                                                                <TableRow key={sg.subGrpName}
                                                                    onClick={() => {
                                                                        setSelectedSubGroup({ groupName: group.groupName, ...sg });
                                                                        setGroupwisePage("clients");
                                                                    }}
                                                                    sx={{
                                                                        cursor: "pointer", background: sgIdx % 2 === 0 ? WHITE : "#FAFBFD",
                                                                        "& td": { borderBottom: `1px solid ${G200}` },
                                                                        "& td:first-of-type": { borderLeft: `3px solid transparent` },
                                                                        "&:hover td": { background: "#EEF4FF" },
                                                                        "&:hover td:first-of-type": { borderLeft: `3px solid ${FB}` },
                                                                    }}
                                                                >
                                                                    <TableCell sx={{ display: { xs: "none", sm: "table-cell" }, py: 1.25, pl: 2, color: G500, fontSize: 12 }}>{srNo}</TableCell>
                                                                    <TableCell sx={{ py: 1.25, pl: 2 }}>
                                                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: FB }}>{sg.subGrpName}</Typography>
                                                                    </TableCell>
                                                                    <TableCell align="right" sx={{ py: 1.25, pr: 2 }}>
                                                                        <BalBadge value={sg.totalBalance} size="sm" />
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </>
                                                ))}

                                                {/* Grand Total row */}
                                                <TableRow sx={{ background: FB_LIGHT, "& td": { borderTop: `2px solid ${G300}`, borderBottom: "none", py: 1.5 } }}>
                                                    <TableCell sx={{ display: { xs: "none", sm: "table-cell" }, pl: 2 }} />
                                                    <TableCell sx={{ pl: 2 }}>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                            <Box sx={{ width: 3, height: 18, background: FB, borderRadius: 1, flexShrink: 0 }} />
                                                            <Typography sx={{ fontSize: 12, fontWeight: 700, color: G900 }}>Grand Total</Typography>
                                                            <Typography sx={{ fontSize: 11, color: G500, display: { xs: "none", sm: "block" } }}>· {groups.length} group{groups.length !== 1 ? "s" : ""} · {totalSubGroups} sub-groups</Typography>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ pr: 2 }}>
                                                        <BalBadge value={grandTotal} />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </Box>
                                );
                            }

                            // ── PAGE: CLIENTS (after clicking a SubGrpName) ──────────
                            if (groupwisePage === "clients" && selectedSubGroup) {
                                return (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>

                                        {/* Breadcrumb / Back header */}
                                        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                                <Button onClick={() => { setGroupwisePage("groups"); setSelectedSubGroup(null); }}
                                                    startIcon={<ArrowBackIcon sx={{ fontSize: 15 }} />}
                                                    sx={{ ...btnGhostSx, height: 32, px: 1.5, fontSize: 12 }}>
                                                    Back
                                                </Button>
                                                <Box sx={{ width: 1, height: 20, background: G300, mx: 0.5 }} />
                                                <Typography sx={{ fontSize: 12, color: G500 }}>Groupwise Summary</Typography>
                                                <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
                                                <Typography sx={{ fontSize: 12, color: G700 }}>{selectedSubGroup.groupName}</Typography>
                                                <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
                                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: FB }}>{selectedSubGroup.subGrpName}</Typography>
                                            </Box>
                                            <BalBadge value={selectedSubGroup.totalBalance} />
                                        </Box>

                                        {/* Sub-group summary cards */}
                                        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3, 1fr)" }, gap: 1.5 }}>
                                            {[
                                                { label: "Group", text: selectedSubGroup.groupName },
                                                { label: "Clients", num: selectedSubGroup.clients.length },
                                                { label: "Total Balance", badge: selectedSubGroup.totalBalance },
                                            ].map(({ label, text, num, badge }) => (
                                                <Box key={label} sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.5, display: "flex", flexDirection: "column", gap: "4px" }}>
                                                    <Typography sx={{ fontSize: 11, color: G500, fontWeight: 500, textTransform: "uppercase", letterSpacing: ".4px" }}>{label}</Typography>
                                                    {badge !== undefined
                                                        ? <BalBadge value={badge} />
                                                        : <Typography sx={{ fontSize: text ? 13 : 20, fontWeight: 700, color: G900, lineHeight: 1 }}>{text ?? num}</Typography>
                                                    }
                                                </Box>
                                            ))}
                                        </Box>

                                        {/* Client list */}
                                        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: "8px", background: `linear-gradient(90deg, ${FB_LIGHT} 0%, #F0F7FF 100%)`, borderBottom: `1px solid ${G300}` }}>
                                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: G700, letterSpacing: ".5px", textTransform: "uppercase" }}>Client Name</Typography>
                                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: G700, letterSpacing: ".5px", textTransform: "uppercase" }}>Balance (₹)</Typography>
                                            </Box>

                                            {selectedSubGroup.clients.length === 0 ? (
                                                <Box sx={{ py: "2rem", textAlign: "center" }}>
                                                    <Typography sx={{ fontSize: 13, color: G500 }}>No clients in this sub-group.</Typography>
                                                </Box>
                                            ) : selectedSubGroup.clients.map((client, cIdx) => (
                                                <Box key={client.clientId}
                                                    onClick={() => {
                                                        setSelectedClientForMonthly(client);
                                                        setGroupwisePage("monthly");
                                                        if (!expandedClients[client.clientId]) {
                                                            fetchClientMonthlyClosing(client.clientId);
                                                        }
                                                    }}
                                                    sx={{
                                                        display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: "11px", cursor: "pointer", background: cIdx % 2 === 0 ? WHITE : "#FAFAFA", borderBottom: cIdx < selectedSubGroup.clients.length - 1 ? `1px solid ${G200}` : "none", borderLeft: "3px solid transparent", transition: "all .15s",
                                                        "&:hover": { background: "#EEF4FF", borderLeft: `3px solid #5C9BD4` },
                                                    }}
                                                >
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                                                        <Box sx={{ width: 20, height: 20, borderRadius: "5px", background: G200, border: `1px solid ${G300}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                            <Typography sx={{ fontSize: 12, color: G700, fontWeight: 700, lineHeight: 1 }}>›</Typography>
                                                        </Box>
                                                        <Typography sx={{ fontSize: 13, fontWeight: 500, color: G700 }}>{client.clientName}</Typography>
                                                    </Box>
                                                    <BalBadge value={Number(client.balance || 0)} size="sm" />
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                );
                            }

                            // ── PAGE: MONTHLY CLOSING (after clicking a client) ───────
                            if (groupwisePage === "monthly" && selectedClientForMonthly) {
                                const cState = expandedClients[selectedClientForMonthly.clientId];
                                const cLoading = cState?.loading;
                                const months = cState?.months || [];

                                const getMonthDateRange = (monthStr) => {
                                    const [year, month] = monthStr.split("-").map(Number);
                                    const fromDate = `${year}-${String(month).padStart(2, "0")}-01`;
                                    const lastDay = new Date(year, month, 0).getDate();
                                    const toDate = `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
                                    return { fromDate, toDate };
                                };

                                return (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                                        {/* Breadcrumb / Back header */}
                                        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                                <Button onClick={() => { setGroupwisePage("clients"); setSelectedClientForMonthly(null); }}
                                                    startIcon={<ArrowBackIcon sx={{ fontSize: 15 }} />}
                                                    sx={{ ...btnGhostSx, height: 32, px: 1.5, fontSize: 12 }}>
                                                    Back
                                                </Button>
                                                <Box sx={{ width: 1, height: 20, background: G300, mx: 0.5 }} />
                                                <Typography sx={{ fontSize: 12, color: G500 }}>Groupwise Summary</Typography>
                                                <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
                                                <Typography sx={{ fontSize: 12, color: G700 }}>{selectedSubGroup?.subGrpName}</Typography>
                                                <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
                                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: FB }}>{selectedClientForMonthly.clientName}</Typography>
                                            </Box>
                                            <BalBadge value={Number(selectedClientForMonthly.balance || 0)} />
                                        </Box>

                                        {/* Monthly data table */}
                                        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
                                            {cLoading ? (
                                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2 }}>
                                                    <CircularProgress sx={{ color: FB }} />
                                                    <Typography sx={{ color: G500, fontSize: 13 }}>Loading monthly data…</Typography>
                                                </Box>
                                            ) : months.length > 0 ? (
                                                <Table size="small" sx={{ tableLayout: "fixed" }}>
                                                    <TableHead>
                                                        <TableRow sx={{ background: FB_LIGHT }}>
                                                            <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2 }}>Month</TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25 }}>Debit (₹)</TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25 }}>Credit (₹)</TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", letterSpacing: ".5px", borderBottom: `2px solid ${G300}`, py: 1.25, pr: 2 }}>Closing (₹)</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {months.map((m, mIdx) => (
                                                            <TableRow key={m.Month}
                                                                onClick={() => {
                                                                    const { fromDate, toDate } = getMonthDateRange(m.Month);
                                                                    setSelectedMonthForLedger({ ...m, fromDate, toDate });
                                                                    setGroupwisePage("ledger");
                                                                    fetchMonthLedger(selectedClientForMonthly.clientId, fromDate, toDate);
                                                                }}
                                                                sx={{
                                                                    cursor: "pointer", background: mIdx % 2 === 0 ? WHITE : "#FAFBFD", transition: "all .15s",
                                                                    "&:hover": { background: "#EEF4FF" },
                                                                    "& td": { borderBottom: `1px solid ${G200}`, py: 1.25 },
                                                                }}
                                                            >
                                                                <TableCell sx={{ pl: 2 }}>
                                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                        <CalendarTodayOutlinedIcon sx={{ fontSize: 13, color: G500 }} />
                                                                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: G900 }}>{m.MonthName} {m.Month?.split("-")[0]}</Typography>
                                                                    </Box>
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <Typography sx={{ fontSize: 12, color: "#C62828", fontVariantNumeric: "tabular-nums", fontWeight: 500 }}>{fmt(Number(m.TotalDebit || 0))}</Typography>
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    <Typography sx={{ fontSize: 12, color: FB, fontVariantNumeric: "tabular-nums", fontWeight: 500 }}>{fmt(Number(m.TotalCredit || 0))}</Typography>
                                                                </TableCell>
                                                                <TableCell align="right" sx={{ pr: 2 }}>
                                                                    <BalBadge value={Number(m.ClosingBalance || 0)} size="sm" />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        {/* Totals footer row */}
                                                        <TableRow sx={{ background: FB_LIGHT, "& td": { borderTop: `2px solid ${G300}`, borderBottom: "none", py: 1.5 } }}>
                                                            <TableCell sx={{ pl: 2 }}>
                                                                <Typography sx={{ fontSize: 12, fontWeight: 700, color: FB }}>Total ({months.length} month{months.length !== 1 ? "s" : ""})</Typography>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <Typography sx={{ fontSize: 12, fontWeight: 700, color: "#C62828", fontVariantNumeric: "tabular-nums" }}>{fmt(months.reduce((s, m) => s + Number(m.TotalDebit || 0), 0))}</Typography>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <Typography sx={{ fontSize: 12, fontWeight: 700, color: FB, fontVariantNumeric: "tabular-nums" }}>{fmt(months.reduce((s, m) => s + Number(m.TotalCredit || 0), 0))}</Typography>
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ pr: 2 }}>
                                                                <BalBadge value={Number(selectedClientForMonthly.balance || 0)} />
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            ) : (
                                                <Box sx={{ py: "2.5rem", textAlign: "center" }}>
                                                    <Typography sx={{ fontSize: 13, color: G500 }}>No monthly closing data available.</Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                );
                            }

                            // ── PAGE: MONTH LEDGER (after clicking a month row) ───────
                            if (groupwisePage === "ledger" && selectedMonthForLedger && selectedClientForMonthly) {
                                const opValue = Number(monthLedgerData?.openingBalance?.absValue || 0);
                                const opType = monthLedgerData?.openingBalance?.type || "Dr";
                                const displayRows = (() => {
                                    if (!monthLedgerData?.details) return [];
                                    const openingRow = {
                                        id: "opening-balance",
                                        docDate: fmtDate(selectedMonthForLedger.fromDate) || "—",
                                        salePurchaseAC: "—",
                                        docNo: "—",
                                        bookName: "OPBAL",
                                        debit: opType === "Dr" ? opValue : 0,
                                        credit: opType === "Cr" ? opValue : 0,
                                        remark: "",
                                        balance: opValue,
                                        balanceType: opType,
                                        isOpeningRow: true,
                                    };
                                    return [openingRow, ...monthLedgerData.details];
                                })();

                                return (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>

                                        {/* Breadcrumb / Back header */}
                                        <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                                <Button onClick={() => { setGroupwisePage("monthly"); setSelectedMonthForLedger(null); setMonthLedgerData(null); }}
                                                    startIcon={<ArrowBackIcon sx={{ fontSize: 15 }} />}
                                                    sx={{ ...btnGhostSx, height: 32, px: 1.5, fontSize: 12 }}>
                                                    Back
                                                </Button>
                                                <Box sx={{ width: 1, height: 20, background: G300, mx: 0.5 }} />
                                                <Typography sx={{ fontSize: 12, color: G500 }}>{selectedClientForMonthly.clientName}</Typography>
                                                <Typography sx={{ fontSize: 12, color: G300 }}>›</Typography>
                                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: FB }}>{selectedMonthForLedger.MonthName} {selectedMonthForLedger.Month?.split("-")[0]}</Typography>
                                            </Box>
                                            <Typography sx={{ fontSize: 11, color: G500 }}>{fmtDate(selectedMonthForLedger.fromDate)} – {fmtDate(selectedMonthForLedger.toDate)}</Typography>
                                        </Box>

                                        {monthLedgerLoading ? (
                                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2, background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px" }}>
                                                <CircularProgress sx={{ color: FB }} />
                                                <Typography sx={{ color: G500, fontSize: 13 }}>Loading ledger entries…</Typography>
                                            </Box>
                                        ) : monthLedgerData ? (
                                            <>
                                                {/* KPI Strip */}
                                                {monthLedgerData.details && monthLedgerData.details.length > 0 && (
                                                    <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
                                                        <Box sx={{ display: "flex", px: { xs: 2, sm: 3 }, py: 1.5, overflowX: "auto" }}>
                                                            {[
                                                                { label: "ENTRIES", value: String(monthLedgerData.summary?.totalTransactions || monthLedgerData.details.length) },
                                                                { label: "TOTAL DEBIT", value: `₹ ${fmt(Number(monthLedgerData.summary?.totalDebit || 0) + (opType === "Dr" ? opValue : 0))}` },
                                                                { label: "TOTAL CREDIT", value: `₹ ${fmt(Number(monthLedgerData.summary?.totalCredit || 0) + (opType === "Cr" ? opValue : 0))}` },
                                                                { label: "CLOSING BALANCE", value: `${fmt(Number(monthLedgerData.closingBalance?.absValue || 0))} ${monthLedgerData.closingBalance?.type || "Dr"}`, accent: true },
                                                            ].map((item, i, arr) => (
                                                                <Box key={i} sx={{ pr: { xs: 2.5, sm: 3.5 }, pl: i === 0 ? 0 : { xs: 2.5, sm: 3.5 }, borderRight: i < arr.length - 1 ? `1px solid ${G300}` : "none", flexShrink: 0 }}>
                                                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: G500, textTransform: "uppercase", letterSpacing: ".6px", lineHeight: 1, mb: "4px" }}>{item.label}</Typography>
                                                                    <Typography sx={{ fontSize: 16, fontWeight: 700, color: item.accent ? FB : G900, fontFamily: "monospace", lineHeight: 1 }}>{item.value}</Typography>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Box>
                                                )}

                                                {/* DataGrid — same columns as General Ledger */}
                                                <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
                                                    {displayRows.length > 0 ? (
                                                        <DataGrid
                                                            rows={displayRows}
                                                            columns={columns}
                                                            autoHeight
                                                            rowHeight={44}
                                                            getRowId={(row) => row.id}
                                                            disableRowSelectionOnClick
                                                            pageSizeOptions={[25, 50, 100]}
                                                            initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
                                                            slots={{ noResultsOverlay: CustomNoDataOverlay }}
                                                            sx={dgSx}
                                                        />
                                                    ) : (
                                                        <Box sx={{ py: "2.5rem" }}>
                                                            <NoDataComponent />
                                                        </Box>
                                                    )}
                                                </Box>
                                            </>
                                        ) : (
                                            <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                                <Typography sx={{ fontSize: 14, color: G500 }}>No ledger data available.</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                );
                            }

                            return null;
                        })() : (
                            <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {/* ── Sale VS Purchase Report ── */}
                {appliedReportType === "sale_vs_purchase" && (
                    <Box>
                        {salesVsPurchaseLoading ? (
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2, background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px" }}>
                                <CircularProgress sx={{ color: FB }} />
                                <Typography sx={{ color: G500, fontSize: 13 }}>Loading Sale VS Purchase data…</Typography>
                            </Box>
                        ) : salesVsPurchaseData ? (() => {
                            // Backend returns a flat accounts array — split by accountName/subGroupName
                            const allAccounts = salesVsPurchaseData.accounts || [];
                            const salesAccounts = allAccounts.filter(acc =>
                                (acc.subGroupName || acc.accountName || "").toUpperCase().includes("SALES")
                            );
                            const purchaseAccounts = allAccounts.filter(acc =>
                                (acc.subGroupName || acc.accountName || "").toUpperCase().includes("PURCHASE")
                            );

                            // Compute summaries from filtered account data
                            const salesSummary = {
                                totalAccounts: salesAccounts.length,
                                totalAmt: salesAccounts.reduce((s, a) => s + (a.totalAmt || 0), 0),
                                totalSaleInvoices: salesAccounts.reduce((s, a) => s + (a.saleCount || 0), 0),
                                totalPurchaseInvoices: salesAccounts.reduce((s, a) => s + (a.purchaseCount || 0), 0),
                            };
                            const purchaseSummary = {
                                totalAccounts: purchaseAccounts.length,
                                totalAmt: purchaseAccounts.reduce((s, a) => s + Math.abs(a.totalAmt || 0), 0),
                                totalPurchaseInvoices: purchaseAccounts.reduce((s, a) => s + (a.purchaseCount || 0), 0),
                                totalSaleInvoices: purchaseAccounts.reduce((s, a) => s + (a.saleCount || 0), 0),
                            };

                            // Build combined Sale VS Purchase chart data (one entry per month)
                            const _combined = {}; const _combinedOrder = [];
                            salesAccounts.forEach(acc => { (acc.months || []).forEach(m => { if (!_combined[m.monthKey]) { _combined[m.monthKey] = { month: m.monthLabel, "Sale": 0, "Purchase": 0 }; _combinedOrder.push(m.monthKey); } _combined[m.monthKey]["Sale"] += m.saleAmt || 0; }); });
                            purchaseAccounts.forEach(acc => { (acc.months || []).forEach(m => { if (!_combined[m.monthKey]) { _combined[m.monthKey] = { month: m.monthLabel, "Sale": 0, "Purchase": 0 }; _combinedOrder.push(m.monthKey); } _combined[m.monthKey]["Purchase"] += Math.abs(m.netAmt || 0); }); });
                            const combinedChartData = _combinedOrder.map(k => _combined[k]);

                            return (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

                                    {/* ── Monthly Sale VS Purchase ── */}
                                    {(salesAccounts.length > 0 || purchaseAccounts.length > 0) ? (
                                        <>
                                            <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
                                                <Box sx={{ display: "flex", alignItems: "center", px: { xs: 2, sm: 3 }, py: 1.5, gap: 2, justifyContent: "space-between" }}>
                                                    <Box sx={{ display: "flex", overflowX: "auto", gap: 0 }}>
                                                        {[
                                                            { label: "TOTAL SALE", value: `₹ ${fmt(salesSummary.totalAmt || 0)}`, accent: true },
                                                            { label: "TOTAL PURCHASE", value: `₹ ${fmt(purchaseSummary.totalAmt || 0)}`, accent: true },
                                                            { label: "SALE INVOICES", value: String(salesSummary.totalSaleInvoices || 0) },
                                                            { label: "PURC INVOICES", value: String(purchaseSummary.totalPurchaseInvoices || 0) },
                                                        ].map((kpi, i, arr) => (
                                                            <Box key={i} sx={{ pr: { xs: 2.5, sm: 3.5 }, pl: i === 0 ? 0 : { xs: 2.5, sm: 3.5 }, borderRight: i < arr.length - 1 ? `1px solid ${G300}` : "none", flexShrink: 0 }}>
                                                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: G500, textTransform: "uppercase", letterSpacing: ".6px", lineHeight: 1, mb: "4px" }}>{kpi.label}</Typography>
                                                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: kpi.accent ? FB : G900, fontFamily: "monospace", lineHeight: 1 }}>{kpi.value}</Typography>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                    <Button onClick={() => setShowSalesVsGraph(prev => { if (!prev) setSaleGraphAnimKey(k => k + 1); return !prev; })} startIcon={showSalesVsGraph ? <TableRowsOutlinedIcon sx={{ fontSize: 16 }} /> : <BarChartOutlinedIcon sx={{ fontSize: 16 }} />} sx={{ ...btnOutlineSx, flexShrink: 0, fontSize: 12, height: 34, px: 2 }}>{showSalesVsGraph ? "Table" : "Graph"}</Button>
                                                </Box>
                                            </Box>
                                            <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden" }}>
                                                <Box sx={{ px: 2.5, py: 1.5, background: `linear-gradient(90deg, ${FB} 0%, #1a5fce 100%)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                                                    <Box><Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE }}>Monthly Sale VS Purchase</Typography><Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.8)", mt: "2px" }}>From: {fmtDate(appliedFilters?.fromDate)} &nbsp;To: {fmtDate(appliedFilters?.toDate)}</Typography></Box>
                                                </Box>
                                                {showSalesVsGraph ? (
                                                    <Box sx={{ p: 2 }}>
                                                        <ResponsiveContainer width="100%" height={400}>
                                                            <BarChart key={saleGraphAnimKey} data={combinedChartData} margin={{ top: 30, right: 45, left: 20, bottom: 20 }}>
                                                                <CartesianGrid strokeDasharray="3 3" stroke={G300} vertical={false} />
                                                                <XAxis dataKey="month" tick={{ fontSize: 11, fill: G700 }} axisLine={{ stroke: G300 }} tickLine={false} />
                                                                <YAxis tickFormatter={v => v >= 1e6 ? `${(v / 1e6).toFixed(1)}M` : v >= 1e3 ? `${(v / 1e3).toFixed(0)}K` : String(v)} tick={{ fontSize: 10, fill: G500 }} axisLine={false} tickLine={false} />
                                                                <RechartsTooltip formatter={(value, name) => [`₹ ${fmt(value)}`, name]} contentStyle={{ borderRadius: 8, border: `1px solid ${G300}`, fontSize: 12 }} />
                                                                <Legend wrapperStyle={{ fontSize: 12, paddingTop: 12 }} />
                                                                <Bar dataKey="Sale" fill={FB} maxBarSize={55} shape={AnimatedBlockBar} isAnimationActive={false} />
                                                                <Bar dataKey="Purchase" fill="#a5b4fc" maxBarSize={55} shape={AnimatedBlockBar} isAnimationActive={false} />
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    </Box>
                                                ) : (
                                                    <Table size="small" sx={{ tableLayout: "fixed", borderCollapse: "collapse" }}>
                                                        <TableHead><TableRow>
                                                            <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2, background: FB_LIGHT, width: "33%" }}>Month</TableCell>
                                                            <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", borderBottom: `2px solid ${G300}`, py: 1.25, background: FB_LIGHT, textAlign: "right", width: "33%" }}>Sale Amt</TableCell>
                                                            <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", borderBottom: `2px solid ${G300}`, py: 1.25, background: FB_LIGHT, textAlign: "right", width: "34%" }}>Purchase Amt</TableCell>
                                                        </TableRow></TableHead>
                                                        <TableBody>
                                                            {combinedChartData.map((row, idx) => (
                                                                <TableRow key={row.month} sx={{ background: idx % 2 === 0 ? WHITE : "#FAFBFD", "&:hover td": { background: "#EEF2FF" } }}>
                                                                    <TableCell sx={{ py: 1, px: 1.5, pl: 2, borderBottom: `1px solid ${G200}` }}><Typography sx={{ fontSize: 12, color: G700 }}>{row.month}</Typography></TableCell>
                                                                    <TableCell sx={{ py: 1, px: 1.5, borderBottom: `1px solid ${G200}`, textAlign: "right" }}><Typography sx={{ fontSize: 12, color: G700, fontFamily: "monospace" }}>{fmt(row["Sale"])}</Typography></TableCell>
                                                                    <TableCell sx={{ py: 1, px: 1.5, borderBottom: `1px solid ${G200}`, textAlign: "right" }}><Typography sx={{ fontSize: 12, color: G700, fontFamily: "monospace" }}>{fmt(row["Purchase"])}</Typography></TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow sx={{ background: `linear-gradient(90deg, ${FB}18 0%, #1a5fce18 100%)` }}>
                                                                <TableCell sx={{ py: 1.25, px: 1.5, pl: 2, borderTop: `2px solid ${FB}`, borderBottom: "none" }}><Typography sx={{ fontSize: 12, fontWeight: 700, color: G900 }}>Grand Total</Typography></TableCell>
                                                                <TableCell sx={{ py: 1.25, px: 1.5, borderTop: `2px solid ${FB}`, borderBottom: "none", textAlign: "right" }}><Typography sx={{ fontSize: 12, fontWeight: 700, color: G900, fontFamily: "monospace" }}>{fmt(salesSummary.totalAmt || 0)}</Typography></TableCell>
                                                                <TableCell sx={{ py: 1.25, px: 1.5, borderTop: `2px solid ${FB}`, borderBottom: "none", textAlign: "right" }}><Typography sx={{ fontSize: 12, fontWeight: 700, color: G900, fontFamily: "monospace" }}>{fmt(purchaseSummary.totalAmt || 0)}</Typography></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                )}
                                            </Box>
                                        </>
                                    ) : (
                                        <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                            <Typography sx={{ fontSize: 14, color: G500 }}>No records found.</Typography>
                                        </Box>
                                    )}
                                </Box>
                            );
                        })() : (
                            <Box sx={{ ...cardSx, textAlign: "center", py: "3rem" }}>
                                <ReceiptLongOutlinedIcon sx={{ fontSize: 36, color: G300, mb: 1 }} />
                                <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {/* ── Inc. VS Exp. Report ── */}
                {appliedReportType === "inc_vs_exp" && (
                    <Box>
                        {incVsExpLoading ? (
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: "3rem", gap: 2, background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px" }}>
                                <CircularProgress sx={{ color: FB }} />
                                <Typography sx={{ color: G500, fontSize: 13 }}>Loading Inc. VS Exp. data…</Typography>
                            </Box>
                        ) : incVsExpData ? (() => {
                            const allAccounts = incVsExpData.accounts || [];

                            // Aggregate combined chart data (one entry per month)
                            const _combined = {}; const _combinedOrder = [];
                            allAccounts.forEach(acc => {
                                (acc.months || []).forEach(m => {
                                    if (!_combined[m.monthKey]) {
                                        _combined[m.monthKey] = { month: m.monthLabel, "Income": 0, "Expense": 0 };
                                        _combinedOrder.push(m.monthKey);
                                    }
                                    _combined[m.monthKey]["Income"] += m.incomeAmt || 0;
                                    _combined[m.monthKey]["Expense"] += m.expenseAmt || 0;
                                });
                            });
                            const combinedChartData = _combinedOrder.map(k => _combined[k]);

                            const totalIncome = allAccounts.reduce((s, a) => s + (a.incomeCount !== undefined ? (a.months || []).reduce((ms, m) => ms + (m.incomeAmt || 0), 0) : 0), 0);
                            const totalExpense = allAccounts.reduce((s, a) => s + (a.expenseCount !== undefined ? (a.months || []).reduce((ms, m) => ms + (m.expenseAmt || 0), 0) : 0), 0);
                            const summary = incVsExpData.summary || {};

                            return (
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    {(combinedChartData.length > 0) ? (
                                        <>
                                            <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "8px", overflow: "hidden" }}>
                                                <Box sx={{ display: "flex", alignItems: "center", px: { xs: 2, sm: 3 }, py: 1.5, gap: 2, justifyContent: "space-between" }}>
                                                    <Box sx={{ display: "flex", overflowX: "auto", gap: 0 }}>
                                                        {[
                                                            { label: "TOTAL INCOME", value: `₹ ${fmt(combinedChartData.reduce((s, r) => s + (r["Income"] || 0), 0))}`, accent: true },
                                                            { label: "TOTAL EXPENSE", value: `₹ ${fmt(combinedChartData.reduce((s, r) => s + (r["Expense"] || 0), 0))}`, accent: true },
                                                            { label: "INCOME ENTRIES", value: String(summary.totalIncomeInvoices || 0) },
                                                            { label: "EXPENSE ENTRIES", value: String(summary.totalExpenseInvoices || 0) },
                                                        ].map((kpi, i, arr) => (
                                                            <Box key={i} sx={{ pr: { xs: 2.5, sm: 3.5 }, pl: i === 0 ? 0 : { xs: 2.5, sm: 3.5 }, borderRight: i < arr.length - 1 ? `1px solid ${G300}` : "none", flexShrink: 0 }}>
                                                                <Typography sx={{ fontSize: 10, fontWeight: 700, color: G500, textTransform: "uppercase", letterSpacing: ".6px", lineHeight: 1, mb: "4px" }}>{kpi.label}</Typography>
                                                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: kpi.accent ? FB : G900, fontFamily: "monospace", lineHeight: 1 }}>{kpi.value}</Typography>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                    <Button onClick={() => setShowIncVsExpGraph(prev => { if (!prev) setIncVsExpGraphAnimKey(k => k + 1); return !prev; })} startIcon={showIncVsExpGraph ? <TableRowsOutlinedIcon sx={{ fontSize: 16 }} /> : <BarChartOutlinedIcon sx={{ fontSize: 16 }} />} sx={{ ...btnOutlineSx, flexShrink: 0, fontSize: 12, height: 34, px: 2 }}>{showIncVsExpGraph ? "Table" : "Graph"}</Button>
                                                </Box>
                                            </Box>
                                            <Box sx={{ background: WHITE, border: `1px solid ${G300}`, borderRadius: "12px", overflow: "hidden" }}>
                                                <Box sx={{ px: 2.5, py: 1.5, background: `linear-gradient(90deg, ${FB} 0%, #1a5fce 100%)`, display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
                                                    <Box><Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE }}>Monthly Inc. VS Exp.</Typography><Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.8)", mt: "2px" }}>From: {fmtDate(appliedFilters?.fromDate)} &nbsp;To: {fmtDate(appliedFilters?.toDate)}</Typography></Box>
                                                </Box>
                                                {showIncVsExpGraph ? (
                                                    <Box sx={{ p: 2 }}>
                                                        <ResponsiveContainer width="100%" height={400}>
                                                            <BarChart key={incVsExpGraphAnimKey} data={combinedChartData} margin={{ top: 30, right: 45, left: 20, bottom: 20 }}>
                                                                <CartesianGrid strokeDasharray="3 3" stroke={G300} vertical={false} />
                                                                <XAxis dataKey="month" tick={{ fontSize: 11, fill: G700 }} axisLine={{ stroke: G300 }} tickLine={false} />
                                                                <YAxis tickFormatter={v => v >= 1e6 ? `${(v / 1e6).toFixed(1)}M` : v >= 1e3 ? `${(v / 1e3).toFixed(0)}K` : String(v)} tick={{ fontSize: 10, fill: G500 }} axisLine={false} tickLine={false} />
                                                                <RechartsTooltip formatter={(value, name) => [`₹ ${fmt(value)}`, name]} contentStyle={{ borderRadius: 8, border: `1px solid ${G300}`, fontSize: 12 }} />
                                                                <Legend wrapperStyle={{ fontSize: 12, paddingTop: 12 }} />
                                                                <Bar dataKey="Income" fill={FB} maxBarSize={55} shape={AnimatedBlockBar} isAnimationActive={false} />
                                                                <Bar dataKey="Expense" fill="#a5b4fc" maxBarSize={55} shape={AnimatedBlockBar} isAnimationActive={false} />
                                                            </BarChart>
                                                        </ResponsiveContainer>
                                                    </Box>
                                                ) : (
                                                    <Table size="small" sx={{ tableLayout: "fixed", borderCollapse: "collapse" }}>
                                                        <TableHead><TableRow>
                                                            <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", borderBottom: `2px solid ${G300}`, py: 1.25, pl: 2, background: FB_LIGHT, width: "33%" }}>Month</TableCell>
                                                            <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", borderBottom: `2px solid ${G300}`, py: 1.25, background: FB_LIGHT, textAlign: "right", width: "33%" }}>Income Amt</TableCell>
                                                            <TableCell sx={{ fontWeight: 700, fontSize: 11, color: G700, textTransform: "uppercase", borderBottom: `2px solid ${G300}`, py: 1.25, background: FB_LIGHT, textAlign: "right", width: "34%" }}>Expense Amt</TableCell>
                                                        </TableRow></TableHead>
                                                        <TableBody>
                                                            {combinedChartData.map((row, idx) => (
                                                                <TableRow key={row.month} sx={{ background: idx % 2 === 0 ? WHITE : "#FAFBFD", "&:hover td": { background: "#EEF2FF" } }}>
                                                                    <TableCell sx={{ py: 1, px: 1.5, pl: 2, borderBottom: `1px solid ${G200}` }}><Typography sx={{ fontSize: 12, color: G700 }}>{row.month}</Typography></TableCell>
                                                                    <TableCell sx={{ py: 1, px: 1.5, borderBottom: `1px solid ${G200}`, textAlign: "right" }}><Typography sx={{ fontSize: 12, color: G700, fontFamily: "monospace" }}>{fmt(row["Income"])}</Typography></TableCell>
                                                                    <TableCell sx={{ py: 1, px: 1.5, borderBottom: `1px solid ${G200}`, textAlign: "right" }}><Typography sx={{ fontSize: 12, color: G700, fontFamily: "monospace" }}>{fmt(row["Expense"])}</Typography></TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow sx={{ background: `linear-gradient(90deg, ${FB}18 0%, #1a5fce18 100%)` }}>
                                                                <TableCell sx={{ py: 1.25, px: 1.5, pl: 2, borderTop: `2px solid ${FB}`, borderBottom: "none" }}><Typography sx={{ fontSize: 12, fontWeight: 700, color: G900 }}>Grand Total</Typography></TableCell>
                                                                <TableCell sx={{ py: 1.25, px: 1.5, borderTop: `2px solid ${FB}`, borderBottom: "none", textAlign: "right" }}><Typography sx={{ fontSize: 12, fontWeight: 700, color: G900, fontFamily: "monospace" }}>{fmt(combinedChartData.reduce((s, r) => s + (r["Income"] || 0), 0))}</Typography></TableCell>
                                                                <TableCell sx={{ py: 1.25, px: 1.5, borderTop: `2px solid ${FB}`, borderBottom: "none", textAlign: "right" }}><Typography sx={{ fontSize: 12, fontWeight: 700, color: G900, fontFamily: "monospace" }}>{fmt(combinedChartData.reduce((s, r) => s + (r["Expense"] || 0), 0))}</Typography></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                )}
                                            </Box>
                                        </>
                                    ) : (
                                        <Box sx={{ ...cardSx, textAlign: "center", py: "2.5rem" }}>
                                            <Typography sx={{ fontSize: 14, color: G500 }}>No records found.</Typography>
                                        </Box>
                                    )}
                                </Box>
                            );
                        })() : (
                            <Box sx={{ ...cardSx, textAlign: "center", py: "3rem" }}>
                                <ReceiptLongOutlinedIcon sx={{ fontSize: 36, color: G300, mb: 1 }} />
                                <Typography sx={{ fontSize: 14, color: G500 }}>No data available.</Typography>
                            </Box>
                        )}
                    </Box>
                )}

            </Box>{/* end content area */}

            {/* ── Smart Filter Dialog ──────────────────────────────────────────── */}
            <SmartFilterDialog
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                allClients={allClients}
                itemGroupsLoading={false}
                tempFromDate={tempFromDate}
                setTempFromDate={setTempFromDate}
                tempToDate={tempToDate}
                setTempToDate={setTempToDate}
                tempClientSearchText={tempClientSearchText}
                setTempClientSearchText={handleTempClientSearch}
                tempSelectedClients={tempSelectedClients}
                setTempSelectedClients={setTempSelectedClients}
                filteredTempClients={filteredTempClients}
                handleTempSelectAll={() => setTempSelectedClients(filteredTempClients)}
                handleTempDeselectAll={() => setTempSelectedClients([])}
                handleTempClientCheckbox={handleTempClientCheckbox}
                loading={loading}
                onGetData={handleViewSelectedLedgers}
                tempReportType={tempReportType}
                setTempReportType={setTempReportType}
                selectedBookNames={selectedBookNames}
                setSelectedBookNames={setSelectedBookNames}
                selectedBankAccount={selectedBankAccount}
                setSelectedBankAccount={setSelectedBankAccount}
                bankAccounts={bankAccounts}
                bankAccountsLoading={bankAccountsLoading}
                isDaywise={isDaywise}
                setIsDaywise={setIsDaywise}
                allSalesAccountClients={allSalesAccountClients}
                salesClientsLoading={salesClientsLoading}
                tempSelectedSalesClients={tempSelectedSalesClients}
                setTempSelectedSalesClients={setTempSelectedSalesClients}
                salesClientSearchText={salesClientSearchText}
                setSalesClientSearchText={setSalesClientSearchText}
                allPurchaseAccountClients={allPurchaseAccountClients}
                purchaseClientsLoading={purchaseClientsLoading}
                tempSelectedPurchaseClients={tempSelectedPurchaseClients}
                setTempSelectedPurchaseClients={setTempSelectedPurchaseClients}
                purchaseClientSearchText={purchaseClientSearchText}
                setPurchaseClientSearchText={setPurchaseClientSearchText}
                allIncomeAccountClients={allIncomeAccountClients}
                incomeClientsLoading={incomeClientsLoading}
                tempSelectedIncomeClients={tempSelectedIncomeClients}
                setTempSelectedIncomeClients={setTempSelectedIncomeClients}
                incomeClientSearchText={incomeClientSearchText}
                setIncomeClientSearchText={setIncomeClientSearchText}
                allExpenseAccountClients={allExpenseAccountClients}
                expenseClientsLoading={expenseClientsLoading}
                tempSelectedExpenseClients={tempSelectedExpenseClients}
                setTempSelectedExpenseClients={setTempSelectedExpenseClients}
                expenseClientSearchText={expenseClientSearchText}
                setExpenseClientSearchText={setExpenseClientSearchText}
            />

            {/* ── Snackbar ─────────────────────────────────────────────────────── */}
            <Snackbar open={snackbar.open} autoHideDuration={3500} onClose={() => setSnackbar((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}
